import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Iterable: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Company = Node & {
  __typename?: 'Company';
  _id: Scalars['Int']['output'];
  contacts?: Maybe<CompanyContactCursorConnection>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invites?: Maybe<CompanyInviteCursorConnection>;
  logo?: Maybe<CompanyLogo>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reports?: Maybe<ReportCursorConnection>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  users?: Maybe<CompanyUserCursorConnection>;
};


export type CompanyContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<CompanyContactFilter_Order>>>;
};


export type CompanyInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<CompanyInviteFilter_Order>>>;
};


export type CompanyReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportFilter_Order>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyContact = Node & {
  __typename?: 'CompanyContact';
  _id: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for CompanyContact. */
export type CompanyContactCursorConnection = {
  __typename?: 'CompanyContactCursorConnection';
  edges?: Maybe<Array<Maybe<CompanyContactEdge>>>;
  pageInfo: CompanyContactPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of CompanyContact. */
export type CompanyContactEdge = {
  __typename?: 'CompanyContactEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyContact>;
};

export type CompanyContactFilter_Order = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type CompanyContactPageInfo = {
  __typename?: 'CompanyContactPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for Company. */
export type CompanyCursorConnection = {
  __typename?: 'CompanyCursorConnection';
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  pageInfo: CompanyPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of Company. */
export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Company>;
};

export type CompanyFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyInvite = Node & {
  __typename?: 'CompanyInvite';
  _id: Scalars['Int']['output'];
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['String']['output']>;
  acceptedByFullName?: Maybe<Scalars['String']['output']>;
  company: Company;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  role: CompanyRole;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for CompanyInvite. */
export type CompanyInviteCursorConnection = {
  __typename?: 'CompanyInviteCursorConnection';
  edges?: Maybe<Array<Maybe<CompanyInviteEdge>>>;
  pageInfo: CompanyInvitePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of CompanyInvite. */
export type CompanyInviteEdge = {
  __typename?: 'CompanyInviteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyInvite>;
};

export type CompanyInviteFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type CompanyInvitePageInfo = {
  __typename?: 'CompanyInvitePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type CompanyLogo = Node & {
  __typename?: 'CompanyLogo';
  _id: Scalars['Int']['output'];
  /** Populated when deserializing via MediaObjectNormalizer. */
  contentUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Information about the current page. */
export type CompanyPageInfo = {
  __typename?: 'CompanyPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum CompanyRole {
  Owner = 'Owner',
  Standard = 'Standard'
}

export type CompanyUser = Node & {
  __typename?: 'CompanyUser';
  _id: Scalars['Int']['output'];
  company: Company;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  role: CompanyRole;
  user: User;
};

/** Cursor connection for CompanyUser. */
export type CompanyUserCursorConnection = {
  __typename?: 'CompanyUserCursorConnection';
  edges?: Maybe<Array<Maybe<CompanyUserEdge>>>;
  pageInfo: CompanyUserPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of CompanyUser. */
export type CompanyUserEdge = {
  __typename?: 'CompanyUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompanyUser>;
};

/** Information about the current page. */
export type CompanyUserPageInfo = {
  __typename?: 'CompanyUserPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Contact = Node & {
  __typename?: 'Contact';
  _id: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for Contact. */
export type ContactCursorConnection = {
  __typename?: 'ContactCursorConnection';
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  pageInfo: ContactPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of Contact. */
export type ContactEdge = {
  __typename?: 'ContactEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Contact>;
};

export type ContactFilter_Order = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ContactPageInfo = {
  __typename?: 'ContactPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accepts a CompanyInvite. */
  acceptCompanyInvite?: Maybe<AcceptCompanyInvitePayload>;
  /** Accepts a ReportInvite. */
  acceptReportInvite?: Maybe<AcceptReportInvitePayload>;
  /** AddCompanyUserTos a Report. */
  addCompanyUserToReport?: Maybe<AddCompanyUserToReportPayload>;
  /** AddUserTos a Company. */
  addUserToCompany?: Maybe<AddUserToCompanyPayload>;
  /** AddUserTos a Report. */
  addUserToReport?: Maybe<AddUserToReportPayload>;
  /** Applys a UserMobileNumberChangeRequest. */
  applyUserMobileNumberChangeRequest?: Maybe<ApplyUserMobileNumberChangeRequestPayload>;
  /** Completes a ReportTestTypePrerequisite. */
  completeReportTestTypePrerequisite?: Maybe<CompleteReportTestTypePrerequisitePayload>;
  /** Creates a Company. */
  createCompany?: Maybe<CreateCompanyPayload>;
  /** Creates a CompanyContact. */
  createCompanyContact?: Maybe<CreateCompanyContactPayload>;
  /** Creates a CompanyInvite. */
  createCompanyInvite?: Maybe<CreateCompanyInvitePayload>;
  /** Creates a Contact. */
  createContact?: Maybe<CreateContactPayload>;
  /** Creates a Report. */
  createReport?: Maybe<CreateReportPayload>;
  /** Creates a ReportAccessInformationCredentials. */
  createReportAccessInformationCredentials?: Maybe<CreateReportAccessInformationCredentialsPayload>;
  /** Creates a ReportAccessInformationFile. */
  createReportAccessInformationFile?: Maybe<CreateReportAccessInformationFilePayload>;
  /** Creates a ReportDeliverableFile. */
  createReportDeliverableFile?: Maybe<CreateReportDeliverableFilePayload>;
  /** Creates a ReportInvite. */
  createReportInvite?: Maybe<CreateReportInvitePayload>;
  /** Creates a ReportReadReceipt. */
  createReportReadReceipt?: Maybe<CreateReportReadReceiptPayload>;
  /** Creates a ReportTestTypePrerequisite. */
  createReportTestTypePrerequisite?: Maybe<CreateReportTestTypePrerequisitePayload>;
  /** Creates a ReportVulnerability. */
  createReportVulnerability?: Maybe<CreateReportVulnerabilityPayload>;
  /** Creates a ReportVulnerabilityAction. */
  createReportVulnerabilityAction?: Maybe<CreateReportVulnerabilityActionPayload>;
  /** Creates a ReportVulnerabilityClientNotification. */
  createReportVulnerabilityClientNotification?: Maybe<CreateReportVulnerabilityClientNotificationPayload>;
  /** Creates a ReportVulnerabilityComment. */
  createReportVulnerabilityComment?: Maybe<CreateReportVulnerabilityCommentPayload>;
  /** Creates a ReportVulnerabilityFile. */
  createReportVulnerabilityFile?: Maybe<CreateReportVulnerabilityFilePayload>;
  /** Creates a ReportVulnerabilityRetestRequest. */
  createReportVulnerabilityRetestRequest?: Maybe<CreateReportVulnerabilityRetestRequestPayload>;
  /** Creates a TestTypePrerequisite. */
  createTestTypePrerequisite?: Maybe<CreateTestTypePrerequisitePayload>;
  /** Creates a TestingType. */
  createTestingType?: Maybe<CreateTestingTypePayload>;
  /** Creates a User. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a UserMobileNumberChangeRequest. */
  createUserMobileNumberChangeRequest?: Maybe<CreateUserMobileNumberChangeRequestPayload>;
  /** Creates a UserPasswordResetRequest. */
  createUserPasswordResetRequest?: Maybe<CreateUserPasswordResetRequestPayload>;
  /** Creates a Vulnerability. */
  createVulnerability?: Maybe<CreateVulnerabilityPayload>;
  /** DeleteAllVersionsOfs a TestTypePrerequisite. */
  deleteAllVersionsOfTestTypePrerequisite?: Maybe<DeleteAllVersionsOfTestTypePrerequisitePayload>;
  /** DeleteAllVersionsOfs a Vulnerability. */
  deleteAllVersionsOfVulnerability?: Maybe<DeleteAllVersionsOfVulnerabilityPayload>;
  /** Deletes a Company. */
  deleteCompany?: Maybe<DeleteCompanyPayload>;
  /** Deletes a CompanyContact. */
  deleteCompanyContact?: Maybe<DeleteCompanyContactPayload>;
  /** Deletes a CompanyInvite. */
  deleteCompanyInvite?: Maybe<DeleteCompanyInvitePayload>;
  /** Deletes a Contact. */
  deleteContact?: Maybe<DeleteContactPayload>;
  /** Deletes a Report. */
  deleteReport?: Maybe<DeleteReportPayload>;
  /** Deletes a ReportAccessInformationCredentials. */
  deleteReportAccessInformationCredentials?: Maybe<DeleteReportAccessInformationCredentialsPayload>;
  /** Deletes a ReportAccessInformationFile. */
  deleteReportAccessInformationFile?: Maybe<DeleteReportAccessInformationFilePayload>;
  /** Deletes a ReportDeliverableFile. */
  deleteReportDeliverableFile?: Maybe<DeleteReportDeliverableFilePayload>;
  /** Deletes a ReportInvite. */
  deleteReportInvite?: Maybe<DeleteReportInvitePayload>;
  /** Deletes a ReportTestTypePrerequisite. */
  deleteReportTestTypePrerequisite?: Maybe<DeleteReportTestTypePrerequisitePayload>;
  /** Deletes a ReportVulnerability. */
  deleteReportVulnerability?: Maybe<DeleteReportVulnerabilityPayload>;
  /** Deletes a ReportVulnerabilityAction. */
  deleteReportVulnerabilityAction?: Maybe<DeleteReportVulnerabilityActionPayload>;
  /** Deletes a ReportVulnerabilityComment. */
  deleteReportVulnerabilityComment?: Maybe<DeleteReportVulnerabilityCommentPayload>;
  /** Deletes a ReportVulnerabilityFile. */
  deleteReportVulnerabilityFile?: Maybe<DeleteReportVulnerabilityFilePayload>;
  /** Deletes a TestingType. */
  deleteTestingType?: Maybe<DeleteTestingTypePayload>;
  /** Deletes a User. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** MarkReads a UserNotification. */
  markReadUserNotification?: Maybe<MarkReadUserNotificationPayload>;
  /** NewVersionOfs a Report. */
  newVersionOfReport?: Maybe<NewVersionOfReportPayload>;
  /** RemoveUserFroms a Company. */
  removeUserFromCompany?: Maybe<RemoveUserFromCompanyPayload>;
  /** RemoveUserFroms a Report. */
  removeUserFromReport?: Maybe<RemoveUserFromReportPayload>;
  /** Resends a CompanyInvite. */
  resendCompanyInvite?: Maybe<ResendCompanyInvitePayload>;
  /** Resends a ReportInvite. */
  resendReportInvite?: Maybe<ResendReportInvitePayload>;
  /** ResetPasswords a User. */
  resetPasswordUser?: Maybe<ResetPasswordUserPayload>;
  /** SendCustomEmails a ReportVersion. */
  sendCustomEmailReportVersion?: Maybe<SendCustomEmailReportVersionPayload>;
  /** SendDailyTestCommencementEmails a ReportVersion. */
  sendDailyTestCommencementEmailReportVersion?: Maybe<SendDailyTestCommencementEmailReportVersionPayload>;
  /** SendDailyTestCompletionEmails a ReportVersion. */
  sendDailyTestCompletionEmailReportVersion?: Maybe<SendDailyTestCompletionEmailReportVersionPayload>;
  /** SendPrerequisitesRequestInformationEmails a ReportVersion. */
  sendPrerequisitesRequestInformationEmailReportVersion?: Maybe<SendPrerequisitesRequestInformationEmailReportVersionPayload>;
  /** SendScopeRequestInformationEmails a ReportVersion. */
  sendScopeRequestInformationEmailReportVersion?: Maybe<SendScopeRequestInformationEmailReportVersionPayload>;
  /** Transitions a ReportVersion. */
  transitionReportVersion?: Maybe<TransitionReportVersionPayload>;
  /** Transitions a ReportVulnerability. */
  transitionReportVulnerability?: Maybe<TransitionReportVulnerabilityPayload>;
  /** Updates a Company. */
  updateCompany?: Maybe<UpdateCompanyPayload>;
  /** Updates a CompanyContact. */
  updateCompanyContact?: Maybe<UpdateCompanyContactPayload>;
  /** Updates a CompanyUser. */
  updateCompanyUser?: Maybe<UpdateCompanyUserPayload>;
  /** Updates a Contact. */
  updateContact?: Maybe<UpdateContactPayload>;
  /** Updates a Report. */
  updateReport?: Maybe<UpdateReportPayload>;
  /** Updates a ReportAccessInformation. */
  updateReportAccessInformation?: Maybe<UpdateReportAccessInformationPayload>;
  /** Updates a ReportAccessInformationCredentials. */
  updateReportAccessInformationCredentials?: Maybe<UpdateReportAccessInformationCredentialsPayload>;
  /** Updates a ReportAccessInformationFile. */
  updateReportAccessInformationFile?: Maybe<UpdateReportAccessInformationFilePayload>;
  /** Updates a ReportClient. */
  updateReportClient?: Maybe<UpdateReportClientPayload>;
  /** Updates a ReportConsultant. */
  updateReportConsultant?: Maybe<UpdateReportConsultantPayload>;
  /** Updates a ReportContact. */
  updateReportContact?: Maybe<UpdateReportContactPayload>;
  /** Updates a ReportDeliverableFile. */
  updateReportDeliverableFile?: Maybe<UpdateReportDeliverableFilePayload>;
  /** Updates a ReportEngagementOverview. */
  updateReportEngagementOverview?: Maybe<UpdateReportEngagementOverviewPayload>;
  /** Updates a ReportScope. */
  updateReportScope?: Maybe<UpdateReportScopePayload>;
  /** Updates a ReportSection. */
  updateReportSection?: Maybe<UpdateReportSectionPayload>;
  /** Updates a ReportTestTypePrerequisite. */
  updateReportTestTypePrerequisite?: Maybe<UpdateReportTestTypePrerequisitePayload>;
  /** Updates a ReportUser. */
  updateReportUser?: Maybe<UpdateReportUserPayload>;
  /** Updates a ReportVersion. */
  updateReportVersion?: Maybe<UpdateReportVersionPayload>;
  /** Updates a ReportVulnerability. */
  updateReportVulnerability?: Maybe<UpdateReportVulnerabilityPayload>;
  /** Updates a ReportVulnerabilityAction. */
  updateReportVulnerabilityAction?: Maybe<UpdateReportVulnerabilityActionPayload>;
  /** Updates a ReportVulnerabilityFile. */
  updateReportVulnerabilityFile?: Maybe<UpdateReportVulnerabilityFilePayload>;
  /** Updates a TestTypePrerequisite. */
  updateTestTypePrerequisite?: Maybe<UpdateTestTypePrerequisitePayload>;
  /** Updates a TestingType. */
  updateTestingType?: Maybe<UpdateTestingTypePayload>;
  /** Updates a User. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a Vulnerability. */
  updateVulnerability?: Maybe<UpdateVulnerabilityPayload>;
  /** UploadLogos a Company. */
  uploadLogoCompany?: Maybe<UploadLogoCompanyPayload>;
  /** Uploads a ReportMediaObject. */
  uploadReportMediaObject?: Maybe<UploadReportMediaObjectPayload>;
  /** VerifyEmails a User. */
  verifyEmailUser?: Maybe<VerifyEmailUserPayload>;
};


export type MutationAcceptCompanyInviteArgs = {
  input: AcceptCompanyInviteInput;
};


export type MutationAcceptReportInviteArgs = {
  input: AcceptReportInviteInput;
};


export type MutationAddCompanyUserToReportArgs = {
  input: AddCompanyUserToReportInput;
};


export type MutationAddUserToCompanyArgs = {
  input: AddUserToCompanyInput;
};


export type MutationAddUserToReportArgs = {
  input: AddUserToReportInput;
};


export type MutationApplyUserMobileNumberChangeRequestArgs = {
  input: ApplyUserMobileNumberChangeRequestInput;
};


export type MutationCompleteReportTestTypePrerequisiteArgs = {
  input: CompleteReportTestTypePrerequisiteInput;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCompanyContactArgs = {
  input: CreateCompanyContactInput;
};


export type MutationCreateCompanyInviteArgs = {
  input: CreateCompanyInviteInput;
};


export type MutationCreateContactArgs = {
  input: CreateContactInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateReportAccessInformationCredentialsArgs = {
  input: CreateReportAccessInformationCredentialsInput;
};


export type MutationCreateReportAccessInformationFileArgs = {
  input: CreateReportAccessInformationFileInput;
};


export type MutationCreateReportDeliverableFileArgs = {
  input: CreateReportDeliverableFileInput;
};


export type MutationCreateReportInviteArgs = {
  input: CreateReportInviteInput;
};


export type MutationCreateReportReadReceiptArgs = {
  input: CreateReportReadReceiptInput;
};


export type MutationCreateReportTestTypePrerequisiteArgs = {
  input: CreateReportTestTypePrerequisiteInput;
};


export type MutationCreateReportVulnerabilityArgs = {
  input: CreateReportVulnerabilityInput;
};


export type MutationCreateReportVulnerabilityActionArgs = {
  input: CreateReportVulnerabilityActionInput;
};


export type MutationCreateReportVulnerabilityClientNotificationArgs = {
  input: CreateReportVulnerabilityClientNotificationInput;
};


export type MutationCreateReportVulnerabilityCommentArgs = {
  input: CreateReportVulnerabilityCommentInput;
};


export type MutationCreateReportVulnerabilityFileArgs = {
  input: CreateReportVulnerabilityFileInput;
};


export type MutationCreateReportVulnerabilityRetestRequestArgs = {
  input: CreateReportVulnerabilityRetestRequestInput;
};


export type MutationCreateTestTypePrerequisiteArgs = {
  input: CreateTestTypePrerequisiteInput;
};


export type MutationCreateTestingTypeArgs = {
  input: CreateTestingTypeInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateUserMobileNumberChangeRequestArgs = {
  input: CreateUserMobileNumberChangeRequestInput;
};


export type MutationCreateUserPasswordResetRequestArgs = {
  input: CreateUserPasswordResetRequestInput;
};


export type MutationCreateVulnerabilityArgs = {
  input: CreateVulnerabilityInput;
};


export type MutationDeleteAllVersionsOfTestTypePrerequisiteArgs = {
  input: DeleteAllVersionsOfTestTypePrerequisiteInput;
};


export type MutationDeleteAllVersionsOfVulnerabilityArgs = {
  input: DeleteAllVersionsOfVulnerabilityInput;
};


export type MutationDeleteCompanyArgs = {
  input: DeleteCompanyInput;
};


export type MutationDeleteCompanyContactArgs = {
  input: DeleteCompanyContactInput;
};


export type MutationDeleteCompanyInviteArgs = {
  input: DeleteCompanyInviteInput;
};


export type MutationDeleteContactArgs = {
  input: DeleteContactInput;
};


export type MutationDeleteReportArgs = {
  input: DeleteReportInput;
};


export type MutationDeleteReportAccessInformationCredentialsArgs = {
  input: DeleteReportAccessInformationCredentialsInput;
};


export type MutationDeleteReportAccessInformationFileArgs = {
  input: DeleteReportAccessInformationFileInput;
};


export type MutationDeleteReportDeliverableFileArgs = {
  input: DeleteReportDeliverableFileInput;
};


export type MutationDeleteReportInviteArgs = {
  input: DeleteReportInviteInput;
};


export type MutationDeleteReportTestTypePrerequisiteArgs = {
  input: DeleteReportTestTypePrerequisiteInput;
};


export type MutationDeleteReportVulnerabilityArgs = {
  input: DeleteReportVulnerabilityInput;
};


export type MutationDeleteReportVulnerabilityActionArgs = {
  input: DeleteReportVulnerabilityActionInput;
};


export type MutationDeleteReportVulnerabilityCommentArgs = {
  input: DeleteReportVulnerabilityCommentInput;
};


export type MutationDeleteReportVulnerabilityFileArgs = {
  input: DeleteReportVulnerabilityFileInput;
};


export type MutationDeleteTestingTypeArgs = {
  input: DeleteTestingTypeInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationMarkReadUserNotificationArgs = {
  input: MarkReadUserNotificationInput;
};


export type MutationNewVersionOfReportArgs = {
  input: NewVersionOfReportInput;
};


export type MutationRemoveUserFromCompanyArgs = {
  input: RemoveUserFromCompanyInput;
};


export type MutationRemoveUserFromReportArgs = {
  input: RemoveUserFromReportInput;
};


export type MutationResendCompanyInviteArgs = {
  input: ResendCompanyInviteInput;
};


export type MutationResendReportInviteArgs = {
  input: ResendReportInviteInput;
};


export type MutationResetPasswordUserArgs = {
  input: ResetPasswordUserInput;
};


export type MutationSendCustomEmailReportVersionArgs = {
  input: SendCustomEmailReportVersionInput;
};


export type MutationSendDailyTestCommencementEmailReportVersionArgs = {
  input: SendDailyTestCommencementEmailReportVersionInput;
};


export type MutationSendDailyTestCompletionEmailReportVersionArgs = {
  input: SendDailyTestCompletionEmailReportVersionInput;
};


export type MutationSendPrerequisitesRequestInformationEmailReportVersionArgs = {
  input: SendPrerequisitesRequestInformationEmailReportVersionInput;
};


export type MutationSendScopeRequestInformationEmailReportVersionArgs = {
  input: SendScopeRequestInformationEmailReportVersionInput;
};


export type MutationTransitionReportVersionArgs = {
  input: TransitionReportVersionInput;
};


export type MutationTransitionReportVulnerabilityArgs = {
  input: TransitionReportVulnerabilityInput;
};


export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyContactArgs = {
  input: UpdateCompanyContactInput;
};


export type MutationUpdateCompanyUserArgs = {
  input: UpdateCompanyUserInput;
};


export type MutationUpdateContactArgs = {
  input: UpdateContactInput;
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
};


export type MutationUpdateReportAccessInformationArgs = {
  input: UpdateReportAccessInformationInput;
};


export type MutationUpdateReportAccessInformationCredentialsArgs = {
  input: UpdateReportAccessInformationCredentialsInput;
};


export type MutationUpdateReportAccessInformationFileArgs = {
  input: UpdateReportAccessInformationFileInput;
};


export type MutationUpdateReportClientArgs = {
  input: UpdateReportClientInput;
};


export type MutationUpdateReportConsultantArgs = {
  input: UpdateReportConsultantInput;
};


export type MutationUpdateReportContactArgs = {
  input: UpdateReportContactInput;
};


export type MutationUpdateReportDeliverableFileArgs = {
  input: UpdateReportDeliverableFileInput;
};


export type MutationUpdateReportEngagementOverviewArgs = {
  input: UpdateReportEngagementOverviewInput;
};


export type MutationUpdateReportScopeArgs = {
  input: UpdateReportScopeInput;
};


export type MutationUpdateReportSectionArgs = {
  input: UpdateReportSectionInput;
};


export type MutationUpdateReportTestTypePrerequisiteArgs = {
  input: UpdateReportTestTypePrerequisiteInput;
};


export type MutationUpdateReportUserArgs = {
  input: UpdateReportUserInput;
};


export type MutationUpdateReportVersionArgs = {
  input: UpdateReportVersionInput;
};


export type MutationUpdateReportVulnerabilityArgs = {
  input: UpdateReportVulnerabilityInput;
};


export type MutationUpdateReportVulnerabilityActionArgs = {
  input: UpdateReportVulnerabilityActionInput;
};


export type MutationUpdateReportVulnerabilityFileArgs = {
  input: UpdateReportVulnerabilityFileInput;
};


export type MutationUpdateTestTypePrerequisiteArgs = {
  input: UpdateTestTypePrerequisiteInput;
};


export type MutationUpdateTestingTypeArgs = {
  input: UpdateTestingTypeInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateVulnerabilityArgs = {
  input: UpdateVulnerabilityInput;
};


export type MutationUploadLogoCompanyArgs = {
  input: UploadLogoCompanyInput;
};


export type MutationUploadReportMediaObjectArgs = {
  input: UploadReportMediaObjectInput;
};


export type MutationVerifyEmailUserArgs = {
  input: VerifyEmailUserInput;
};

/** A node, according to the Relay specification. */
export type Node = {
  /** The id of this node. */
  id: Scalars['ID']['output'];
};

export type Query = {
  __typename?: 'Query';
  companies?: Maybe<CompanyCursorConnection>;
  company?: Maybe<Company>;
  companyContact?: Maybe<CompanyContact>;
  companyContacts?: Maybe<CompanyContactCursorConnection>;
  companyInvite?: Maybe<CompanyInvite>;
  companyInvites?: Maybe<CompanyInviteCursorConnection>;
  companyReportVersions?: Maybe<ReportVersionCursorConnection>;
  companyUser?: Maybe<CompanyUser>;
  companyUsers?: Maybe<CompanyUserCursorConnection>;
  consultantUsers?: Maybe<UserCursorConnection>;
  contact?: Maybe<Contact>;
  contacts?: Maybe<ContactCursorConnection>;
  node?: Maybe<Node>;
  publishedCompanyReportVulnerabilities?: Maybe<ReportVulnerabilityCursorConnection>;
  publishedReportVulnerabilities?: Maybe<ReportVulnerabilityCursorConnection>;
  report?: Maybe<Report>;
  reportAccessInformation?: Maybe<ReportAccessInformation>;
  reportAccessInformationCredentials?: Maybe<ReportAccessInformationCredentials>;
  reportAccessInformationFile?: Maybe<ReportAccessInformationFile>;
  reportAccessInformationFiles?: Maybe<ReportAccessInformationFileCursorConnection>;
  reportClient?: Maybe<ReportClient>;
  reportConsultant?: Maybe<ReportConsultant>;
  reportContact?: Maybe<ReportContact>;
  reportDeliverableFile?: Maybe<ReportDeliverableFile>;
  reportDeliverableFiles?: Maybe<ReportDeliverableFileCursorConnection>;
  reportEmailRecord?: Maybe<ReportEmailRecord>;
  reportEmailRecords?: Maybe<ReportEmailRecordCursorConnection>;
  reportEngagementOverview?: Maybe<ReportEngagementOverview>;
  reportInvite?: Maybe<ReportInvite>;
  reportInvites?: Maybe<ReportInviteCursorConnection>;
  reportScope?: Maybe<ReportScope>;
  reportSection?: Maybe<ReportSection>;
  reportTestTypePrerequisite?: Maybe<ReportTestTypePrerequisite>;
  reportTestTypePrerequisites?: Maybe<ReportTestTypePrerequisiteCursorConnection>;
  reportUser?: Maybe<ReportUser>;
  reportUsers?: Maybe<ReportUserCursorConnection>;
  reportVersion?: Maybe<ReportVersion>;
  reportVersions?: Maybe<ReportVersionCursorConnection>;
  reportVulnerabilities?: Maybe<ReportVulnerabilityCursorConnection>;
  reportVulnerability?: Maybe<ReportVulnerability>;
  reportVulnerabilityAction?: Maybe<ReportVulnerabilityAction>;
  reportVulnerabilityActions?: Maybe<ReportVulnerabilityActionCursorConnection>;
  reportVulnerabilityClientNotification?: Maybe<ReportVulnerabilityClientNotification>;
  reportVulnerabilityClientNotifications?: Maybe<ReportVulnerabilityClientNotificationCursorConnection>;
  reportVulnerabilityComment?: Maybe<ReportVulnerabilityComment>;
  reportVulnerabilityComments?: Maybe<ReportVulnerabilityCommentCursorConnection>;
  reportVulnerabilityFile?: Maybe<ReportVulnerabilityFile>;
  reportVulnerabilityFiles?: Maybe<ReportVulnerabilityFileCursorConnection>;
  reportVulnerabilityRetestRequest?: Maybe<ReportVulnerabilityRetestRequest>;
  reportVulnerabilityRetestRequests?: Maybe<ReportVulnerabilityRetestRequestCursorConnection>;
  reports?: Maybe<ReportCursorConnection>;
  retrieveCompanyInvite?: Maybe<CompanyInvite>;
  retrieveReportInvite?: Maybe<ReportInvite>;
  testTypePrerequisite?: Maybe<TestTypePrerequisite>;
  testTypePrerequisites?: Maybe<TestTypePrerequisiteCursorConnection>;
  testingType?: Maybe<TestingType>;
  testingTypes?: Maybe<TestingTypeCursorConnection>;
  user?: Maybe<User>;
  userNotification?: Maybe<UserNotification>;
  userNotifications?: Maybe<UserNotificationCursorConnection>;
  users?: Maybe<UserCursorConnection>;
  vulnerabilities?: Maybe<VulnerabilityCursorConnection>;
  vulnerability?: Maybe<Vulnerability>;
};


export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<CompanyFilter_Order>>>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<CompanyContactFilter_Order>>>;
};


export type QueryCompanyInviteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<CompanyInviteFilter_Order>>>;
};


export type QueryCompanyReportVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVersionFilter_Order>>>;
  publishedAt?: InputMaybe<Array<InputMaybe<ReportVersionFilter_PublishedAt>>>;
};


export type QueryCompanyUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryConsultantUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserFilter_Order>>>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ContactFilter_Order>>>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublishedCompanyReportVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['ID']['input'];
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_DateDiscovered>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_Order>>>;
  severity?: InputMaybe<Scalars['String']['input']>;
  severity_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testingTypes?: InputMaybe<Scalars['String']['input']>;
  testingTypes_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPublishedReportVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_DateDiscovered>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_Order>>>;
  severity?: InputMaybe<Scalars['String']['input']>;
  severity_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testingTypes?: InputMaybe<Scalars['String']['input']>;
  testingTypes_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportAccessInformationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportAccessInformationCredentialsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportAccessInformationFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportAccessInformationFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportConsultantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportDeliverableFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportDeliverableFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportEmailRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportEmailRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportEngagementOverviewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportInviteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportInviteFilter_Order>>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryReportScopeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportTestTypePrerequisiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportTestTypePrerequisitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVersionFilter_Order>>>;
  publishedAt?: InputMaybe<Array<InputMaybe<ReportVersionFilter_PublishedAt>>>;
};


export type QueryReportVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_DateDiscovered>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_Order>>>;
  severity?: InputMaybe<Scalars['String']['input']>;
  severity_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testingTypes?: InputMaybe<Scalars['String']['input']>;
  testingTypes_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportVulnerabilityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVulnerabilityActionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVulnerabilityActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityActionFilter_Order>>>;
};


export type QueryReportVulnerabilityClientNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVulnerabilityClientNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityClientNotificationFilter_Order>>>;
};


export type QueryReportVulnerabilityCommentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVulnerabilityCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityCommentFilter_Order>>>;
};


export type QueryReportVulnerabilityFileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVulnerabilityFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFileFilter_Order>>>;
};


export type QueryReportVulnerabilityRetestRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReportVulnerabilityRetestRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityRetestRequestFilter_Order>>>;
};


export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportFilter_Order>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRetrieveCompanyInviteArgs = {
  token: Scalars['String']['input'];
};


export type QueryRetrieveReportInviteArgs = {
  token: Scalars['String']['input'];
};


export type QueryTestTypePrerequisiteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTestTypePrerequisitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TestTypePrerequisiteFilter_Order>>>;
  testType?: InputMaybe<Scalars['String']['input']>;
  testType_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryTestingTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTestingTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TestingTypeFilter_Order>>>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserNotificationFilter_Order>>>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Array<InputMaybe<UserFilter_Order>>>;
};


export type QueryVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<VulnerabilityFilter_Order>>>;
  testingTypes?: InputMaybe<Scalars['String']['input']>;
  testingTypes_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVulnerabilityArgs = {
  id: Scalars['ID']['input'];
};

export type Report = Node & {
  __typename?: 'Report';
  _id: Scalars['Int']['output'];
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invites?: Maybe<ReportInviteCursorConnection>;
  latestVersion?: Maybe<ReportVersion>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<ReportVersionCursorConnection>;
  viewers?: Maybe<ReportUserCursorConnection>;
};


export type ReportInvitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportInviteFilter_Order>>>;
  token?: InputMaybe<Scalars['String']['input']>;
  token_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReportVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVersionFilter_Order>>>;
  publishedAt?: InputMaybe<Array<InputMaybe<ReportVersionFilter_PublishedAt>>>;
};


export type ReportViewersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportAccessInformation = Node & {
  __typename?: 'ReportAccessInformation';
  _id: Scalars['Int']['output'];
  additionalInformation: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  credentials?: Maybe<ReportAccessInformationCredentialsCursorConnection>;
  files?: Maybe<ReportAccessInformationFileCursorConnection>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};


export type ReportAccessInformationCredentialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportAccessInformationFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ReportAccessInformationCredentials = Node & {
  __typename?: 'ReportAccessInformationCredentials';
  _id: Scalars['Int']['output'];
  accessInformation: ReportAccessInformation;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportAccessInformationCredentials. */
export type ReportAccessInformationCredentialsCursorConnection = {
  __typename?: 'ReportAccessInformationCredentialsCursorConnection';
  edges?: Maybe<Array<Maybe<ReportAccessInformationCredentialsEdge>>>;
  pageInfo: ReportAccessInformationCredentialsPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportAccessInformationCredentials. */
export type ReportAccessInformationCredentialsEdge = {
  __typename?: 'ReportAccessInformationCredentialsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportAccessInformationCredentials>;
};

/** Information about the current page. */
export type ReportAccessInformationCredentialsPageInfo = {
  __typename?: 'ReportAccessInformationCredentialsPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportAccessInformationFile = Node & {
  __typename?: 'ReportAccessInformationFile';
  _id: Scalars['Int']['output'];
  accessInformation: ReportAccessInformation;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportMediaObject: ReportMediaObject;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportAccessInformationFile. */
export type ReportAccessInformationFileCursorConnection = {
  __typename?: 'ReportAccessInformationFileCursorConnection';
  edges?: Maybe<Array<Maybe<ReportAccessInformationFileEdge>>>;
  pageInfo: ReportAccessInformationFilePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportAccessInformationFile. */
export type ReportAccessInformationFileEdge = {
  __typename?: 'ReportAccessInformationFileEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportAccessInformationFile>;
};

/** Information about the current page. */
export type ReportAccessInformationFilePageInfo = {
  __typename?: 'ReportAccessInformationFilePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportClient = Node & {
  __typename?: 'ReportClient';
  _id: Scalars['Int']['output'];
  contact?: Maybe<ReportContact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

export type ReportConsultant = Node & {
  __typename?: 'ReportConsultant';
  _id: Scalars['Int']['output'];
  contact?: Maybe<ReportContact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  qualifications?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

export type ReportContact = Node & {
  __typename?: 'ReportContact';
  _id: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for Report. */
export type ReportCursorConnection = {
  __typename?: 'ReportCursorConnection';
  edges?: Maybe<Array<Maybe<ReportEdge>>>;
  pageInfo: ReportPageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ReportDeliverableFile = Node & {
  __typename?: 'ReportDeliverableFile';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportMediaObject: ReportMediaObject;
  reportVersion: ReportVersion;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportDeliverableFile. */
export type ReportDeliverableFileCursorConnection = {
  __typename?: 'ReportDeliverableFileCursorConnection';
  edges?: Maybe<Array<Maybe<ReportDeliverableFileEdge>>>;
  pageInfo: ReportDeliverableFilePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportDeliverableFile. */
export type ReportDeliverableFileEdge = {
  __typename?: 'ReportDeliverableFileEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportDeliverableFile>;
};

/** Information about the current page. */
export type ReportDeliverableFilePageInfo = {
  __typename?: 'ReportDeliverableFilePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Edge of Report. */
export type ReportEdge = {
  __typename?: 'ReportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Report>;
};

export type ReportEmailRecord = Node & {
  __typename?: 'ReportEmailRecord';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  type: ReportEmailRecordType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportEmailRecord. */
export type ReportEmailRecordCursorConnection = {
  __typename?: 'ReportEmailRecordCursorConnection';
  edges?: Maybe<Array<Maybe<ReportEmailRecordEdge>>>;
  pageInfo: ReportEmailRecordPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportEmailRecord. */
export type ReportEmailRecordEdge = {
  __typename?: 'ReportEmailRecordEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportEmailRecord>;
};

/** Information about the current page. */
export type ReportEmailRecordPageInfo = {
  __typename?: 'ReportEmailRecordPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum ReportEmailRecordType {
  Custom = 'Custom',
  DailyTestCommencement = 'DailyTestCommencement',
  DailyTestCompletion = 'DailyTestCompletion',
  PrerequisitesRequestInformation = 'PrerequisitesRequestInformation',
  ScopeRequestInformation = 'ScopeRequestInformation'
}

export type ReportEngagementOverview = Node & {
  __typename?: 'ReportEngagementOverview';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limitationsAndExclusions: Scalars['String']['output'];
  objectives: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  rulesOfEngagement: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

export type ReportFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ReportInvite = Node & {
  __typename?: 'ReportInvite';
  _id: Scalars['Int']['output'];
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['String']['output']>;
  acceptedByFullName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  report: Report;
  role: ReportRole;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportInvite. */
export type ReportInviteCursorConnection = {
  __typename?: 'ReportInviteCursorConnection';
  edges?: Maybe<Array<Maybe<ReportInviteEdge>>>;
  pageInfo: ReportInvitePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportInvite. */
export type ReportInviteEdge = {
  __typename?: 'ReportInviteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportInvite>;
};

export type ReportInviteFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportInvitePageInfo = {
  __typename?: 'ReportInvitePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportMediaObject = Node & {
  __typename?: 'ReportMediaObject';
  _id: Scalars['Int']['output'];
  /** Populated when deserializing via MediaObjectNormalizer. */
  contentUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportMediaObject. */
export type ReportMediaObjectCursorConnection = {
  __typename?: 'ReportMediaObjectCursorConnection';
  edges?: Maybe<Array<Maybe<ReportMediaObjectEdge>>>;
  pageInfo: ReportMediaObjectPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportMediaObject. */
export type ReportMediaObjectEdge = {
  __typename?: 'ReportMediaObjectEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportMediaObject>;
};

/** Information about the current page. */
export type ReportMediaObjectPageInfo = {
  __typename?: 'ReportMediaObjectPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Information about the current page. */
export type ReportPageInfo = {
  __typename?: 'ReportPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportReadReceipt = Node & {
  __typename?: 'ReportReadReceipt';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  sectionNumber: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportReadReceipt. */
export type ReportReadReceiptCursorConnection = {
  __typename?: 'ReportReadReceiptCursorConnection';
  edges?: Maybe<Array<Maybe<ReportReadReceiptEdge>>>;
  pageInfo: ReportReadReceiptPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportReadReceipt. */
export type ReportReadReceiptEdge = {
  __typename?: 'ReportReadReceiptEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportReadReceipt>;
};

export type ReportReadReceiptFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportReadReceiptPageInfo = {
  __typename?: 'ReportReadReceiptPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum ReportRole {
  Limited = 'Limited',
  Standard = 'Standard'
}

export type ReportScope = Node & {
  __typename?: 'ReportScope';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inScope: Scalars['String']['output'];
  outOfScope: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

export type ReportSection = Node & {
  __typename?: 'ReportSection';
  _id: Scalars['Int']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: ReportSectionIdentifier;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportSection. */
export type ReportSectionCursorConnection = {
  __typename?: 'ReportSectionCursorConnection';
  edges?: Maybe<Array<Maybe<ReportSectionEdge>>>;
  pageInfo: ReportSectionPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportSection. */
export type ReportSectionEdge = {
  __typename?: 'ReportSectionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportSection>;
};

export type ReportSectionFilter_Order = {
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export enum ReportSectionIdentifier {
  ConsultantExecutiveSummary = 'ConsultantExecutiveSummary',
  ConsultantTechnicalSummary = 'ConsultantTechnicalSummary',
  Exclusions = 'Exclusions',
  ExecutiveSummaryIntro = 'ExecutiveSummaryIntro',
  Scope = 'Scope',
  TargetObjectives = 'TargetObjectives'
}

/** Information about the current page. */
export type ReportSectionPageInfo = {
  __typename?: 'ReportSectionPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportTestTypePrerequisite = Node & {
  __typename?: 'ReportTestTypePrerequisite';
  _id: Scalars['Int']['output'];
  baseTestTypePrerequisite?: Maybe<TestTypePrerequisite>;
  complete: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVersion: ReportVersion;
  testType: TestType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportTestTypePrerequisite. */
export type ReportTestTypePrerequisiteCursorConnection = {
  __typename?: 'ReportTestTypePrerequisiteCursorConnection';
  edges?: Maybe<Array<Maybe<ReportTestTypePrerequisiteEdge>>>;
  pageInfo: ReportTestTypePrerequisitePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportTestTypePrerequisite. */
export type ReportTestTypePrerequisiteEdge = {
  __typename?: 'ReportTestTypePrerequisiteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportTestTypePrerequisite>;
};

/** Information about the current page. */
export type ReportTestTypePrerequisitePageInfo = {
  __typename?: 'ReportTestTypePrerequisitePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportUser = Node & {
  __typename?: 'ReportUser';
  _id: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  report: Report;
  role: ReportRole;
  user: User;
};

/** Cursor connection for ReportUser. */
export type ReportUserCursorConnection = {
  __typename?: 'ReportUserCursorConnection';
  edges?: Maybe<Array<Maybe<ReportUserEdge>>>;
  pageInfo: ReportUserPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportUser. */
export type ReportUserEdge = {
  __typename?: 'ReportUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportUser>;
};

/** Information about the current page. */
export type ReportUserPageInfo = {
  __typename?: 'ReportUserPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportVersion = Node & {
  __typename?: 'ReportVersion';
  _id: Scalars['Int']['output'];
  accessInformation?: Maybe<ReportAccessInformation>;
  bookedAt?: Maybe<Scalars['String']['output']>;
  client?: Maybe<ReportClient>;
  consultant?: Maybe<ReportConsultant>;
  contact?: Maybe<ReportContact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  deliverableFiles?: Maybe<ReportDeliverableFileCursorConnection>;
  engagementOverview?: Maybe<ReportEngagementOverview>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  readReceipts?: Maybe<ReportReadReceiptCursorConnection>;
  report: Report;
  reportCompletedAt?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<ReportScope>;
  scopingCompletedAt?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<ReportSectionCursorConnection>;
  status: ReportVersionStatus;
  testApplicationVersion?: Maybe<Scalars['String']['output']>;
  testCompletedAt?: Maybe<Scalars['String']['output']>;
  testEffortDays?: Maybe<Scalars['Int']['output']>;
  testHostname?: Maybe<Scalars['String']['output']>;
  testName?: Maybe<Scalars['String']['output']>;
  testPerformedFrom?: Maybe<Scalars['String']['output']>;
  testPerformedTo?: Maybe<Scalars['String']['output']>;
  testServerVersion?: Maybe<Scalars['String']['output']>;
  testStartedAt?: Maybe<Scalars['String']['output']>;
  testTypePrerequisites?: Maybe<ReportTestTypePrerequisiteCursorConnection>;
  testTypes?: Maybe<Array<Maybe<TestType>>>;
  transitions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  versionName: Scalars['String']['output'];
  versionNumber: Scalars['String']['output'];
  vulnerabilities?: Maybe<ReportVulnerabilityCursorConnection>;
};


export type ReportVersionDeliverableFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportVersionReadReceiptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportReadReceiptFilter_Order>>>;
};


export type ReportVersionSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportSectionFilter_Order>>>;
};


export type ReportVersionTestTypePrerequisitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ReportVersionTestTypesArgs = {
  order?: InputMaybe<Array<InputMaybe<ReportVersionFilter_Order>>>;
  publishedAt?: InputMaybe<Array<InputMaybe<ReportVersionFilter_PublishedAt>>>;
};


export type ReportVersionVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_DateDiscovered>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFilter_Order>>>;
  severity?: InputMaybe<Scalars['String']['input']>;
  severity_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  testingTypes?: InputMaybe<Scalars['String']['input']>;
  testingTypes_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Cursor connection for ReportVersion. */
export type ReportVersionCursorConnection = {
  __typename?: 'ReportVersionCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVersionEdge>>>;
  pageInfo: ReportVersionPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVersion. */
export type ReportVersionEdge = {
  __typename?: 'ReportVersionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVersion>;
};

export type ReportVersionFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  versionName?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ReportVersionFilter_PublishedAt = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  strictly_after?: InputMaybe<Scalars['String']['input']>;
  strictly_before?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVersionPageInfo = {
  __typename?: 'ReportVersionPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum ReportVersionStatus {
  Booked = 'Booked',
  Prerequisites = 'Prerequisites',
  Published = 'Published',
  QualityAssurance = 'QualityAssurance',
  Reporting = 'Reporting',
  Scoping = 'Scoping',
  Testing = 'Testing'
}

export enum ReportVersionTransition {
  Book = 'book',
  CompleteReport = 'complete_report',
  CompleteScoping = 'complete_scoping',
  CompleteTest = 'complete_test',
  Publish = 'publish',
  RequestPrerequisites = 'request_prerequisites',
  RequestScoping = 'request_scoping',
  StartTest = 'start_test'
}

export type ReportVulnerability = Node & {
  __typename?: 'ReportVulnerability';
  _id: Scalars['Int']['output'];
  actions?: Maybe<ReportVulnerabilityActionCursorConnection>;
  advice?: Maybe<Scalars['String']['output']>;
  affectedHosts?: Maybe<Scalars['String']['output']>;
  baseVulnerability?: Maybe<Vulnerability>;
  clientNotifications?: Maybe<ReportVulnerabilityClientNotificationCursorConnection>;
  comments?: Maybe<ReportVulnerabilityCommentCursorConnection>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  cveScore?: Maybe<Scalars['String']['output']>;
  cvssScore?: Maybe<Scalars['String']['output']>;
  cvssVector?: Maybe<Scalars['String']['output']>;
  cwe?: Maybe<Scalars['String']['output']>;
  dateDiscovered: Scalars['String']['output'];
  dateResolved?: Maybe<Scalars['String']['output']>;
  files?: Maybe<ReportVulnerabilityFileCursorConnection>;
  id: Scalars['ID']['output'];
  issueDetail?: Maybe<Scalars['String']['output']>;
  issueNumber: Scalars['Int']['output'];
  numberOfIssues: Scalars['String']['output'];
  owaspCategory?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reopenedAt?: Maybe<Scalars['String']['output']>;
  reopenedByFullName?: Maybe<Scalars['String']['output']>;
  reopenedReason?: Maybe<Scalars['String']['output']>;
  reportVersion: ReportVersion;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedByFullName?: Maybe<Scalars['String']['output']>;
  resolvedVerifiedAt?: Maybe<Scalars['String']['output']>;
  resolvedVerifiedByFullName?: Maybe<Scalars['String']['output']>;
  retestRequests?: Maybe<ReportVulnerabilityRetestRequestCursorConnection>;
  riskAcceptedAt?: Maybe<Scalars['String']['output']>;
  riskAcceptedByFullName?: Maybe<Scalars['String']['output']>;
  severity: VulnerabilitySeverity;
  status: ReportVulnerabilityStatus;
  testingTypes?: Maybe<TestingTypeCursorConnection>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};


export type ReportVulnerabilityActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityActionFilter_Order>>>;
};


export type ReportVulnerabilityClientNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityClientNotificationFilter_Order>>>;
};


export type ReportVulnerabilityCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityCommentFilter_Order>>>;
};


export type ReportVulnerabilityFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityFileFilter_Order>>>;
};


export type ReportVulnerabilityRetestRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<ReportVulnerabilityRetestRequestFilter_Order>>>;
};


export type ReportVulnerabilityTestingTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TestingTypeFilter_Order>>>;
};

export type ReportVulnerabilityAction = Node & {
  __typename?: 'ReportVulnerabilityAction';
  _id: Scalars['Int']['output'];
  clientReference?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  dateActioned: Scalars['String']['output'];
  description: Scalars['String']['output'];
  files?: Maybe<ReportMediaObjectCursorConnection>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  vulnerability: ReportVulnerability;
};


export type ReportVulnerabilityActionFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Cursor connection for ReportVulnerabilityAction. */
export type ReportVulnerabilityActionCursorConnection = {
  __typename?: 'ReportVulnerabilityActionCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVulnerabilityActionEdge>>>;
  pageInfo: ReportVulnerabilityActionPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVulnerabilityAction. */
export type ReportVulnerabilityActionEdge = {
  __typename?: 'ReportVulnerabilityActionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVulnerabilityAction>;
};

export type ReportVulnerabilityActionFilter_Order = {
  clientReference?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  dateActioned?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVulnerabilityActionPageInfo = {
  __typename?: 'ReportVulnerabilityActionPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportVulnerabilityClientNotification = Node & {
  __typename?: 'ReportVulnerabilityClientNotification';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  vulnerability: ReportVulnerability;
};

/** Cursor connection for ReportVulnerabilityClientNotification. */
export type ReportVulnerabilityClientNotificationCursorConnection = {
  __typename?: 'ReportVulnerabilityClientNotificationCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVulnerabilityClientNotificationEdge>>>;
  pageInfo: ReportVulnerabilityClientNotificationPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVulnerabilityClientNotification. */
export type ReportVulnerabilityClientNotificationEdge = {
  __typename?: 'ReportVulnerabilityClientNotificationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVulnerabilityClientNotification>;
};

export type ReportVulnerabilityClientNotificationFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVulnerabilityClientNotificationPageInfo = {
  __typename?: 'ReportVulnerabilityClientNotificationPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportVulnerabilityComment = Node & {
  __typename?: 'ReportVulnerabilityComment';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  emailParticipants: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reportVulnerability: ReportVulnerability;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportVulnerabilityComment. */
export type ReportVulnerabilityCommentCursorConnection = {
  __typename?: 'ReportVulnerabilityCommentCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVulnerabilityCommentEdge>>>;
  pageInfo: ReportVulnerabilityCommentPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVulnerabilityComment. */
export type ReportVulnerabilityCommentEdge = {
  __typename?: 'ReportVulnerabilityCommentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVulnerabilityComment>;
};

export type ReportVulnerabilityCommentFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVulnerabilityCommentPageInfo = {
  __typename?: 'ReportVulnerabilityCommentPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for ReportVulnerability. */
export type ReportVulnerabilityCursorConnection = {
  __typename?: 'ReportVulnerabilityCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVulnerabilityEdge>>>;
  pageInfo: ReportVulnerabilityPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVulnerability. */
export type ReportVulnerabilityEdge = {
  __typename?: 'ReportVulnerabilityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVulnerability>;
};

export type ReportVulnerabilityFile = Node & {
  __typename?: 'ReportVulnerabilityFile';
  _id: Scalars['Int']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  position: Scalars['Int']['output'];
  reportMediaObject: ReportMediaObject;
  reportVulnerability: ReportVulnerability;
};

/** Cursor connection for ReportVulnerabilityFile. */
export type ReportVulnerabilityFileCursorConnection = {
  __typename?: 'ReportVulnerabilityFileCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVulnerabilityFileEdge>>>;
  pageInfo: ReportVulnerabilityFilePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVulnerabilityFile. */
export type ReportVulnerabilityFileEdge = {
  __typename?: 'ReportVulnerabilityFileEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVulnerabilityFile>;
};

export type ReportVulnerabilityFileFilter_Order = {
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVulnerabilityFilePageInfo = {
  __typename?: 'ReportVulnerabilityFilePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportVulnerabilityFilter_DateDiscovered = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  strictly_after?: InputMaybe<Scalars['String']['input']>;
  strictly_before?: InputMaybe<Scalars['String']['input']>;
};

export type ReportVulnerabilityFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  issueNumber?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVulnerabilityPageInfo = {
  __typename?: 'ReportVulnerabilityPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ReportVulnerabilityRetestRequest = Node & {
  __typename?: 'ReportVulnerabilityRetestRequest';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  vulnerability: ReportVulnerability;
};

/** Cursor connection for ReportVulnerabilityRetestRequest. */
export type ReportVulnerabilityRetestRequestCursorConnection = {
  __typename?: 'ReportVulnerabilityRetestRequestCursorConnection';
  edges?: Maybe<Array<Maybe<ReportVulnerabilityRetestRequestEdge>>>;
  pageInfo: ReportVulnerabilityRetestRequestPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of ReportVulnerabilityRetestRequest. */
export type ReportVulnerabilityRetestRequestEdge = {
  __typename?: 'ReportVulnerabilityRetestRequestEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ReportVulnerabilityRetestRequest>;
};

export type ReportVulnerabilityRetestRequestFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type ReportVulnerabilityRetestRequestPageInfo = {
  __typename?: 'ReportVulnerabilityRetestRequestPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum ReportVulnerabilityStatus {
  Informational = 'Informational',
  Open = 'Open',
  Resolved = 'Resolved',
  RiskAccepted = 'RiskAccepted',
  VerifiedResolved = 'VerifiedResolved'
}

export enum ReportVulnerabilityTransition {
  AcceptRisk = 'accept_risk',
  Reopen = 'reopen',
  Resolve = 'resolve',
  VerifyResolved = 'verify_resolved'
}

export enum TestType {
  Api = 'Api',
  AppInfraCloud = 'AppInfraCloud',
  BlackBox = 'BlackBox',
  BlindTesting = 'BlindTesting',
  CloudAssessment = 'CloudAssessment',
  DesktopApp = 'DesktopApp',
  DoubleBlindTesting = 'DoubleBlindTesting',
  ExternalInfrastructure = 'ExternalInfrastructure',
  GreyBox = 'GreyBox',
  InternalExternalInfra = 'InternalExternalInfra',
  InternalInfrastructure = 'InternalInfrastructure',
  IotAndEmbedded = 'IotAndEmbedded',
  Kubernetes = 'Kubernetes',
  Llm = 'Llm',
  MobileApp = 'MobileApp',
  NotSpecified = 'NotSpecified',
  PenetrationTest = 'PenetrationTest',
  Phishing = 'Phishing',
  PhysicalPenetrationTesting = 'PhysicalPenetrationTesting',
  PurpleTeamAssessment = 'PurpleTeamAssessment',
  RedTeamAssessment = 'RedTeamAssessment',
  SapTesting = 'SapTesting',
  SocialEngineering = 'SocialEngineering',
  WebApp = 'WebApp',
  WhiteBox = 'WhiteBox',
  Wifi = 'Wifi'
}

export type TestTypePrerequisite = Node & {
  __typename?: 'TestTypePrerequisite';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  testType: TestType;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

/** Cursor connection for TestTypePrerequisite. */
export type TestTypePrerequisiteCursorConnection = {
  __typename?: 'TestTypePrerequisiteCursorConnection';
  edges?: Maybe<Array<Maybe<TestTypePrerequisiteEdge>>>;
  pageInfo: TestTypePrerequisitePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of TestTypePrerequisite. */
export type TestTypePrerequisiteEdge = {
  __typename?: 'TestTypePrerequisiteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TestTypePrerequisite>;
};

export type TestTypePrerequisiteFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  testType?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type TestTypePrerequisitePageInfo = {
  __typename?: 'TestTypePrerequisitePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type TestingType = Node & {
  __typename?: 'TestingType';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for TestingType. */
export type TestingTypeCursorConnection = {
  __typename?: 'TestingTypeCursorConnection';
  edges?: Maybe<Array<Maybe<TestingTypeEdge>>>;
  pageInfo: TestingTypePageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of TestingType. */
export type TestingTypeEdge = {
  __typename?: 'TestingTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TestingType>;
};

export type TestingTypeFilter_Order = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type TestingTypePageInfo = {
  __typename?: 'TestingTypePageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type User = Node & {
  __typename?: 'User';
  _id: Scalars['Int']['output'];
  companies?: Maybe<CompanyUserCursorConnection>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  mobileNumber?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  roles?: Maybe<Array<Scalars['String']['output']>>;
};


export type UserCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  company_list?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Cursor connection for User. */
export type UserCursorConnection = {
  __typename?: 'UserCursorConnection';
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  pageInfo: UserPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of User. */
export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export type UserFilter_Order = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UserMobileNumberChangeRequest = Node & {
  __typename?: 'UserMobileNumberChangeRequest';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

export type UserNotification = Node & {
  __typename?: 'UserNotification';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Iterable']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  readAt?: Maybe<Scalars['String']['output']>;
  type: UserNotificationType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for UserNotification. */
export type UserNotificationCursorConnection = {
  __typename?: 'UserNotificationCursorConnection';
  edges?: Maybe<Array<Maybe<UserNotificationEdge>>>;
  pageInfo: UserNotificationPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of UserNotification. */
export type UserNotificationEdge = {
  __typename?: 'UserNotificationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserNotification>;
};

export type UserNotificationFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type UserNotificationPageInfo = {
  __typename?: 'UserNotificationPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum UserNotificationType {
  NewHighRiskVulnerability = 'NewHighRiskVulnerability',
  NewReportVulnerabilityClientNotification = 'NewReportVulnerabilityClientNotification',
  NewReportVulnerabilityRetestRequest = 'NewReportVulnerabilityRetestRequest',
  NewVulnerabilityComment = 'NewVulnerabilityComment'
}

/** Information about the current page. */
export type UserPageInfo = {
  __typename?: 'UserPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Vulnerability = Node & {
  __typename?: 'Vulnerability';
  _id: Scalars['Int']['output'];
  advice?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  cveScore?: Maybe<Scalars['String']['output']>;
  cvssScore?: Maybe<Scalars['String']['output']>;
  cvssVector?: Maybe<Scalars['String']['output']>;
  cwe?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  issueDetail?: Maybe<Scalars['String']['output']>;
  owaspCategory?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  severity: VulnerabilitySeverity;
  testingTypes?: Maybe<TestingTypeCursorConnection>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};


export type VulnerabilityTestingTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<TestingTypeFilter_Order>>>;
};

/** Cursor connection for Vulnerability. */
export type VulnerabilityCursorConnection = {
  __typename?: 'VulnerabilityCursorConnection';
  edges?: Maybe<Array<Maybe<VulnerabilityEdge>>>;
  pageInfo: VulnerabilityPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of Vulnerability. */
export type VulnerabilityEdge = {
  __typename?: 'VulnerabilityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Vulnerability>;
};

export type VulnerabilityFilter_Order = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the current page. */
export type VulnerabilityPageInfo = {
  __typename?: 'VulnerabilityPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum VulnerabilitySeverity {
  Critical = 'Critical',
  High = 'High',
  Informational = 'Informational',
  Low = 'Low',
  Medium = 'Medium'
}

/** Accepts a CompanyInvite. */
export type AcceptCompanyInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

/** Accepts a CompanyInvite. */
export type AcceptCompanyInvitePayload = {
  __typename?: 'acceptCompanyInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyInvite?: Maybe<CompanyInvite>;
};

/** Accepts a ReportInvite. */
export type AcceptReportInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

/** Accepts a ReportInvite. */
export type AcceptReportInvitePayload = {
  __typename?: 'acceptReportInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportInvite?: Maybe<ReportInvite>;
};

/** AddCompanyUserTos a Report. */
export type AddCompanyUserToReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyUser: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  role: ReportRole;
};

/** AddCompanyUserTos a Report. */
export type AddCompanyUserToReportPayload = {
  __typename?: 'addCompanyUserToReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** AddUserTos a Company. */
export type AddUserToCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  role: CompanyRole;
  user: Scalars['ID']['input'];
};

/** AddUserTos a Company. */
export type AddUserToCompanyPayload = {
  __typename?: 'addUserToCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
};

/** AddUserTos a Report. */
export type AddUserToReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  role: ReportRole;
  user: Scalars['ID']['input'];
};

/** AddUserTos a Report. */
export type AddUserToReportPayload = {
  __typename?: 'addUserToReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** Applys a UserMobileNumberChangeRequest. */
export type ApplyUserMobileNumberChangeRequestInput = {
  challenge: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Applys a UserMobileNumberChangeRequest. */
export type ApplyUserMobileNumberChangeRequestPayload = {
  __typename?: 'applyUserMobileNumberChangeRequestPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userMobileNumberChangeRequest?: Maybe<UserMobileNumberChangeRequest>;
};

/** Completes a ReportTestTypePrerequisite. */
export type CompleteReportTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  complete: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

/** Completes a ReportTestTypePrerequisite. */
export type CompleteReportTestTypePrerequisitePayload = {
  __typename?: 'completeReportTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportTestTypePrerequisite?: Maybe<ReportTestTypePrerequisite>;
};

/** Creates a CompanyContact. */
export type CreateCompanyContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a CompanyContact. */
export type CreateCompanyContactNestedPayload = Node & {
  __typename?: 'createCompanyContactNestedPayload';
  _id: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  company: CreateCompanyNestedPayload;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for createCompanyContactNestedPayload. */
export type CreateCompanyContactNestedPayloadCursorConnection = {
  __typename?: 'createCompanyContactNestedPayloadCursorConnection';
  edges?: Maybe<Array<Maybe<CreateCompanyContactNestedPayloadEdge>>>;
  pageInfo: CreateCompanyContactNestedPayloadPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of createCompanyContactNestedPayload. */
export type CreateCompanyContactNestedPayloadEdge = {
  __typename?: 'createCompanyContactNestedPayloadEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CreateCompanyContactNestedPayload>;
};

/** Information about the current page. */
export type CreateCompanyContactNestedPayloadPageInfo = {
  __typename?: 'createCompanyContactNestedPayloadPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Creates a CompanyContact. */
export type CreateCompanyContactPayload = {
  __typename?: 'createCompanyContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyContact?: Maybe<CompanyContact>;
};

/** Creates a Company. */
export type CreateCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Creates a CompanyInvite. */
export type CreateCompanyInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  role: CompanyRole;
};

/** Creates a CompanyInvite. */
export type CreateCompanyInviteNestedPayload = Node & {
  __typename?: 'createCompanyInviteNestedPayload';
  _id: Scalars['Int']['output'];
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['String']['output']>;
  acceptedByFullName?: Maybe<Scalars['String']['output']>;
  company: CreateCompanyNestedPayload;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  role: CompanyRole;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for createCompanyInviteNestedPayload. */
export type CreateCompanyInviteNestedPayloadCursorConnection = {
  __typename?: 'createCompanyInviteNestedPayloadCursorConnection';
  edges?: Maybe<Array<Maybe<CreateCompanyInviteNestedPayloadEdge>>>;
  pageInfo: CreateCompanyInviteNestedPayloadPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of createCompanyInviteNestedPayload. */
export type CreateCompanyInviteNestedPayloadEdge = {
  __typename?: 'createCompanyInviteNestedPayloadEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CreateCompanyInviteNestedPayload>;
};

/** Information about the current page. */
export type CreateCompanyInviteNestedPayloadPageInfo = {
  __typename?: 'createCompanyInviteNestedPayloadPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Creates a CompanyInvite. */
export type CreateCompanyInvitePayload = {
  __typename?: 'createCompanyInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyInvite?: Maybe<CreateCompanyInvitePayloadData>;
};

/** Creates a CompanyInvite. */
export type CreateCompanyInvitePayloadData = Node & {
  __typename?: 'createCompanyInvitePayloadData';
  _id: Scalars['Int']['output'];
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['String']['output']>;
  acceptedByFullName?: Maybe<Scalars['String']['output']>;
  company: CreateCompanyNestedPayload;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  role: CompanyRole;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Creates a Company. */
export type CreateCompanyNestedPayload = Node & {
  __typename?: 'createCompanyNestedPayload';
  _id: Scalars['Int']['output'];
  contacts?: Maybe<CreateCompanyContactNestedPayloadCursorConnection>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invites?: Maybe<CreateCompanyInviteNestedPayloadCursorConnection>;
  logo?: Maybe<CompanyLogo>;
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  reports?: Maybe<CreateReportNestedPayloadCursorConnection>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  users?: Maybe<CompanyUserCursorConnection>;
};

/** Creates a Company. */
export type CreateCompanyPayload = {
  __typename?: 'createCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
};

/** Creates a Contact. */
export type CreateContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a Contact. */
export type CreateContactPayload = {
  __typename?: 'createContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
};

/** Creates a ReportAccessInformationCredentials. */
export type CreateReportAccessInformationCredentialsInput = {
  accessInformation: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Creates a ReportAccessInformationCredentials. */
export type CreateReportAccessInformationCredentialsPayload = {
  __typename?: 'createReportAccessInformationCredentialsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformationCredentials?: Maybe<ReportAccessInformationCredentials>;
};

/** Creates a ReportAccessInformationFile. */
export type CreateReportAccessInformationFileInput = {
  accessInformation: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  reportMediaObject: Scalars['String']['input'];
};

/** Creates a ReportAccessInformationFile. */
export type CreateReportAccessInformationFilePayload = {
  __typename?: 'createReportAccessInformationFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformationFile?: Maybe<ReportAccessInformationFile>;
};

/** Creates a ReportDeliverableFile. */
export type CreateReportDeliverableFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  reportMediaObject: Scalars['String']['input'];
  reportVersion: Scalars['String']['input'];
};

/** Creates a ReportDeliverableFile. */
export type CreateReportDeliverableFilePayload = {
  __typename?: 'createReportDeliverableFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportDeliverableFile?: Maybe<ReportDeliverableFile>;
};

/** Creates a Report. */
export type CreateReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

/** Creates a ReportInvite. */
export type CreateReportInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  report: Scalars['String']['input'];
  role: ReportRole;
};

/** Creates a ReportInvite. */
export type CreateReportInviteNestedPayload = Node & {
  __typename?: 'createReportInviteNestedPayload';
  _id: Scalars['Int']['output'];
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['String']['output']>;
  acceptedByFullName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  report: CreateReportNestedPayload;
  role: ReportRole;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Cursor connection for createReportInviteNestedPayload. */
export type CreateReportInviteNestedPayloadCursorConnection = {
  __typename?: 'createReportInviteNestedPayloadCursorConnection';
  edges?: Maybe<Array<Maybe<CreateReportInviteNestedPayloadEdge>>>;
  pageInfo: CreateReportInviteNestedPayloadPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of createReportInviteNestedPayload. */
export type CreateReportInviteNestedPayloadEdge = {
  __typename?: 'createReportInviteNestedPayloadEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CreateReportInviteNestedPayload>;
};

/** Information about the current page. */
export type CreateReportInviteNestedPayloadPageInfo = {
  __typename?: 'createReportInviteNestedPayloadPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Creates a ReportInvite. */
export type CreateReportInvitePayload = {
  __typename?: 'createReportInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportInvite?: Maybe<CreateReportInvitePayloadData>;
};

/** Creates a ReportInvite. */
export type CreateReportInvitePayloadData = Node & {
  __typename?: 'createReportInvitePayloadData';
  _id: Scalars['Int']['output'];
  accepted: Scalars['Boolean']['output'];
  acceptedAt?: Maybe<Scalars['String']['output']>;
  acceptedByFullName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expired: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  report: CreateReportNestedPayload;
  role: ReportRole;
  token: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Creates a Report. */
export type CreateReportNestedPayload = Node & {
  __typename?: 'createReportNestedPayload';
  _id: Scalars['Int']['output'];
  company?: Maybe<CreateCompanyNestedPayload>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invites?: Maybe<CreateReportInviteNestedPayloadCursorConnection>;
  latestVersion?: Maybe<ReportVersion>;
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
  versions?: Maybe<ReportVersionCursorConnection>;
  viewers?: Maybe<ReportUserCursorConnection>;
};

/** Cursor connection for createReportNestedPayload. */
export type CreateReportNestedPayloadCursorConnection = {
  __typename?: 'createReportNestedPayloadCursorConnection';
  edges?: Maybe<Array<Maybe<CreateReportNestedPayloadEdge>>>;
  pageInfo: CreateReportNestedPayloadPageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Edge of createReportNestedPayload. */
export type CreateReportNestedPayloadEdge = {
  __typename?: 'createReportNestedPayloadEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CreateReportNestedPayload>;
};

/** Information about the current page. */
export type CreateReportNestedPayloadPageInfo = {
  __typename?: 'createReportNestedPayloadPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Creates a Report. */
export type CreateReportPayload = {
  __typename?: 'createReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** Creates a ReportReadReceipt. */
export type CreateReportReadReceiptInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reportVersion: Scalars['String']['input'];
  sectionNumber: Scalars['String']['input'];
};

/** Creates a ReportReadReceipt. */
export type CreateReportReadReceiptPayload = {
  __typename?: 'createReportReadReceiptPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportReadReceipt?: Maybe<ReportReadReceipt>;
};

/** Creates a ReportTestTypePrerequisite. */
export type CreateReportTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  complete: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  reportVersion: Scalars['String']['input'];
  testType: TestType;
};

/** Creates a ReportTestTypePrerequisite. */
export type CreateReportTestTypePrerequisitePayload = {
  __typename?: 'createReportTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportTestTypePrerequisite?: Maybe<ReportTestTypePrerequisite>;
};

/** Creates a ReportVulnerabilityAction. */
export type CreateReportVulnerabilityActionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientReference?: InputMaybe<Scalars['String']['input']>;
  dateActioned: Scalars['String']['input'];
  description: Scalars['String']['input'];
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vulnerability: Scalars['String']['input'];
};

/** Creates a ReportVulnerabilityAction. */
export type CreateReportVulnerabilityActionPayload = {
  __typename?: 'createReportVulnerabilityActionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityAction?: Maybe<ReportVulnerabilityAction>;
};

/** Creates a ReportVulnerabilityClientNotification. */
export type CreateReportVulnerabilityClientNotificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vulnerability: Scalars['String']['input'];
};

/** Creates a ReportVulnerabilityClientNotification. */
export type CreateReportVulnerabilityClientNotificationPayload = {
  __typename?: 'createReportVulnerabilityClientNotificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityClientNotification?: Maybe<ReportVulnerabilityClientNotification>;
};

/** Creates a ReportVulnerabilityComment. */
export type CreateReportVulnerabilityCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailParticipants: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  reportVulnerability: Scalars['String']['input'];
};

/** Creates a ReportVulnerabilityComment. */
export type CreateReportVulnerabilityCommentPayload = {
  __typename?: 'createReportVulnerabilityCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityComment?: Maybe<ReportVulnerabilityComment>;
};

/** Creates a ReportVulnerabilityFile. */
export type CreateReportVulnerabilityFileInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  position: Scalars['Int']['input'];
  reportMediaObject: Scalars['String']['input'];
  reportVulnerability: Scalars['String']['input'];
};

/** Creates a ReportVulnerabilityFile. */
export type CreateReportVulnerabilityFilePayload = {
  __typename?: 'createReportVulnerabilityFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityFile?: Maybe<ReportVulnerabilityFile>;
};

/** Creates a ReportVulnerability. */
export type CreateReportVulnerabilityInput = {
  advice?: InputMaybe<Scalars['String']['input']>;
  affectedHosts?: InputMaybe<Scalars['String']['input']>;
  baseVulnerability?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cveScore?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cwe?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered: Scalars['String']['input'];
  issueDetail?: InputMaybe<Scalars['String']['input']>;
  numberOfIssues: Scalars['String']['input'];
  owaspCategory?: InputMaybe<Scalars['String']['input']>;
  reportVersion: Scalars['String']['input'];
  severity: VulnerabilitySeverity;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};

/** Creates a ReportVulnerability. */
export type CreateReportVulnerabilityPayload = {
  __typename?: 'createReportVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerability?: Maybe<ReportVulnerability>;
};

/** Creates a ReportVulnerabilityRetestRequest. */
export type CreateReportVulnerabilityRetestRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  vulnerability: Scalars['String']['input'];
};

/** Creates a ReportVulnerabilityRetestRequest. */
export type CreateReportVulnerabilityRetestRequestPayload = {
  __typename?: 'createReportVulnerabilityRetestRequestPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityRetestRequest?: Maybe<ReportVulnerabilityRetestRequest>;
};

/** Creates a TestTypePrerequisite. */
export type CreateTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  testType: TestType;
};

/** Creates a TestTypePrerequisite. */
export type CreateTestTypePrerequisitePayload = {
  __typename?: 'createTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  testTypePrerequisite?: Maybe<TestTypePrerequisite>;
};

/** Creates a TestingType. */
export type CreateTestingTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Creates a TestingType. */
export type CreateTestingTypePayload = {
  __typename?: 'createTestingTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  testingType?: Maybe<TestingType>;
};

/** Creates a User. */
export type CreateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  plainPassword: Scalars['String']['input'];
};

/** Creates a UserMobileNumberChangeRequest. */
export type CreateUserMobileNumberChangeRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  toValue: Scalars['String']['input'];
};

/** Creates a UserMobileNumberChangeRequest. */
export type CreateUserMobileNumberChangeRequestPayload = {
  __typename?: 'createUserMobileNumberChangeRequestPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userMobileNumberChangeRequest?: Maybe<CreateUserMobileNumberChangeRequestPayloadData>;
};

/** Creates a UserMobileNumberChangeRequest. */
export type CreateUserMobileNumberChangeRequestPayloadData = Node & {
  __typename?: 'createUserMobileNumberChangeRequestPayloadData';
  _id: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdByFullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedByFullName?: Maybe<Scalars['String']['output']>;
};

/** Creates a UserPasswordResetRequest. */
export type CreateUserPasswordResetRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};

/** Creates a UserPasswordResetRequest. */
export type CreateUserPasswordResetRequestPayload = {
  __typename?: 'createUserPasswordResetRequestPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userPasswordResetRequest?: Maybe<CreateUserPasswordResetRequestPayloadData>;
};

/** Creates a UserPasswordResetRequest. */
export type CreateUserPasswordResetRequestPayloadData = Node & {
  __typename?: 'createUserPasswordResetRequestPayloadData';
  id: Scalars['ID']['output'];
};

/** Creates a User. */
export type CreateUserPayload = {
  __typename?: 'createUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Creates a Vulnerability. */
export type CreateVulnerabilityInput = {
  advice?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cveScore?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cwe?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  issueDetail?: InputMaybe<Scalars['String']['input']>;
  owaspCategory?: InputMaybe<Scalars['String']['input']>;
  severity: VulnerabilitySeverity;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: Scalars['String']['input'];
};

/** Creates a Vulnerability. */
export type CreateVulnerabilityPayload = {
  __typename?: 'createVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  vulnerability?: Maybe<Vulnerability>;
};

/** DeleteAllVersionsOfs a TestTypePrerequisite. */
export type DeleteAllVersionsOfTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** DeleteAllVersionsOfs a TestTypePrerequisite. */
export type DeleteAllVersionsOfTestTypePrerequisitePayload = {
  __typename?: 'deleteAllVersionsOfTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  testTypePrerequisite?: Maybe<TestTypePrerequisite>;
};

/** DeleteAllVersionsOfs a Vulnerability. */
export type DeleteAllVersionsOfVulnerabilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** DeleteAllVersionsOfs a Vulnerability. */
export type DeleteAllVersionsOfVulnerabilityPayload = {
  __typename?: 'deleteAllVersionsOfVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  vulnerability?: Maybe<Vulnerability>;
};

/** Deletes a CompanyContact. */
export type DeleteCompanyContactInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a CompanyContact. */
export type DeleteCompanyContactPayload = {
  __typename?: 'deleteCompanyContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyContact?: Maybe<CompanyContact>;
};

/** Deletes a Company. */
export type DeleteCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a CompanyInvite. */
export type DeleteCompanyInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a CompanyInvite. */
export type DeleteCompanyInvitePayload = {
  __typename?: 'deleteCompanyInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyInvite?: Maybe<CompanyInvite>;
};

/** Deletes a Company. */
export type DeleteCompanyPayload = {
  __typename?: 'deleteCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
};

/** Deletes a Contact. */
export type DeleteContactInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a Contact. */
export type DeleteContactPayload = {
  __typename?: 'deleteContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
};

/** Deletes a ReportAccessInformationCredentials. */
export type DeleteReportAccessInformationCredentialsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportAccessInformationCredentials. */
export type DeleteReportAccessInformationCredentialsPayload = {
  __typename?: 'deleteReportAccessInformationCredentialsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformationCredentials?: Maybe<ReportAccessInformationCredentials>;
};

/** Deletes a ReportAccessInformationFile. */
export type DeleteReportAccessInformationFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportAccessInformationFile. */
export type DeleteReportAccessInformationFilePayload = {
  __typename?: 'deleteReportAccessInformationFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformationFile?: Maybe<ReportAccessInformationFile>;
};

/** Deletes a ReportDeliverableFile. */
export type DeleteReportDeliverableFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportDeliverableFile. */
export type DeleteReportDeliverableFilePayload = {
  __typename?: 'deleteReportDeliverableFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportDeliverableFile?: Maybe<ReportDeliverableFile>;
};

/** Deletes a Report. */
export type DeleteReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportInvite. */
export type DeleteReportInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportInvite. */
export type DeleteReportInvitePayload = {
  __typename?: 'deleteReportInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportInvite?: Maybe<ReportInvite>;
};

/** Deletes a Report. */
export type DeleteReportPayload = {
  __typename?: 'deleteReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** Deletes a ReportTestTypePrerequisite. */
export type DeleteReportTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportTestTypePrerequisite. */
export type DeleteReportTestTypePrerequisitePayload = {
  __typename?: 'deleteReportTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportTestTypePrerequisite?: Maybe<ReportTestTypePrerequisite>;
};

/** Deletes a ReportVulnerabilityAction. */
export type DeleteReportVulnerabilityActionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportVulnerabilityAction. */
export type DeleteReportVulnerabilityActionPayload = {
  __typename?: 'deleteReportVulnerabilityActionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityAction?: Maybe<ReportVulnerabilityAction>;
};

/** Deletes a ReportVulnerabilityComment. */
export type DeleteReportVulnerabilityCommentInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportVulnerabilityComment. */
export type DeleteReportVulnerabilityCommentPayload = {
  __typename?: 'deleteReportVulnerabilityCommentPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityComment?: Maybe<ReportVulnerabilityComment>;
};

/** Deletes a ReportVulnerabilityFile. */
export type DeleteReportVulnerabilityFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportVulnerabilityFile. */
export type DeleteReportVulnerabilityFilePayload = {
  __typename?: 'deleteReportVulnerabilityFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityFile?: Maybe<ReportVulnerabilityFile>;
};

/** Deletes a ReportVulnerability. */
export type DeleteReportVulnerabilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a ReportVulnerability. */
export type DeleteReportVulnerabilityPayload = {
  __typename?: 'deleteReportVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerability?: Maybe<ReportVulnerability>;
};

/** Deletes a TestingType. */
export type DeleteTestingTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a TestingType. */
export type DeleteTestingTypePayload = {
  __typename?: 'deleteTestingTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  testingType?: Maybe<TestingType>;
};

/** Deletes a User. */
export type DeleteUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Deletes a User. */
export type DeleteUserPayload = {
  __typename?: 'deleteUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** MarkReads a UserNotification. */
export type MarkReadUserNotificationInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  read: Scalars['Boolean']['input'];
};

/** MarkReads a UserNotification. */
export type MarkReadUserNotificationPayload = {
  __typename?: 'markReadUserNotificationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  userNotification?: Maybe<UserNotification>;
};

/** NewVersionOfs a Report. */
export type NewVersionOfReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  versionName: Scalars['String']['input'];
  versionNumber: Scalars['String']['input'];
};

/** NewVersionOfs a Report. */
export type NewVersionOfReportPayload = {
  __typename?: 'newVersionOfReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** RemoveUserFroms a Company. */
export type RemoveUserFromCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

/** RemoveUserFroms a Company. */
export type RemoveUserFromCompanyPayload = {
  __typename?: 'removeUserFromCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
};

/** RemoveUserFroms a Report. */
export type RemoveUserFromReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

/** RemoveUserFroms a Report. */
export type RemoveUserFromReportPayload = {
  __typename?: 'removeUserFromReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** Resends a CompanyInvite. */
export type ResendCompanyInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Resends a CompanyInvite. */
export type ResendCompanyInvitePayload = {
  __typename?: 'resendCompanyInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyInvite?: Maybe<CompanyInvite>;
};

/** Resends a ReportInvite. */
export type ResendReportInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Resends a ReportInvite. */
export type ResendReportInvitePayload = {
  __typename?: 'resendReportInvitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportInvite?: Maybe<ReportInvite>;
};

/** ResetPasswords a User. */
export type ResetPasswordUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

/** ResetPasswords a User. */
export type ResetPasswordUserPayload = {
  __typename?: 'resetPasswordUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** SendCustomEmails a ReportVersion. */
export type SendCustomEmailReportVersionInput = {
  additionalRecipients?: InputMaybe<Scalars['Iterable']['input']>;
  body: Scalars['String']['input'];
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  subject: Scalars['String']['input'];
};

/** SendCustomEmails a ReportVersion. */
export type SendCustomEmailReportVersionPayload = {
  __typename?: 'sendCustomEmailReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** SendDailyTestCommencementEmails a ReportVersion. */
export type SendDailyTestCommencementEmailReportVersionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** SendDailyTestCommencementEmails a ReportVersion. */
export type SendDailyTestCommencementEmailReportVersionPayload = {
  __typename?: 'sendDailyTestCommencementEmailReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** SendDailyTestCompletionEmails a ReportVersion. */
export type SendDailyTestCompletionEmailReportVersionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** SendDailyTestCompletionEmails a ReportVersion. */
export type SendDailyTestCompletionEmailReportVersionPayload = {
  __typename?: 'sendDailyTestCompletionEmailReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** SendPrerequisitesRequestInformationEmails a ReportVersion. */
export type SendPrerequisitesRequestInformationEmailReportVersionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** SendPrerequisitesRequestInformationEmails a ReportVersion. */
export type SendPrerequisitesRequestInformationEmailReportVersionPayload = {
  __typename?: 'sendPrerequisitesRequestInformationEmailReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** SendScopeRequestInformationEmails a ReportVersion. */
export type SendScopeRequestInformationEmailReportVersionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** SendScopeRequestInformationEmails a ReportVersion. */
export type SendScopeRequestInformationEmailReportVersionPayload = {
  __typename?: 'sendScopeRequestInformationEmailReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** Transitions a ReportVersion. */
export type TransitionReportVersionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  transition: ReportVersionTransition;
};

/** Transitions a ReportVersion. */
export type TransitionReportVersionPayload = {
  __typename?: 'transitionReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** Transitions a ReportVulnerability. */
export type TransitionReportVulnerabilityInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  dateResolved?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reopenedReason?: InputMaybe<Scalars['String']['input']>;
  transition: ReportVulnerabilityTransition;
};

/** Transitions a ReportVulnerability. */
export type TransitionReportVulnerabilityPayload = {
  __typename?: 'transitionReportVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerability?: Maybe<ReportVulnerability>;
};

/** Updates a CompanyContact. */
export type UpdateCompanyContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a CompanyContact. */
export type UpdateCompanyContactPayload = {
  __typename?: 'updateCompanyContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyContact?: Maybe<CompanyContact>;
};

/** Updates a Company. */
export type UpdateCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a Company. */
export type UpdateCompanyPayload = {
  __typename?: 'updateCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
};

/** Updates a CompanyUser. */
export type UpdateCompanyUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  role?: InputMaybe<CompanyRole>;
};

/** Updates a CompanyUser. */
export type UpdateCompanyUserPayload = {
  __typename?: 'updateCompanyUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  companyUser?: Maybe<CompanyUser>;
};

/** Updates a Contact. */
export type UpdateContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a Contact. */
export type UpdateContactPayload = {
  __typename?: 'updateContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
};

/** Updates a ReportAccessInformationCredentials. */
export type UpdateReportAccessInformationCredentialsInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportAccessInformationCredentials. */
export type UpdateReportAccessInformationCredentialsPayload = {
  __typename?: 'updateReportAccessInformationCredentialsPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformationCredentials?: Maybe<ReportAccessInformationCredentials>;
};

/** Updates a ReportAccessInformationFile. */
export type UpdateReportAccessInformationFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportAccessInformationFile. */
export type UpdateReportAccessInformationFilePayload = {
  __typename?: 'updateReportAccessInformationFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformationFile?: Maybe<ReportAccessInformationFile>;
};

/** Updates a ReportAccessInformation. */
export type UpdateReportAccessInformationInput = {
  additionalInformation?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportAccessInformation. */
export type UpdateReportAccessInformationPayload = {
  __typename?: 'updateReportAccessInformationPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportAccessInformation?: Maybe<ReportAccessInformation>;
};

/** Updates a ReportClient. */
export type UpdateReportClientInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportClient. */
export type UpdateReportClientPayload = {
  __typename?: 'updateReportClientPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportClient?: Maybe<ReportClient>;
};

/** Updates a ReportConsultant. */
export type UpdateReportConsultantInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  qualifications?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportConsultant. */
export type UpdateReportConsultantPayload = {
  __typename?: 'updateReportConsultantPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportConsultant?: Maybe<ReportConsultant>;
};

/** Updates a ReportContact. */
export type UpdateReportContactInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportContact. */
export type UpdateReportContactPayload = {
  __typename?: 'updateReportContactPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportContact?: Maybe<ReportContact>;
};

/** Updates a ReportDeliverableFile. */
export type UpdateReportDeliverableFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportDeliverableFile. */
export type UpdateReportDeliverableFilePayload = {
  __typename?: 'updateReportDeliverableFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportDeliverableFile?: Maybe<ReportDeliverableFile>;
};

/** Updates a ReportEngagementOverview. */
export type UpdateReportEngagementOverviewInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  limitationsAndExclusions?: InputMaybe<Scalars['String']['input']>;
  objectives?: InputMaybe<Scalars['String']['input']>;
  rulesOfEngagement?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportEngagementOverview. */
export type UpdateReportEngagementOverviewPayload = {
  __typename?: 'updateReportEngagementOverviewPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportEngagementOverview?: Maybe<ReportEngagementOverview>;
};

/** Updates a Report. */
export type UpdateReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a Report. */
export type UpdateReportPayload = {
  __typename?: 'updateReportPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

/** Updates a ReportScope. */
export type UpdateReportScopeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  inScope?: InputMaybe<Scalars['String']['input']>;
  outOfScope?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportScope. */
export type UpdateReportScopePayload = {
  __typename?: 'updateReportScopePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportScope?: Maybe<ReportScope>;
};

/** Updates a ReportSection. */
export type UpdateReportSectionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportSection. */
export type UpdateReportSectionPayload = {
  __typename?: 'updateReportSectionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportSection?: Maybe<ReportSection>;
};

/** Updates a ReportTestTypePrerequisite. */
export type UpdateReportTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportTestTypePrerequisite. */
export type UpdateReportTestTypePrerequisitePayload = {
  __typename?: 'updateReportTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportTestTypePrerequisite?: Maybe<ReportTestTypePrerequisite>;
};

/** Updates a ReportUser. */
export type UpdateReportUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  role?: InputMaybe<ReportRole>;
};

/** Updates a ReportUser. */
export type UpdateReportUserPayload = {
  __typename?: 'updateReportUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportUser?: Maybe<ReportUser>;
};

/** Updates a ReportVersion. */
export type UpdateReportVersionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  testApplicationVersion?: InputMaybe<Scalars['String']['input']>;
  testEffortDays?: InputMaybe<Scalars['Int']['input']>;
  testHostname?: InputMaybe<Scalars['String']['input']>;
  testName?: InputMaybe<Scalars['String']['input']>;
  testPerformedFrom?: InputMaybe<Scalars['String']['input']>;
  testPerformedTo?: InputMaybe<Scalars['String']['input']>;
  testServerVersion?: InputMaybe<Scalars['String']['input']>;
  testTypes?: InputMaybe<Array<InputMaybe<TestType>>>;
  versionName?: InputMaybe<Scalars['String']['input']>;
  versionNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportVersion. */
export type UpdateReportVersionPayload = {
  __typename?: 'updateReportVersionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVersion?: Maybe<ReportVersion>;
};

/** Updates a ReportVulnerabilityAction. */
export type UpdateReportVulnerabilityActionInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  clientReference?: InputMaybe<Scalars['String']['input']>;
  dateActioned?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
};

/** Updates a ReportVulnerabilityAction. */
export type UpdateReportVulnerabilityActionPayload = {
  __typename?: 'updateReportVulnerabilityActionPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityAction?: Maybe<ReportVulnerabilityAction>;
};

/** Updates a ReportVulnerabilityFile. */
export type UpdateReportVulnerabilityFileInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** Updates a ReportVulnerabilityFile. */
export type UpdateReportVulnerabilityFilePayload = {
  __typename?: 'updateReportVulnerabilityFilePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerabilityFile?: Maybe<ReportVulnerabilityFile>;
};

/** Updates a ReportVulnerability. */
export type UpdateReportVulnerabilityInput = {
  advice?: InputMaybe<Scalars['String']['input']>;
  affectedHosts?: InputMaybe<Scalars['String']['input']>;
  baseVulnerability?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cveScore?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cwe?: InputMaybe<Scalars['String']['input']>;
  dateDiscovered?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issueDetail?: InputMaybe<Scalars['String']['input']>;
  numberOfIssues?: InputMaybe<Scalars['String']['input']>;
  owaspCategory?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<VulnerabilitySeverity>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a ReportVulnerability. */
export type UpdateReportVulnerabilityPayload = {
  __typename?: 'updateReportVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportVulnerability?: Maybe<ReportVulnerability>;
};

/** Updates a TestTypePrerequisite. */
export type UpdateTestTypePrerequisiteInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** TODO this isn't persisted - just a way to provide a parameter for UpdateTestTypePrerequisiteMutationResolver - a better way might be to use a DTO as the input, but means duplicating the properties here and then applying the DTO to the entity. */
  replacePrevious?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Updates a TestTypePrerequisite. */
export type UpdateTestTypePrerequisitePayload = {
  __typename?: 'updateTestTypePrerequisitePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  testTypePrerequisite?: Maybe<TestTypePrerequisite>;
};

/** Updates a TestingType. */
export type UpdateTestingTypeInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a TestingType. */
export type UpdateTestingTypePayload = {
  __typename?: 'updateTestingTypePayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  testingType?: Maybe<TestingType>;
};

/** Updates a User. */
export type UpdateUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Updates a User. */
export type UpdateUserPayload = {
  __typename?: 'updateUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Updates a Vulnerability. */
export type UpdateVulnerabilityInput = {
  advice?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cveScore?: InputMaybe<Scalars['String']['input']>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
  cvssVector?: InputMaybe<Scalars['String']['input']>;
  cwe?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issueDetail?: InputMaybe<Scalars['String']['input']>;
  owaspCategory?: InputMaybe<Scalars['String']['input']>;
  /** TODO this isn't persisted - just a way to provide a parameter for UpdateVulnerabilityMutationResolver - a better way might be to use a DTO as the input, but means duplicating the properties here and then applying the DTO to the entity. */
  replacePrevious?: InputMaybe<Scalars['Boolean']['input']>;
  severity?: InputMaybe<VulnerabilitySeverity>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Updates a Vulnerability. */
export type UpdateVulnerabilityPayload = {
  __typename?: 'updateVulnerabilityPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  vulnerability?: Maybe<Vulnerability>;
};

/** UploadLogos a Company. */
export type UploadLogoCompanyInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The file to upload */
  file: Scalars['Upload']['input'];
  /** Company ID */
  id: Scalars['ID']['input'];
};

/** UploadLogos a Company. */
export type UploadLogoCompanyPayload = {
  __typename?: 'uploadLogoCompanyPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
};

/** Uploads a ReportMediaObject. */
export type UploadReportMediaObjectInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The file to upload */
  file: Scalars['Upload']['input'];
  /** The report version to associate the file with */
  version: Scalars['ID']['input'];
};

/** Uploads a ReportMediaObject. */
export type UploadReportMediaObjectPayload = {
  __typename?: 'uploadReportMediaObjectPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  reportMediaObject?: Maybe<ReportMediaObject>;
};

/** VerifyEmails a User. */
export type VerifyEmailUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  token: Scalars['String']['input'];
};

/** VerifyEmails a User. */
export type VerifyEmailUserPayload = {
  __typename?: 'verifyEmailUserPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type CompanyContactListFieldsFragment = { __typename?: 'CompanyContact', _id: number, id: string, name: string, permissions?: Array<string> | null };

export type CompanyContactFieldsFragment = { __typename?: 'CompanyContact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string } };

export type CompanyInviteListFieldsFragment = { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null };

export type CompanyInviteFieldsFragment = { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null };

export type CreateCompanyInviteFieldsFragment = { __typename?: 'createCompanyInvitePayloadData', _id: number, id: string, token: string };

export type CompanyLogoFieldsFragment = { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null };

export type CompanyUserListFieldsFragment = { __typename?: 'CompanyUser', _id: number, id: string, role: CompanyRole, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } };

export type CompanyListFieldsFragment = { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null };

export type CompanyFieldsFragment = { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null };

export type ContactListFieldsFragment = { __typename?: 'Contact', _id: number, id: string, name: string, permissions?: Array<string> | null };

export type ContactFieldsFragment = { __typename?: 'Contact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null };

export type ReportAccessInformationCredentialsFieldsFragment = { __typename?: 'ReportAccessInformationCredentials', _id: number, id: string, username?: string | null, password?: string | null, url?: string | null, notes?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string } };

export type ReportAccessInformationFileFieldsFragment = { __typename?: 'ReportAccessInformationFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } };

export type ReportAccessInformationFieldsFragment = { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null };

export type ReportClientListFieldsFragment = { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null };

export type ReportClientFieldsFragment = { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null };

export type ReportConsultantListFieldsFragment = { __typename?: 'ReportConsultant', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null };

export type ReportConsultantFieldsFragment = { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null };

export type ReportContactListFieldsFragment = { __typename?: 'ReportContact', _id: number, id: string, name?: string | null, permissions?: Array<string> | null };

export type ReportContactFieldsFragment = { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null };

export type ReportDeliverableFileFieldsFragment = { __typename?: 'ReportDeliverableFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } };

export type ReportEngagementOverviewFieldsFragment = { __typename?: 'ReportEngagementOverview', _id: number, id: string, objectives: string, rulesOfEngagement: string, limitationsAndExclusions: string, permissions?: Array<string> | null };

export type ReportInviteListFieldsFragment = { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null };

export type ReportInviteFieldsFragment = { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null };

export type CreateReportInviteFieldsFragment = { __typename?: 'createReportInvitePayloadData', _id: number, id: string, token: string };

export type ReportMediaObjectFieldsFragment = { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null };

export type ReportReadReceiptListFieldsFragment = { __typename?: 'ReportReadReceipt', id: string, sectionNumber: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null };

export type ReportScopeFieldsFragment = { __typename?: 'ReportScope', _id: number, id: string, inScope: string, outOfScope: string, permissions?: Array<string> | null };

export type ReportSectionListFieldsFragment = { __typename?: 'ReportSection', id: string, _id: number, identifier: ReportSectionIdentifier, name: string, permissions?: Array<string> | null };

export type ReportSectionFieldsFragment = { __typename?: 'ReportSection', content: string, id: string, _id: number, identifier: ReportSectionIdentifier, name: string, permissions?: Array<string> | null };

export type ReportTestTypePrerequisiteFieldsFragment = { __typename?: 'ReportTestTypePrerequisite', _id: number, id: string, testType: TestType, complete: boolean, description: string, permissions?: Array<string> | null, baseTestTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null };

export type ReportUserListFieldsFragment = { __typename?: 'ReportUser', _id: number, id: string, role: ReportRole, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } };

export type ReportVersionListFieldsFragment = { __typename?: 'ReportVersion', _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string } };

export type ReportVersionFieldsFragment = { __typename?: 'ReportVersion', testName?: string | null, testTypes?: Array<TestType | null> | null, testPerformedFrom?: string | null, testPerformedTo?: string | null, testApplicationVersion?: string | null, testServerVersion?: string | null, testHostname?: string | null, testEffortDays?: number | null, _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, client?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, consultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null, report: { __typename?: 'Report', _id: number, id: string } };

export type ReportVulnerabilityActionListFieldsFragment = { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null };

export type ReportVulnerabilityActionFieldsFragment = { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, files?: { __typename?: 'ReportMediaObjectCursorConnection', pageInfo: { __typename?: 'ReportMediaObjectPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportMediaObjectEdge', node?: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null };

export type ReportVulnerabilityClientNotificationListFieldsFragment = { __typename?: 'ReportVulnerabilityClientNotification', _id: number, id: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null };

export type ReportVulnerabilityCommentFieldsFragment = { __typename?: 'ReportVulnerabilityComment', _id: number, id: string, message: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null };

export type ReportVulnerabilityFileFieldsFragment = { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } };

export type ReportVulnerabilityRetestRequestListFieldsFragment = { __typename?: 'ReportVulnerabilityRetestRequest', _id: number, id: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null };

export type ReportVulnerabilityListFieldsFragment = { __typename?: 'ReportVulnerability', _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } };

export type ReportVulnerabilityFieldsFragment = { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } };

export type ReportListFieldsFragment = { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null };

export type TestTypePrerequisiteFieldsFragment = { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null };

export type TestingTypeListFieldsFragment = { __typename?: 'TestingType', _id: number, id: string, name: string, permissions?: Array<string> | null };

export type TestingTypeFieldsFragment = { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null };

export type UserNotificationFieldsFragment = { __typename?: 'UserNotification', _id: number, id: string, message: string, type: UserNotificationType, data?: any | null, createdAt?: string | null, readAt?: string | null, permissions?: Array<string> | null };

export type UserListFieldsFragment = { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null };

export type UserFieldsFragment = { __typename?: 'User', roles?: Array<string> | null, _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null };

export type VulnerabilityListFieldsFragment = { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null };

export type VulnerabilityFieldsFragment = { __typename?: 'Vulnerability', cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, advice?: string | null, _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null };

export type CreateCompanyContactMutationVariables = Exact<{
  input: CreateCompanyContactInput;
}>;


export type CreateCompanyContactMutation = { __typename?: 'Mutation', createCompanyContact?: { __typename?: 'createCompanyContactPayload', companyContact?: { __typename?: 'CompanyContact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string } } | null } | null };

export type UpdateCompanyContactMutationVariables = Exact<{
  input: UpdateCompanyContactInput;
}>;


export type UpdateCompanyContactMutation = { __typename?: 'Mutation', updateCompanyContact?: { __typename?: 'updateCompanyContactPayload', companyContact?: { __typename?: 'CompanyContact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string } } | null } | null };

export type DeleteCompanyContactMutationVariables = Exact<{
  input: DeleteCompanyContactInput;
}>;


export type DeleteCompanyContactMutation = { __typename?: 'Mutation', deleteCompanyContact?: { __typename: 'deleteCompanyContactPayload' } | null };

export type CreateCompanyInviteMutationVariables = Exact<{
  input: CreateCompanyInviteInput;
}>;


export type CreateCompanyInviteMutation = { __typename?: 'Mutation', createCompanyInvite?: { __typename?: 'createCompanyInvitePayload', companyInvite?: { __typename?: 'createCompanyInvitePayloadData', _id: number, id: string, token: string } | null } | null };

export type AcceptCompanyInviteMutationVariables = Exact<{
  input: AcceptCompanyInviteInput;
}>;


export type AcceptCompanyInviteMutation = { __typename?: 'Mutation', acceptCompanyInvite?: { __typename?: 'acceptCompanyInvitePayload', companyInvite?: { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type ResendCompanyInviteMutationVariables = Exact<{
  input: ResendCompanyInviteInput;
}>;


export type ResendCompanyInviteMutation = { __typename?: 'Mutation', resendCompanyInvite?: { __typename?: 'resendCompanyInvitePayload', companyInvite?: { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type DeleteCompanyInviteMutationVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type DeleteCompanyInviteMutation = { __typename?: 'Mutation', deleteCompanyInvite?: { __typename: 'deleteCompanyInvitePayload' } | null };

export type UpdateCompanyUserMutationVariables = Exact<{
  input: UpdateCompanyUserInput;
}>;


export type UpdateCompanyUserMutation = { __typename?: 'Mutation', updateCompanyUser?: { __typename?: 'updateCompanyUserPayload', companyUser?: { __typename?: 'CompanyUser', _id: number, id: string, role: CompanyRole, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } } | null } | null };

export type CreateCompanyMutationVariables = Exact<{
  input: CreateCompanyInput;
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany?: { __typename?: 'createCompanyPayload', company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  input: UpdateCompanyInput;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany?: { __typename?: 'updateCompanyPayload', company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null };

export type DeleteCompanyMutationVariables = Exact<{
  input: DeleteCompanyInput;
}>;


export type DeleteCompanyMutation = { __typename?: 'Mutation', deleteCompany?: { __typename: 'deleteCompanyPayload' } | null };

export type AddUserToCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: CompanyRole;
}>;


export type AddUserToCompanyMutation = { __typename?: 'Mutation', addUserToCompany?: { __typename?: 'addUserToCompanyPayload', company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null };

export type RemoveUserFromCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromCompanyMutation = { __typename?: 'Mutation', removeUserFromCompany?: { __typename?: 'removeUserFromCompanyPayload', company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null };

export type UploadCompanyLogoMutationVariables = Exact<{
  input: UploadLogoCompanyInput;
}>;


export type UploadCompanyLogoMutation = { __typename?: 'Mutation', uploadLogoCompany?: { __typename?: 'uploadLogoCompanyPayload', company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null };

export type CreateContactMutationVariables = Exact<{
  input: CreateContactInput;
}>;


export type CreateContactMutation = { __typename?: 'Mutation', createContact?: { __typename?: 'createContactPayload', contact?: { __typename?: 'Contact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null };

export type UpdateContactMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'updateContactPayload', contact?: { __typename?: 'Contact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null };

export type DeleteContactMutationVariables = Exact<{
  input: DeleteContactInput;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact?: { __typename: 'deleteContactPayload' } | null };

export type CreateReportAccessInformationCredentialsMutationVariables = Exact<{
  input: CreateReportAccessInformationCredentialsInput;
}>;


export type CreateReportAccessInformationCredentialsMutation = { __typename?: 'Mutation', createReportAccessInformationCredentials?: { __typename?: 'createReportAccessInformationCredentialsPayload', reportAccessInformationCredentials?: { __typename?: 'ReportAccessInformationCredentials', _id: number, id: string, username?: string | null, password?: string | null, url?: string | null, notes?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string } } | null } | null };

export type UpdateReportAccessInformationCredentialsMutationVariables = Exact<{
  input: UpdateReportAccessInformationCredentialsInput;
}>;


export type UpdateReportAccessInformationCredentialsMutation = { __typename?: 'Mutation', updateReportAccessInformationCredentials?: { __typename?: 'updateReportAccessInformationCredentialsPayload', reportAccessInformationCredentials?: { __typename?: 'ReportAccessInformationCredentials', _id: number, id: string, username?: string | null, password?: string | null, url?: string | null, notes?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string } } | null } | null };

export type DeleteReportAccessInformationCredentialsMutationVariables = Exact<{
  input: DeleteReportAccessInformationCredentialsInput;
}>;


export type DeleteReportAccessInformationCredentialsMutation = { __typename?: 'Mutation', deleteReportAccessInformationCredentials?: { __typename: 'deleteReportAccessInformationCredentialsPayload' } | null };

export type CreateReportAccessInformationFileMutationVariables = Exact<{
  input: CreateReportAccessInformationFileInput;
}>;


export type CreateReportAccessInformationFileMutation = { __typename?: 'Mutation', createReportAccessInformationFile?: { __typename?: 'createReportAccessInformationFilePayload', reportAccessInformationFile?: { __typename?: 'ReportAccessInformationFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null };

export type UpdateReportAccessInformationFileMutationVariables = Exact<{
  input: UpdateReportAccessInformationFileInput;
}>;


export type UpdateReportAccessInformationFileMutation = { __typename?: 'Mutation', updateReportAccessInformationFile?: { __typename?: 'updateReportAccessInformationFilePayload', reportAccessInformationFile?: { __typename?: 'ReportAccessInformationFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null };

export type DeleteReportAccessInformationFileMutationVariables = Exact<{
  input: DeleteReportAccessInformationFileInput;
}>;


export type DeleteReportAccessInformationFileMutation = { __typename?: 'Mutation', deleteReportAccessInformationFile?: { __typename: 'deleteReportAccessInformationFilePayload' } | null };

export type UpdateReportAccessInformationMutationVariables = Exact<{
  input: UpdateReportAccessInformationInput;
}>;


export type UpdateReportAccessInformationMutation = { __typename?: 'Mutation', updateReportAccessInformation?: { __typename?: 'updateReportAccessInformationPayload', reportAccessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null } | null } | null };

export type UpdateReportClientMutationVariables = Exact<{
  input: UpdateReportClientInput;
}>;


export type UpdateReportClientMutation = { __typename?: 'Mutation', updateReportClient?: { __typename?: 'updateReportClientPayload', reportClient?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null } | null };

export type UpdateReportConsultantMutationVariables = Exact<{
  input: UpdateReportConsultantInput;
}>;


export type UpdateReportConsultantMutation = { __typename?: 'Mutation', updateReportConsultant?: { __typename?: 'updateReportConsultantPayload', reportConsultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null } | null };

export type UpdateReportContactMutationVariables = Exact<{
  input: UpdateReportContactInput;
}>;


export type UpdateReportContactMutation = { __typename?: 'Mutation', updateReportContact?: { __typename?: 'updateReportContactPayload', reportContact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null };

export type CreateReportDeliverableFileMutationVariables = Exact<{
  input: CreateReportDeliverableFileInput;
}>;


export type CreateReportDeliverableFileMutation = { __typename?: 'Mutation', createReportDeliverableFile?: { __typename?: 'createReportDeliverableFilePayload', reportDeliverableFile?: { __typename?: 'ReportDeliverableFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null };

export type UpdateReportDeliverableFileMutationVariables = Exact<{
  input: UpdateReportDeliverableFileInput;
}>;


export type UpdateReportDeliverableFileMutation = { __typename?: 'Mutation', updateReportDeliverableFile?: { __typename?: 'updateReportDeliverableFilePayload', reportDeliverableFile?: { __typename?: 'ReportDeliverableFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null };

export type DeleteReportDeliverableFileMutationVariables = Exact<{
  input: DeleteReportDeliverableFileInput;
}>;


export type DeleteReportDeliverableFileMutation = { __typename?: 'Mutation', deleteReportDeliverableFile?: { __typename: 'deleteReportDeliverableFilePayload' } | null };

export type UpdateReportEngagementOverviewMutationVariables = Exact<{
  input: UpdateReportEngagementOverviewInput;
}>;


export type UpdateReportEngagementOverviewMutation = { __typename?: 'Mutation', updateReportEngagementOverview?: { __typename?: 'updateReportEngagementOverviewPayload', reportEngagementOverview?: { __typename?: 'ReportEngagementOverview', _id: number, id: string, objectives: string, rulesOfEngagement: string, limitationsAndExclusions: string, permissions?: Array<string> | null } | null } | null };

export type CreateReportInviteMutationVariables = Exact<{
  input: CreateReportInviteInput;
}>;


export type CreateReportInviteMutation = { __typename?: 'Mutation', createReportInvite?: { __typename?: 'createReportInvitePayload', reportInvite?: { __typename?: 'createReportInvitePayloadData', _id: number, id: string, token: string } | null } | null };

export type AcceptReportInviteMutationVariables = Exact<{
  input: AcceptReportInviteInput;
}>;


export type AcceptReportInviteMutation = { __typename?: 'Mutation', acceptReportInvite?: { __typename?: 'acceptReportInvitePayload', reportInvite?: { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type ResendReportInviteMutationVariables = Exact<{
  input: ResendReportInviteInput;
}>;


export type ResendReportInviteMutation = { __typename?: 'Mutation', resendReportInvite?: { __typename?: 'resendReportInvitePayload', reportInvite?: { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type DeleteReportInviteMutationVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type DeleteReportInviteMutation = { __typename?: 'Mutation', deleteReportInvite?: { __typename: 'deleteReportInvitePayload' } | null };

export type UploadReportMediaObjectMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
  versionId: Scalars['ID']['input'];
}>;


export type UploadReportMediaObjectMutation = { __typename?: 'Mutation', uploadReportMediaObject?: { __typename?: 'uploadReportMediaObjectPayload', reportMediaObject?: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } | null } | null };

export type CreateReportReadReceiptMutationVariables = Exact<{
  input: CreateReportReadReceiptInput;
}>;


export type CreateReportReadReceiptMutation = { __typename?: 'Mutation', createReportReadReceipt?: { __typename?: 'createReportReadReceiptPayload', reportReadReceipt?: { __typename?: 'ReportReadReceipt', id: string, sectionNumber: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type UpdateReportScopeMutationVariables = Exact<{
  input: UpdateReportScopeInput;
}>;


export type UpdateReportScopeMutation = { __typename?: 'Mutation', updateReportScope?: { __typename?: 'updateReportScopePayload', reportScope?: { __typename?: 'ReportScope', _id: number, id: string, inScope: string, outOfScope: string, permissions?: Array<string> | null } | null } | null };

export type UpdateReportSectionMutationVariables = Exact<{
  input: UpdateReportSectionInput;
}>;


export type UpdateReportSectionMutation = { __typename?: 'Mutation', updateReportSection?: { __typename?: 'updateReportSectionPayload', reportSection?: { __typename?: 'ReportSection', content: string, id: string, _id: number, identifier: ReportSectionIdentifier, name: string, permissions?: Array<string> | null } | null } | null };

export type CreateReportTestTypePrerequisiteMutationVariables = Exact<{
  input: CreateReportTestTypePrerequisiteInput;
}>;


export type CreateReportTestTypePrerequisiteMutation = { __typename?: 'Mutation', createReportTestTypePrerequisite?: { __typename?: 'createReportTestTypePrerequisitePayload', reportTestTypePrerequisite?: { __typename?: 'ReportTestTypePrerequisite', _id: number, id: string, testType: TestType, complete: boolean, description: string, permissions?: Array<string> | null, baseTestTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null } | null };

export type UpdateReportTestTypePrerequisiteMutationVariables = Exact<{
  input: UpdateReportTestTypePrerequisiteInput;
}>;


export type UpdateReportTestTypePrerequisiteMutation = { __typename?: 'Mutation', updateReportTestTypePrerequisite?: { __typename?: 'updateReportTestTypePrerequisitePayload', reportTestTypePrerequisite?: { __typename?: 'ReportTestTypePrerequisite', _id: number, id: string, testType: TestType, complete: boolean, description: string, permissions?: Array<string> | null, baseTestTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null } | null };

export type DeleteReportTestTypePrerequisiteMutationVariables = Exact<{
  input: DeleteReportTestTypePrerequisiteInput;
}>;


export type DeleteReportTestTypePrerequisiteMutation = { __typename?: 'Mutation', deleteReportTestTypePrerequisite?: { __typename: 'deleteReportTestTypePrerequisitePayload' } | null };

export type CompleteReportTestTypePrerequisiteMutationVariables = Exact<{
  input: CompleteReportTestTypePrerequisiteInput;
}>;


export type CompleteReportTestTypePrerequisiteMutation = { __typename?: 'Mutation', completeReportTestTypePrerequisite?: { __typename?: 'completeReportTestTypePrerequisitePayload', reportTestTypePrerequisite?: { __typename?: 'ReportTestTypePrerequisite', _id: number, id: string, testType: TestType, complete: boolean, description: string, permissions?: Array<string> | null, baseTestTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null } | null };

export type UpdateReportUserMutationVariables = Exact<{
  input: UpdateReportUserInput;
}>;


export type UpdateReportUserMutation = { __typename?: 'Mutation', updateReportUser?: { __typename?: 'updateReportUserPayload', reportUser?: { __typename?: 'ReportUser', _id: number, id: string, role: ReportRole, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } } | null } | null };

export type UpdateReportVersionMutationVariables = Exact<{
  input: UpdateReportVersionInput;
}>;


export type UpdateReportVersionMutation = { __typename?: 'Mutation', updateReportVersion?: { __typename?: 'updateReportVersionPayload', reportVersion?: { __typename?: 'ReportVersion', testName?: string | null, testTypes?: Array<TestType | null> | null, testPerformedFrom?: string | null, testPerformedTo?: string | null, testApplicationVersion?: string | null, testServerVersion?: string | null, testHostname?: string | null, testEffortDays?: number | null, _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, client?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, consultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null, report: { __typename?: 'Report', _id: number, id: string } } | null } | null };

export type TransitionReportVersionStatusMutationVariables = Exact<{
  reportVersionId: Scalars['ID']['input'];
  transition: ReportVersionTransition;
}>;


export type TransitionReportVersionStatusMutation = { __typename?: 'Mutation', transitionReportVersion?: { __typename?: 'transitionReportVersionPayload', reportVersion?: { __typename?: 'ReportVersion', testName?: string | null, testTypes?: Array<TestType | null> | null, testPerformedFrom?: string | null, testPerformedTo?: string | null, testApplicationVersion?: string | null, testServerVersion?: string | null, testHostname?: string | null, testEffortDays?: number | null, _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, client?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, consultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null, report: { __typename?: 'Report', _id: number, id: string } } | null } | null };

export type SendCustomReportVersionEmailMutationVariables = Exact<{
  input: SendCustomEmailReportVersionInput;
}>;


export type SendCustomReportVersionEmailMutation = { __typename?: 'Mutation', sendCustomEmailReportVersion?: { __typename?: 'sendCustomEmailReportVersionPayload', clientMutationId?: string | null } | null };

export type SendDailyTestCommencementEmailMutationVariables = Exact<{
  reportVersionId: Scalars['ID']['input'];
}>;


export type SendDailyTestCommencementEmailMutation = { __typename?: 'Mutation', sendDailyTestCommencementEmailReportVersion?: { __typename?: 'sendDailyTestCommencementEmailReportVersionPayload', clientMutationId?: string | null } | null };

export type SendDailyTestCompletionEmailMutationVariables = Exact<{
  reportVersionId: Scalars['ID']['input'];
}>;


export type SendDailyTestCompletionEmailMutation = { __typename?: 'Mutation', sendDailyTestCompletionEmailReportVersion?: { __typename?: 'sendDailyTestCompletionEmailReportVersionPayload', clientMutationId?: string | null } | null };

export type SendPrerequisitesRequestInformationEmailMutationVariables = Exact<{
  reportVersionId: Scalars['ID']['input'];
}>;


export type SendPrerequisitesRequestInformationEmailMutation = { __typename?: 'Mutation', sendPrerequisitesRequestInformationEmailReportVersion?: { __typename?: 'sendPrerequisitesRequestInformationEmailReportVersionPayload', clientMutationId?: string | null } | null };

export type SendScopeRequestInformationEmailMutationVariables = Exact<{
  reportVersionId: Scalars['ID']['input'];
}>;


export type SendScopeRequestInformationEmailMutation = { __typename?: 'Mutation', sendScopeRequestInformationEmailReportVersion?: { __typename?: 'sendScopeRequestInformationEmailReportVersionPayload', clientMutationId?: string | null } | null };

export type CreateReportVulnerabilityActionMutationVariables = Exact<{
  input: CreateReportVulnerabilityActionInput;
}>;


export type CreateReportVulnerabilityActionMutation = { __typename?: 'Mutation', createReportVulnerabilityAction?: { __typename?: 'createReportVulnerabilityActionPayload', reportVulnerabilityAction?: { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, files?: { __typename?: 'ReportMediaObjectCursorConnection', pageInfo: { __typename?: 'ReportMediaObjectPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportMediaObjectEdge', node?: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null } | null };

export type UpdateReportVulnerabilityActionMutationVariables = Exact<{
  input: UpdateReportVulnerabilityActionInput;
}>;


export type UpdateReportVulnerabilityActionMutation = { __typename?: 'Mutation', updateReportVulnerabilityAction?: { __typename?: 'updateReportVulnerabilityActionPayload', reportVulnerabilityAction?: { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, files?: { __typename?: 'ReportMediaObjectCursorConnection', pageInfo: { __typename?: 'ReportMediaObjectPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportMediaObjectEdge', node?: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null } | null };

export type DeleteReportVulnerabilityActionMutationVariables = Exact<{
  actionId: Scalars['ID']['input'];
}>;


export type DeleteReportVulnerabilityActionMutation = { __typename?: 'Mutation', deleteReportVulnerabilityAction?: { __typename: 'deleteReportVulnerabilityActionPayload' } | null };

export type CreateReportVulnerabilityClientNotificationMutationVariables = Exact<{
  input: CreateReportVulnerabilityClientNotificationInput;
}>;


export type CreateReportVulnerabilityClientNotificationMutation = { __typename?: 'Mutation', createReportVulnerabilityClientNotification?: { __typename?: 'createReportVulnerabilityClientNotificationPayload', reportVulnerabilityClientNotification?: { __typename?: 'ReportVulnerabilityClientNotification', _id: number, id: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type CreateReportVulnerabilityCommentMutationVariables = Exact<{
  input: CreateReportVulnerabilityCommentInput;
}>;


export type CreateReportVulnerabilityCommentMutation = { __typename?: 'Mutation', createReportVulnerabilityComment?: { __typename?: 'createReportVulnerabilityCommentPayload', reportVulnerabilityComment?: { __typename?: 'ReportVulnerabilityComment', _id: number, id: string, message: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type DeleteReportVulnerabilityCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type DeleteReportVulnerabilityCommentMutation = { __typename?: 'Mutation', deleteReportVulnerabilityComment?: { __typename: 'deleteReportVulnerabilityCommentPayload' } | null };

export type CreateReportVulnerabilityFileMutationVariables = Exact<{
  input: CreateReportVulnerabilityFileInput;
}>;


export type CreateReportVulnerabilityFileMutation = { __typename?: 'Mutation', createReportVulnerabilityFile?: { __typename?: 'createReportVulnerabilityFilePayload', reportVulnerabilityFile?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null };

export type UpdateReportVulnerabilityFileMutationVariables = Exact<{
  input: UpdateReportVulnerabilityFileInput;
}>;


export type UpdateReportVulnerabilityFileMutation = { __typename?: 'Mutation', updateReportVulnerabilityFile?: { __typename?: 'updateReportVulnerabilityFilePayload', reportVulnerabilityFile?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null };

export type DeleteReportVulnerabilityFileMutationVariables = Exact<{
  input: DeleteReportVulnerabilityFileInput;
}>;


export type DeleteReportVulnerabilityFileMutation = { __typename?: 'Mutation', deleteReportVulnerabilityFile?: { __typename: 'deleteReportVulnerabilityFilePayload' } | null };

export type CreateReportVulnerabilityRetestRequestMutationVariables = Exact<{
  input: CreateReportVulnerabilityRetestRequestInput;
}>;


export type CreateReportVulnerabilityRetestRequestMutation = { __typename?: 'Mutation', createReportVulnerabilityRetestRequest?: { __typename?: 'createReportVulnerabilityRetestRequestPayload', reportVulnerabilityRetestRequest?: { __typename?: 'ReportVulnerabilityRetestRequest', _id: number, id: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null };

export type CreateReportVulnerabilityMutationVariables = Exact<{
  input: CreateReportVulnerabilityInput;
}>;


export type CreateReportVulnerabilityMutation = { __typename?: 'Mutation', createReportVulnerability?: { __typename?: 'createReportVulnerabilityPayload', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null };

export type UpdateReportVulnerabilityMutationVariables = Exact<{
  input: UpdateReportVulnerabilityInput;
}>;


export type UpdateReportVulnerabilityMutation = { __typename?: 'Mutation', updateReportVulnerability?: { __typename?: 'updateReportVulnerabilityPayload', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null };

export type ResolveReportVulnerabilityMutationVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  dateResolved: Scalars['String']['input'];
}>;


export type ResolveReportVulnerabilityMutation = { __typename?: 'Mutation', transitionReportVulnerability?: { __typename?: 'transitionReportVulnerabilityPayload', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null };

export type AcceptReportVulnerabilityRiskMutationVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
}>;


export type AcceptReportVulnerabilityRiskMutation = { __typename?: 'Mutation', transitionReportVulnerability?: { __typename?: 'transitionReportVulnerabilityPayload', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null };

export type ReopenReportVulnerabilityMutationVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  reopenedReason: Scalars['String']['input'];
}>;


export type ReopenReportVulnerabilityMutation = { __typename?: 'Mutation', transitionReportVulnerability?: { __typename?: 'transitionReportVulnerabilityPayload', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null };

export type VerifyResolvedVulnerabilityRiskMutationVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
}>;


export type VerifyResolvedVulnerabilityRiskMutation = { __typename?: 'Mutation', transitionReportVulnerability?: { __typename?: 'transitionReportVulnerabilityPayload', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null };

export type DeleteReportVulnerabilityMutationVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
}>;


export type DeleteReportVulnerabilityMutation = { __typename?: 'Mutation', deleteReportVulnerability?: { __typename: 'deleteReportVulnerabilityPayload' } | null };

export type CreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'createReportPayload', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null, versions?: { __typename?: 'ReportVersionCursorConnection', pageInfo: { __typename?: 'ReportVersionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVersionEdge', node?: { __typename?: 'ReportVersion', _id: number, id: string } | null } | null> | null } | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null } | null };

export type UpdateReportMutationVariables = Exact<{
  input: UpdateReportInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport?: { __typename?: 'updateReportPayload', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null } | null } | null };

export type DeleteReportMutationVariables = Exact<{
  input: DeleteReportInput;
}>;


export type DeleteReportMutation = { __typename?: 'Mutation', deleteReport?: { __typename: 'deleteReportPayload' } | null };

export type NewVersionOfReportMutationVariables = Exact<{
  input: NewVersionOfReportInput;
}>;


export type NewVersionOfReportMutation = { __typename?: 'Mutation', newVersionOfReport?: { __typename?: 'newVersionOfReportPayload', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null, versions?: { __typename?: 'ReportVersionCursorConnection', pageInfo: { __typename?: 'ReportVersionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVersionEdge', node?: { __typename?: 'ReportVersion', _id: number, id: string } | null } | null> | null } | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null } | null };

export type AddUserToReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: ReportRole;
}>;


export type AddUserToReportMutation = { __typename?: 'Mutation', addUserToReport?: { __typename?: 'addUserToReportPayload', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null } | null } | null };

export type AddCompanyUserToReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  companyUserId: Scalars['ID']['input'];
  role: ReportRole;
}>;


export type AddCompanyUserToReportMutation = { __typename?: 'Mutation', addCompanyUserToReport?: { __typename?: 'addCompanyUserToReportPayload', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null } | null } | null };

export type RemoveUserFromReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveUserFromReportMutation = { __typename?: 'Mutation', removeUserFromReport?: { __typename?: 'removeUserFromReportPayload', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null } | null } | null };

export type CreateTestTypePrerequisiteMutationVariables = Exact<{
  input: CreateTestTypePrerequisiteInput;
}>;


export type CreateTestTypePrerequisiteMutation = { __typename?: 'Mutation', createTestTypePrerequisite?: { __typename?: 'createTestTypePrerequisitePayload', testTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null };

export type UpdateTestTypePrerequisiteMutationVariables = Exact<{
  input: UpdateTestTypePrerequisiteInput;
}>;


export type UpdateTestTypePrerequisiteMutation = { __typename?: 'Mutation', updateTestTypePrerequisite?: { __typename?: 'updateTestTypePrerequisitePayload', testTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null };

export type DeleteAllVersionsOfTestTypePrerequisiteMutationVariables = Exact<{
  input: DeleteAllVersionsOfTestTypePrerequisiteInput;
}>;


export type DeleteAllVersionsOfTestTypePrerequisiteMutation = { __typename?: 'Mutation', deleteAllVersionsOfTestTypePrerequisite?: { __typename: 'deleteAllVersionsOfTestTypePrerequisitePayload' } | null };

export type CreateTestingTypeMutationVariables = Exact<{
  input: CreateTestingTypeInput;
}>;


export type CreateTestingTypeMutation = { __typename?: 'Mutation', createTestingType?: { __typename?: 'createTestingTypePayload', testingType?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null };

export type UpdateTestingTypeMutationVariables = Exact<{
  input: UpdateTestingTypeInput;
}>;


export type UpdateTestingTypeMutation = { __typename?: 'Mutation', updateTestingType?: { __typename?: 'updateTestingTypePayload', testingType?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null };

export type DeleteTestingTypeMutationVariables = Exact<{
  input: DeleteTestingTypeInput;
}>;


export type DeleteTestingTypeMutation = { __typename?: 'Mutation', deleteTestingType?: { __typename: 'deleteTestingTypePayload' } | null };

export type CreateUserMobileNumberChangeRequestMutationVariables = Exact<{
  input: CreateUserMobileNumberChangeRequestInput;
}>;


export type CreateUserMobileNumberChangeRequestMutation = { __typename?: 'Mutation', createUserMobileNumberChangeRequest?: { __typename?: 'createUserMobileNumberChangeRequestPayload', userMobileNumberChangeRequest?: { __typename?: 'createUserMobileNumberChangeRequestPayloadData', _id: number, id: string } | null } | null };

export type ApplyUserMobileNumberChangeRequestMutationVariables = Exact<{
  input: ApplyUserMobileNumberChangeRequestInput;
}>;


export type ApplyUserMobileNumberChangeRequestMutation = { __typename?: 'Mutation', applyUserMobileNumberChangeRequest?: { __typename?: 'applyUserMobileNumberChangeRequestPayload', userMobileNumberChangeRequest?: { __typename?: 'UserMobileNumberChangeRequest', _id: number, id: string } | null } | null };

export type MarkReadUserNotificationMutationVariables = Exact<{
  input: MarkReadUserNotificationInput;
}>;


export type MarkReadUserNotificationMutation = { __typename?: 'Mutation', markReadUserNotification?: { __typename?: 'markReadUserNotificationPayload', userNotification?: { __typename?: 'UserNotification', _id: number, id: string, message: string, type: UserNotificationType, data?: any | null, createdAt?: string | null, readAt?: string | null, permissions?: Array<string> | null } | null } | null };

export type CreateUserPasswordResetRequsetMutationVariables = Exact<{
  input: CreateUserPasswordResetRequestInput;
}>;


export type CreateUserPasswordResetRequsetMutation = { __typename?: 'Mutation', createUserPasswordResetRequest?: { __typename?: 'createUserPasswordResetRequestPayload', userPasswordResetRequest?: { __typename?: 'createUserPasswordResetRequestPayloadData', id: string } | null } | null };

export type RegisterUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type RegisterUserMutation = { __typename?: 'Mutation', createUser?: { __typename: 'createUserPayload' } | null };

export type ResetUserPasswordMutationVariables = Exact<{
  input: ResetPasswordUserInput;
}>;


export type ResetUserPasswordMutation = { __typename?: 'Mutation', resetPasswordUser?: { __typename?: 'resetPasswordUserPayload', user?: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } | null } | null };

export type VerifyUserEmailMutationVariables = Exact<{
  input: VerifyEmailUserInput;
}>;


export type VerifyUserEmailMutation = { __typename?: 'Mutation', verifyEmailUser?: { __typename?: 'verifyEmailUserPayload', user?: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'updateUserPayload', user?: { __typename?: 'User', roles?: Array<string> | null, _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } | null } | null };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: { __typename: 'deleteUserPayload' } | null };

export type CreateVulnerabilityMutationVariables = Exact<{
  input: CreateVulnerabilityInput;
}>;


export type CreateVulnerabilityMutation = { __typename?: 'Mutation', createVulnerability?: { __typename?: 'createVulnerabilityPayload', vulnerability?: { __typename?: 'Vulnerability', cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, advice?: string | null, _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null } | null } | null };

export type UpdateVulnerabilityMutationVariables = Exact<{
  input: UpdateVulnerabilityInput;
}>;


export type UpdateVulnerabilityMutation = { __typename?: 'Mutation', updateVulnerability?: { __typename?: 'updateVulnerabilityPayload', vulnerability?: { __typename?: 'Vulnerability', cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, advice?: string | null, _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null } | null } | null };

export type DeleteAllVersionsOfVulnerabilityMutationVariables = Exact<{
  input: DeleteAllVersionsOfVulnerabilityInput;
}>;


export type DeleteAllVersionsOfVulnerabilityMutation = { __typename?: 'Mutation', deleteAllVersionsOfVulnerability?: { __typename: 'deleteAllVersionsOfVulnerabilityPayload' } | null };

export type CompanyContactQueryVariables = Exact<{
  companyContactId: Scalars['ID']['input'];
}>;


export type CompanyContactQuery = { __typename?: 'Query', companyContact?: { __typename?: 'CompanyContact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string } } | null };

export type CompanyInviteQueryVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type CompanyInviteQuery = { __typename?: 'Query', companyInvite?: { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null };

export type CompanyInviteByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type CompanyInviteByTokenQuery = { __typename?: 'Query', retrieveCompanyInvite?: { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } } | null };

export type CompanyUserQueryVariables = Exact<{
  companyUserId: Scalars['ID']['input'];
}>;


export type CompanyUserQuery = { __typename?: 'Query', companyUser?: { __typename?: 'CompanyUser', _id: number, id: string, role: CompanyRole, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } } | null };

export type CompanyListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<CompanyFilter_Order>;
}>;


export type CompanyListQuery = { __typename?: 'Query', companies?: { __typename?: 'CompanyCursorConnection', pageInfo: { __typename?: 'CompanyPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'CompanyEdge', node?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null> | null } | null };

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null };

export type CompanyUsersQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyUsersQuery = { __typename?: 'Query', company?: { __typename?: 'Company', _id: number, id: string, users?: { __typename?: 'CompanyUserCursorConnection', pageInfo: { __typename?: 'CompanyUserPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'CompanyUserEdge', node?: { __typename?: 'CompanyUser', _id: number, id: string, role: CompanyRole, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } } | null } | null> | null } | null } | null };

export type CompanyReportsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportFilter_Order>;
}>;


export type CompanyReportsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', _id: number, id: string, reports?: { __typename?: 'ReportCursorConnection', pageInfo: { __typename?: 'ReportPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportEdge', node?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null } | null } | null> | null } | null } | null };

export type CompanyInvitesListQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyInvitesListQuery = { __typename?: 'Query', company?: { __typename?: 'Company', _id: number, id: string, invites?: { __typename?: 'CompanyInviteCursorConnection', pageInfo: { __typename?: 'CompanyInvitePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'CompanyInviteEdge', node?: { __typename?: 'CompanyInvite', id: string, _id: number, role: CompanyRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type CompanyContactsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CompanyContactsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', _id: number, id: string, contacts?: { __typename?: 'CompanyContactCursorConnection', pageInfo: { __typename?: 'CompanyContactPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'CompanyContactEdge', node?: { __typename?: 'CompanyContact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null, company: { __typename?: 'Company', _id: number, id: string } } | null } | null> | null } | null } | null };

export type PublishedCompanyReportVulnerabilitiesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateDiscovered?: InputMaybe<ReportVulnerabilityFilter_DateDiscovered>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishedCompanyReportVulnerabilitiesQuery = { __typename?: 'Query', publishedCompanyReportVulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null };

export type PublishedCompanyReportVulnerabilitiesListQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportVulnerabilityFilter_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateDiscovered?: InputMaybe<ReportVulnerabilityFilter_DateDiscovered>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishedCompanyReportVulnerabilitiesListQuery = { __typename?: 'Query', publishedCompanyReportVulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null };

export type ContactQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', contact?: { __typename?: 'Contact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null };

export type ContactListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactListQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactCursorConnection', pageInfo: { __typename?: 'ContactPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ContactEdge', node?: { __typename?: 'Contact', _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null };

export type ContactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactsQuery = { __typename?: 'Query', contacts?: { __typename?: 'ContactCursorConnection', pageInfo: { __typename?: 'ContactPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ContactEdge', node?: { __typename?: 'Contact', address?: string | null, companyName?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null };

export type ReportAccessInformationCredentialsQueryVariables = Exact<{
  credentialsId: Scalars['ID']['input'];
}>;


export type ReportAccessInformationCredentialsQuery = { __typename?: 'Query', reportAccessInformationCredentials?: { __typename?: 'ReportAccessInformationCredentials', _id: number, id: string, username?: string | null, password?: string | null, url?: string | null, notes?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string } } | null };

export type ReportVersionAccessInformationCredentialsQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionAccessInformationCredentialsQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, accessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null, credentials?: { __typename?: 'ReportAccessInformationCredentialsCursorConnection', pageInfo: { __typename?: 'ReportAccessInformationCredentialsPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportAccessInformationCredentialsEdge', node?: { __typename?: 'ReportAccessInformationCredentials', _id: number, id: string, username?: string | null, password?: string | null, url?: string | null, notes?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string } } | null } | null> | null } | null } | null } | null };

export type ReportVersionAccessInformationFilesQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionAccessInformationFilesQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, accessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null, files?: { __typename?: 'ReportAccessInformationFileCursorConnection', pageInfo: { __typename?: 'ReportAccessInformationFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportAccessInformationFileEdge', node?: { __typename?: 'ReportAccessInformationFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null } | null } | null };

export type ReportAccessInformationFileQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type ReportAccessInformationFileQuery = { __typename?: 'Query', reportAccessInformationFile?: { __typename?: 'ReportAccessInformationFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, accessInformation: { __typename?: 'ReportAccessInformation', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null };

export type ReportAccessInformationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportAccessInformationQuery = { __typename?: 'Query', reportAccessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null } | null };

export type ReportConsultantQueryVariables = Exact<{
  consultantId: Scalars['ID']['input'];
}>;


export type ReportConsultantQuery = { __typename?: 'Query', reportConsultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null };

export type ReportContactQueryVariables = Exact<{
  contactId: Scalars['ID']['input'];
}>;


export type ReportContactQuery = { __typename?: 'Query', reportContact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null };

export type ReportDeliverableFileQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type ReportDeliverableFileQuery = { __typename?: 'Query', reportDeliverableFile?: { __typename?: 'ReportDeliverableFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null };

export type ReportEngagementOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportEngagementOverviewQuery = { __typename?: 'Query', reportEngagementOverview?: { __typename?: 'ReportEngagementOverview', _id: number, id: string, objectives: string, rulesOfEngagement: string, limitationsAndExclusions: string, permissions?: Array<string> | null } | null };

export type ReportInviteQueryVariables = Exact<{
  inviteId: Scalars['ID']['input'];
}>;


export type ReportInviteQuery = { __typename?: 'Query', reportInvite?: { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null };

export type ReportInviteByTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReportInviteByTokenQuery = { __typename?: 'Query', retrieveReportInvite?: { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null } } | null };

export type ReportScopeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ReportScopeQuery = { __typename?: 'Query', reportScope?: { __typename?: 'ReportScope', _id: number, id: string, inScope: string, outOfScope: string, permissions?: Array<string> | null } | null };

export type ReportSectionQueryVariables = Exact<{
  sectionId: Scalars['ID']['input'];
}>;


export type ReportSectionQuery = { __typename?: 'Query', reportSection?: { __typename?: 'ReportSection', content: string, id: string, _id: number, identifier: ReportSectionIdentifier, name: string, permissions?: Array<string> | null } | null };

export type ReportUserQueryVariables = Exact<{
  reportUserId: Scalars['ID']['input'];
}>;


export type ReportUserQuery = { __typename?: 'Query', reportUser?: { __typename?: 'ReportUser', _id: number, id: string, role: ReportRole, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } } | null };

export type ReportVersionQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', testName?: string | null, testTypes?: Array<TestType | null> | null, testPerformedFrom?: string | null, testPerformedTo?: string | null, testApplicationVersion?: string | null, testServerVersion?: string | null, testHostname?: string | null, testEffortDays?: number | null, _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string, title: string, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null }, client?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, consultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null };

export type ReportVersionVersionQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionVersionQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', testName?: string | null, testTypes?: Array<TestType | null> | null, testPerformedFrom?: string | null, testPerformedTo?: string | null, testApplicationVersion?: string | null, testServerVersion?: string | null, testHostname?: string | null, testEffortDays?: number | null, _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, client?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, consultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null, report: { __typename?: 'Report', _id: number, id: string } } | null };

export type ReportVersionTestQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionTestQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, testName?: string | null, testTypes?: Array<TestType | null> | null, testPerformedFrom?: string | null, testPerformedTo?: string | null, testApplicationVersion?: string | null, testServerVersion?: string | null, testHostname?: string | null, testEffortDays?: number | null } | null };

export type ReportVersionClientQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionClientQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, client?: { __typename?: 'ReportClient', _id: number, id: string, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, report: { __typename?: 'Report', _id: number, id: string, company?: { __typename?: 'Company', _id: number, id: string } | null } } | null };

export type ReportVersionConsultantQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionConsultantQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, consultant?: { __typename?: 'ReportConsultant', _id: number, id: string, qualifications?: string | null, permissions?: Array<string> | null, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null } | null, report: { __typename?: 'Report', _id: number, id: string, company?: { __typename?: 'Company', _id: number, id: string } | null } } | null };

export type ReportVersionContactQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionContactQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, contact?: { __typename?: 'ReportContact', address?: string | null, company?: string | null, email?: string | null, mobile?: string | null, phone?: string | null, position?: string | null, _id: number, id: string, name?: string | null, permissions?: Array<string> | null } | null, report: { __typename?: 'Report', _id: number, id: string, company?: { __typename?: 'Company', _id: number, id: string } | null } } | null };

export type ReportVersionEngagementOverviewQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionEngagementOverviewQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, engagementOverview?: { __typename?: 'ReportEngagementOverview', _id: number, id: string, objectives: string, rulesOfEngagement: string, limitationsAndExclusions: string, permissions?: Array<string> | null } | null } | null };

export type ReportVersionScopeQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionScopeQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, permissions?: Array<string> | null, scope?: { __typename?: 'ReportScope', _id: number, id: string, inScope: string, outOfScope: string, permissions?: Array<string> | null } | null } | null };

export type ReportVersionAccessInformationQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionAccessInformationQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, accessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null } | null } | null };

export type ReportVersionTestDetailsQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionTestDetailsQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, engagementOverview?: { __typename?: 'ReportEngagementOverview', _id: number, id: string, objectives: string, rulesOfEngagement: string, limitationsAndExclusions: string, permissions?: Array<string> | null } | null, scope?: { __typename?: 'ReportScope', _id: number, id: string, inScope: string, outOfScope: string, permissions?: Array<string> | null } | null, accessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, additionalInformation: string, permissions?: Array<string> | null } | null } | null };

export type ReportVersionSectionsQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVersionSectionsQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, sections?: { __typename?: 'ReportSectionCursorConnection', pageInfo: { __typename?: 'ReportSectionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportSectionEdge', node?: { __typename?: 'ReportSection', content: string, id: string, _id: number, identifier: ReportSectionIdentifier, name: string, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVersionSectionsListQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVersionSectionsListQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, sections?: { __typename?: 'ReportSectionCursorConnection', pageInfo: { __typename?: 'ReportSectionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportSectionEdge', node?: { __typename?: 'ReportSection', id: string, _id: number, identifier: ReportSectionIdentifier, name: string, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVersionVulnerabilitiesQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVersionVulnerabilitiesQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, vulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null } | null };

export type ReportVersionVulnerabilitiesListQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportVulnerabilityFilter_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateDiscovered?: InputMaybe<ReportVulnerabilityFilter_DateDiscovered>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVersionVulnerabilitiesListQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, vulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null } | null };

export type ReportVersionReadReceiptsListQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVersionReadReceiptsListQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, readReceipts?: { __typename?: 'ReportReadReceiptCursorConnection', pageInfo: { __typename?: 'ReportReadReceiptPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportReadReceiptEdge', node?: { __typename?: 'ReportReadReceipt', id: string, sectionNumber: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type AllReportVersionsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<ReportVersionFilter_PublishedAt>;
}>;


export type AllReportVersionsListQuery = { __typename?: 'Query', reportVersions?: { __typename?: 'ReportVersionCursorConnection', pageInfo: { __typename?: 'ReportVersionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVersionEdge', node?: { __typename?: 'ReportVersion', _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string } } | null } | null> | null } | null };

export type CompanyReportVersionsListQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<ReportVersionFilter_PublishedAt>;
}>;


export type CompanyReportVersionsListQuery = { __typename?: 'Query', companyReportVersions?: { __typename?: 'ReportVersionCursorConnection', pageInfo: { __typename?: 'ReportVersionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVersionEdge', node?: { __typename?: 'ReportVersion', _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string } } | null } | null> | null } | null };

export type ReportVersionDeliverableFilesQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionDeliverableFilesQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, permissions?: Array<string> | null, deliverableFiles?: { __typename?: 'ReportDeliverableFileCursorConnection', pageInfo: { __typename?: 'ReportDeliverableFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportDeliverableFileEdge', node?: { __typename?: 'ReportDeliverableFile', _id: number, id: string, description?: string | null, permissions?: Array<string> | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null } | null };

export type ReportVersionTestTypePrerequisitesQueryVariables = Exact<{
  versionId: Scalars['ID']['input'];
}>;


export type ReportVersionTestTypePrerequisitesQuery = { __typename?: 'Query', reportVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, permissions?: Array<string> | null, testTypePrerequisites?: { __typename?: 'ReportTestTypePrerequisiteCursorConnection', pageInfo: { __typename?: 'ReportTestTypePrerequisitePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportTestTypePrerequisiteEdge', node?: { __typename?: 'ReportTestTypePrerequisite', _id: number, id: string, testType: TestType, complete: boolean, description: string, permissions?: Array<string> | null, baseTestTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilityActionQueryVariables = Exact<{
  actionId: Scalars['ID']['input'];
}>;


export type ReportVulnerabilityActionQuery = { __typename?: 'Query', reportVulnerabilityAction?: { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, files?: { __typename?: 'ReportMediaObjectCursorConnection', pageInfo: { __typename?: 'ReportMediaObjectPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportMediaObjectEdge', node?: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilityFileQueryVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type ReportVulnerabilityFileQuery = { __typename?: 'Query', reportVulnerabilityFile?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null };

export type ReportVulnerabilityQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
}>;


export type ReportVulnerabilityQuery = { __typename?: 'Query', reportVulnerability?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null };

export type PublishedReportVulnerabilitiesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateDiscovered?: InputMaybe<ReportVulnerabilityFilter_DateDiscovered>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishedReportVulnerabilitiesQuery = { __typename?: 'Query', publishedReportVulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null };

export type PublishedReportVulnerabilitiesListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportVulnerabilityFilter_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  issueNumber?: InputMaybe<Scalars['Int']['input']>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateDiscovered?: InputMaybe<ReportVulnerabilityFilter_DateDiscovered>;
  cvssScore?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublishedReportVulnerabilitiesListQuery = { __typename?: 'Query', publishedReportVulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null };

export type ReportVulnerabilityActionsListQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportVulnerabilityActionFilter_Order>;
}>;


export type ReportVulnerabilityActionsListQuery = { __typename?: 'Query', reportVulnerability?: { __typename?: 'ReportVulnerability', _id: number, id: string, permissions?: Array<string> | null, actions?: { __typename?: 'ReportVulnerabilityActionCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityActionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityActionEdge', node?: { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilityActionsQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportVulnerabilityActionFilter_Order>;
}>;


export type ReportVulnerabilityActionsQuery = { __typename?: 'Query', reportVulnerability?: { __typename?: 'ReportVulnerability', _id: number, id: string, permissions?: Array<string> | null, actions?: { __typename?: 'ReportVulnerabilityActionCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityActionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityActionEdge', node?: { __typename?: 'ReportVulnerabilityAction', _id: number, id: string, dateActioned: string, description: string, clientReference?: string | null, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, files?: { __typename?: 'ReportMediaObjectCursorConnection', pageInfo: { __typename?: 'ReportMediaObjectPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportMediaObjectEdge', node?: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilityRetestRequestsQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportVulnerabilityRetestRequestFilter_Order>;
}>;


export type ReportVulnerabilityRetestRequestsQuery = { __typename?: 'Query', reportVulnerability?: { __typename?: 'ReportVulnerability', _id: number, id: string, permissions?: Array<string> | null, retestRequests?: { __typename?: 'ReportVulnerabilityRetestRequestCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityRetestRequestPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityRetestRequestEdge', node?: { __typename?: 'ReportVulnerabilityRetestRequest', _id: number, id: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilityCommentsQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVulnerabilityCommentsQuery = { __typename?: 'Query', reportVulnerability?: { __typename?: 'ReportVulnerability', _id: number, id: string, permissions?: Array<string> | null, comments?: { __typename?: 'ReportVulnerabilityCommentCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityCommentPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityCommentEdge', node?: { __typename?: 'ReportVulnerabilityComment', _id: number, id: string, message: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilityClientNotificationsQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVulnerabilityClientNotificationsQuery = { __typename?: 'Query', reportVulnerability?: { __typename?: 'ReportVulnerability', _id: number, id: string, permissions?: Array<string> | null, clientNotifications?: { __typename?: 'ReportVulnerabilityClientNotificationCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityClientNotificationPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityClientNotificationEdge', node?: { __typename?: 'ReportVulnerabilityClientNotification', _id: number, id: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportsListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ReportFilter_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportsListQuery = { __typename?: 'Query', reports?: { __typename?: 'ReportCursorConnection', pageInfo: { __typename?: 'ReportPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportEdge', node?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null } | null> | null } | null };

export type ReportOverviewQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type ReportOverviewQuery = { __typename?: 'Query', report?: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus, versionName: string, versionNumber: string, permissions?: Array<string> | null, engagementOverview?: { __typename?: 'ReportEngagementOverview', _id: number, id: string, permissions?: Array<string> | null } | null, scope?: { __typename?: 'ReportScope', _id: number, id: string, permissions?: Array<string> | null } | null, accessInformation?: { __typename?: 'ReportAccessInformation', _id: number, id: string, permissions?: Array<string> | null } | null } | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null } | null };

export type ReportVersionsListQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVersionsListQuery = { __typename?: 'Query', report?: { __typename?: 'Report', _id: number, id: string, versions?: { __typename?: 'ReportVersionCursorConnection', pageInfo: { __typename?: 'ReportVersionPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVersionEdge', node?: { __typename?: 'ReportVersion', _id: number, id: string, versionName: string, versionNumber: string, status: ReportVersionStatus, createdAt?: string | null, publishedAt?: string | null, createdByFullName?: string | null, transitions?: Array<string> | null, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string } } | null } | null> | null } | null } | null };

export type ReportInvitesListQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportInvitesListQuery = { __typename?: 'Query', report?: { __typename?: 'Report', _id: number, id: string, invites?: { __typename?: 'ReportInviteCursorConnection', pageInfo: { __typename?: 'ReportInvitePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportInviteEdge', node?: { __typename?: 'ReportInvite', id: string, _id: number, role: ReportRole, firstName?: string | null, lastName?: string | null, email?: string | null, expired: boolean, accepted: boolean, acceptedAt?: string | null, expiresAt?: string | null, createdAt?: string | null, createdByFullName?: string | null, acceptedByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export type ReportVulnerabilitiesQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportVulnerabilitiesQuery = { __typename?: 'Query', report?: { __typename?: 'Report', _id: number, id: string, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, vulnerabilities?: { __typename?: 'ReportVulnerabilityCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityEdge', node?: { __typename?: 'ReportVulnerability', advice?: string | null, affectedHosts?: string | null, cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, createdAt?: string | null, updatedAt?: string | null, resolvedByFullName?: string | null, riskAcceptedByFullName?: string | null, reopenedAt?: string | null, reopenedByFullName?: string | null, reopenedReason?: string | null, permissions?: Array<string> | null, _id: number, id: string, status: ReportVulnerabilityStatus, dateDiscovered: string, dateResolved?: string | null, issueNumber: number, numberOfIssues: string, severity: VulnerabilitySeverity, title: string, resolvedAt?: string | null, riskAcceptedAt?: string | null, baseVulnerability?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null, files?: { __typename?: 'ReportVulnerabilityFileCursorConnection', pageInfo: { __typename?: 'ReportVulnerabilityFilePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportVulnerabilityFileEdge', node?: { __typename?: 'ReportVulnerabilityFile', _id: number, id: string, caption?: string | null, position: number, description?: string | null, permissions?: Array<string> | null, reportVulnerability: { __typename?: 'ReportVulnerability', _id: number, id: string }, reportMediaObject: { __typename?: 'ReportMediaObject', _id: number, id: string, contentUrl?: string | null, size?: number | null, originalName?: string | null, mimeType?: string | null, permissions?: Array<string> | null } } | null } | null> | null } | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null, reportVersion: { __typename?: 'ReportVersion', _id: number, id: string, report: { __typename?: 'Report', _id: number, id: string } } } | null } | null> | null } | null } | null } | null };

export type ReportUsersQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportUsersQuery = { __typename?: 'Query', report?: { __typename?: 'Report', _id: number, id: string, company?: { __typename?: 'Company', _id: number, id: string } | null, viewers?: { __typename?: 'ReportUserCursorConnection', pageInfo: { __typename?: 'ReportUserPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'ReportUserEdge', node?: { __typename?: 'ReportUser', _id: number, id: string, role: ReportRole, permissions?: Array<string> | null, report: { __typename?: 'Report', _id: number, id: string, title: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, company?: { __typename?: 'Company', _id: number, id: string, name: string, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, logo?: { __typename?: 'CompanyLogo', _id: number, id: string, contentUrl?: string | null } | null } | null, latestVersion?: { __typename?: 'ReportVersion', _id: number, id: string, status: ReportVersionStatus } | null }, user: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } } | null } | null> | null } | null } | null };

export type TestTypePrerequisiteListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  testType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<TestTypePrerequisiteFilter_Order>;
}>;


export type TestTypePrerequisiteListQuery = { __typename?: 'Query', testTypePrerequisites?: { __typename?: 'TestTypePrerequisiteCursorConnection', pageInfo: { __typename?: 'TestTypePrerequisitePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'TestTypePrerequisiteEdge', node?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null } | null> | null } | null };

export type TestTypePrerequisiteQueryVariables = Exact<{
  testTypePrerequisiteId: Scalars['ID']['input'];
}>;


export type TestTypePrerequisiteQuery = { __typename?: 'Query', testTypePrerequisite?: { __typename?: 'TestTypePrerequisite', _id: number, id: string, version: number, identifier: string, testType: TestType, description: string, permissions?: Array<string> | null } | null };

export type TestingTypeQueryVariables = Exact<{
  testingTypeId: Scalars['ID']['input'];
}>;


export type TestingTypeQuery = { __typename?: 'Query', testingType?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null };

export type TestingTypeListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TestingTypeListQuery = { __typename?: 'Query', testingTypes?: { __typename?: 'TestingTypeCursorConnection', pageInfo: { __typename?: 'TestingTypePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null };

export type TestingTypesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type TestingTypesQuery = { __typename?: 'Query', testingTypes?: { __typename?: 'TestingTypeCursorConnection', pageInfo: { __typename?: 'TestingTypePageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null };

export type GetUserNotificationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserNotificationsQuery = { __typename?: 'Query', userNotifications?: { __typename?: 'UserNotificationCursorConnection', pageInfo: { __typename?: 'UserNotificationPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserNotificationEdge', node?: { __typename?: 'UserNotification', _id: number, id: string, message: string, type: UserNotificationType, data?: any | null, createdAt?: string | null, readAt?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null };

export type UserListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserFilter_Order>;
}>;


export type UserListQuery = { __typename?: 'Query', users?: { __typename?: 'UserCursorConnection', pageInfo: { __typename?: 'UserPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } | null } | null> | null } | null };

export type ConsultantUserListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<UserFilter_Order>;
}>;


export type ConsultantUserListQuery = { __typename?: 'Query', consultantUsers?: { __typename?: 'UserCursorConnection', pageInfo: { __typename?: 'UserPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } | null } | null> | null } | null };

export type UserQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'User', roles?: Array<string> | null, _id: number, id: string, fullName?: string | null, firstName: string, lastName: string, email?: string | null, emailVerified?: boolean | null, permissions?: Array<string> | null, disabled?: boolean | null } | null };

export type UserCompanyRolesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  companyId: Scalars['String']['input'];
}>;


export type UserCompanyRolesQuery = { __typename?: 'Query', user?: { __typename?: 'User', companies?: { __typename?: 'CompanyUserCursorConnection', edges?: Array<{ __typename?: 'CompanyUserEdge', node?: { __typename?: 'CompanyUser', _id: number, id: string, role: CompanyRole } | null } | null> | null } | null } | null };

export type VulnerabilityListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  testingTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  order?: InputMaybe<VulnerabilityFilter_Order>;
}>;


export type VulnerabilityListQuery = { __typename?: 'Query', vulnerabilities?: { __typename?: 'VulnerabilityCursorConnection', pageInfo: { __typename?: 'VulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'VulnerabilityEdge', node?: { __typename?: 'Vulnerability', _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null } | null } | null> | null } | null };

export type SelectVulnerabilityQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<VulnerabilityFilter_Order>;
}>;


export type SelectVulnerabilityQuery = { __typename?: 'Query', vulnerabilities?: { __typename?: 'VulnerabilityCursorConnection', pageInfo: { __typename?: 'VulnerabilityPageInfo', endCursor?: string | null, hasNextPage: boolean }, edges?: Array<{ __typename?: 'VulnerabilityEdge', node?: { __typename?: 'Vulnerability', cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, advice?: string | null, _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null } | null } | null> | null } | null };

export type VulnerabilityQueryVariables = Exact<{
  vulnerabilityId: Scalars['ID']['input'];
}>;


export type VulnerabilityQuery = { __typename?: 'Query', vulnerability?: { __typename?: 'Vulnerability', cvssScore?: string | null, cvssVector?: string | null, cveScore?: string | null, cwe?: string | null, owaspCategory?: string | null, issueDetail?: string | null, advice?: string | null, _id: number, id: string, identifier: string, title: string, severity: VulnerabilitySeverity, createdAt?: string | null, createdByFullName?: string | null, permissions?: Array<string> | null, testingTypes?: { __typename?: 'TestingTypeCursorConnection', edges?: Array<{ __typename?: 'TestingTypeEdge', node?: { __typename?: 'TestingType', createdAt?: string | null, createdByFullName?: string | null, _id: number, id: string, name: string, permissions?: Array<string> | null } | null } | null> | null } | null } | null };

export const CompanyContactListFieldsFragmentDoc = gql`
    fragment companyContactListFields on CompanyContact {
  _id
  id
  name
  permissions
}
    `;
export const CompanyContactFieldsFragmentDoc = gql`
    fragment companyContactFields on CompanyContact {
  ...companyContactListFields
  address
  companyName
  email
  mobile
  phone
  position
  company {
    _id
    id
  }
  createdAt
  createdByFullName
}
    ${CompanyContactListFieldsFragmentDoc}`;
export const CompanyInviteListFieldsFragmentDoc = gql`
    fragment companyInviteListFields on CompanyInvite {
  id
  _id
  role
  firstName
  lastName
  email
  expired
  accepted
  acceptedAt
  expiresAt
  createdAt
  createdByFullName
  acceptedByFullName
  permissions
}
    `;
export const CompanyInviteFieldsFragmentDoc = gql`
    fragment companyInviteFields on CompanyInvite {
  ...companyInviteListFields
}
    ${CompanyInviteListFieldsFragmentDoc}`;
export const CreateCompanyInviteFieldsFragmentDoc = gql`
    fragment createCompanyInviteFields on createCompanyInvitePayloadData {
  _id
  id
  token
}
    `;
export const CompanyLogoFieldsFragmentDoc = gql`
    fragment companyLogoFields on CompanyLogo {
  _id
  id
  contentUrl
}
    `;
export const CompanyListFieldsFragmentDoc = gql`
    fragment companyListFields on Company {
  _id
  id
  name
  createdAt
  createdByFullName
  logo {
    ...companyLogoFields
  }
  permissions
}
    ${CompanyLogoFieldsFragmentDoc}`;
export const UserListFieldsFragmentDoc = gql`
    fragment userListFields on User {
  _id
  id
  fullName
  firstName
  lastName
  email
  emailVerified
  permissions
  disabled
}
    `;
export const CompanyUserListFieldsFragmentDoc = gql`
    fragment companyUserListFields on CompanyUser {
  _id
  id
  role
  company {
    ...companyListFields
  }
  user {
    ...userListFields
  }
  permissions
}
    ${CompanyListFieldsFragmentDoc}
${UserListFieldsFragmentDoc}`;
export const CompanyFieldsFragmentDoc = gql`
    fragment companyFields on Company {
  ...companyListFields
}
    ${CompanyListFieldsFragmentDoc}`;
export const ContactListFieldsFragmentDoc = gql`
    fragment contactListFields on Contact {
  _id
  id
  name
  permissions
}
    `;
export const ContactFieldsFragmentDoc = gql`
    fragment contactFields on Contact {
  ...contactListFields
  address
  companyName
  email
  mobile
  phone
  position
  createdAt
  createdByFullName
}
    ${ContactListFieldsFragmentDoc}`;
export const ReportAccessInformationCredentialsFieldsFragmentDoc = gql`
    fragment reportAccessInformationCredentialsFields on ReportAccessInformationCredentials {
  _id
  id
  username
  password
  url
  notes
  accessInformation {
    _id
    id
  }
  permissions
}
    `;
export const ReportMediaObjectFieldsFragmentDoc = gql`
    fragment reportMediaObjectFields on ReportMediaObject {
  _id
  id
  contentUrl
  size
  originalName
  mimeType
  permissions
}
    `;
export const ReportAccessInformationFileFieldsFragmentDoc = gql`
    fragment reportAccessInformationFileFields on ReportAccessInformationFile {
  _id
  id
  description
  accessInformation {
    _id
    id
  }
  reportMediaObject {
    ...reportMediaObjectFields
  }
  permissions
}
    ${ReportMediaObjectFieldsFragmentDoc}`;
export const ReportAccessInformationFieldsFragmentDoc = gql`
    fragment reportAccessInformationFields on ReportAccessInformation {
  _id
  id
  additionalInformation
  permissions
}
    `;
export const ReportContactListFieldsFragmentDoc = gql`
    fragment reportContactListFields on ReportContact {
  _id
  id
  name
  permissions
}
    `;
export const ReportClientListFieldsFragmentDoc = gql`
    fragment reportClientListFields on ReportClient {
  _id
  id
  contact {
    ...reportContactListFields
  }
  permissions
}
    ${ReportContactListFieldsFragmentDoc}`;
export const ReportConsultantListFieldsFragmentDoc = gql`
    fragment reportConsultantListFields on ReportConsultant {
  _id
  id
  contact {
    ...reportContactListFields
  }
  permissions
}
    ${ReportContactListFieldsFragmentDoc}`;
export const ReportDeliverableFileFieldsFragmentDoc = gql`
    fragment reportDeliverableFileFields on ReportDeliverableFile {
  _id
  id
  description
  reportVersion {
    _id
    id
  }
  reportMediaObject {
    ...reportMediaObjectFields
  }
  permissions
}
    ${ReportMediaObjectFieldsFragmentDoc}`;
export const ReportEngagementOverviewFieldsFragmentDoc = gql`
    fragment reportEngagementOverviewFields on ReportEngagementOverview {
  _id
  id
  objectives
  rulesOfEngagement
  limitationsAndExclusions
  permissions
}
    `;
export const ReportInviteListFieldsFragmentDoc = gql`
    fragment reportInviteListFields on ReportInvite {
  id
  _id
  role
  firstName
  lastName
  email
  expired
  accepted
  acceptedAt
  expiresAt
  createdAt
  createdByFullName
  acceptedByFullName
  permissions
}
    `;
export const ReportInviteFieldsFragmentDoc = gql`
    fragment reportInviteFields on ReportInvite {
  ...reportInviteListFields
}
    ${ReportInviteListFieldsFragmentDoc}`;
export const CreateReportInviteFieldsFragmentDoc = gql`
    fragment createReportInviteFields on createReportInvitePayloadData {
  _id
  id
  token
}
    `;
export const ReportReadReceiptListFieldsFragmentDoc = gql`
    fragment reportReadReceiptListFields on ReportReadReceipt {
  id
  sectionNumber
  createdAt
  createdByFullName
  permissions
}
    `;
export const ReportScopeFieldsFragmentDoc = gql`
    fragment reportScopeFields on ReportScope {
  _id
  id
  inScope
  outOfScope
  permissions
}
    `;
export const ReportSectionListFieldsFragmentDoc = gql`
    fragment reportSectionListFields on ReportSection {
  id
  _id
  identifier
  name
  permissions
}
    `;
export const ReportSectionFieldsFragmentDoc = gql`
    fragment reportSectionFields on ReportSection {
  ...reportSectionListFields
  content
}
    ${ReportSectionListFieldsFragmentDoc}`;
export const TestTypePrerequisiteFieldsFragmentDoc = gql`
    fragment testTypePrerequisiteFields on TestTypePrerequisite {
  _id
  id
  version
  identifier
  testType
  description
  permissions
}
    `;
export const ReportTestTypePrerequisiteFieldsFragmentDoc = gql`
    fragment reportTestTypePrerequisiteFields on ReportTestTypePrerequisite {
  _id
  id
  testType
  complete
  description
  baseTestTypePrerequisite {
    ...testTypePrerequisiteFields
  }
  permissions
}
    ${TestTypePrerequisiteFieldsFragmentDoc}`;
export const ReportListFieldsFragmentDoc = gql`
    fragment reportListFields on Report {
  _id
  id
  title
  createdAt
  createdByFullName
  company {
    ...companyListFields
  }
  latestVersion {
    _id
    id
    status
  }
  permissions
}
    ${CompanyListFieldsFragmentDoc}`;
export const ReportUserListFieldsFragmentDoc = gql`
    fragment reportUserListFields on ReportUser {
  _id
  id
  role
  report {
    ...reportListFields
  }
  user {
    ...userListFields
  }
  permissions
}
    ${ReportListFieldsFragmentDoc}
${UserListFieldsFragmentDoc}`;
export const ReportVersionListFieldsFragmentDoc = gql`
    fragment reportVersionListFields on ReportVersion {
  _id
  id
  versionName
  versionNumber
  status
  createdAt
  publishedAt
  createdByFullName
  report {
    _id
    id
  }
  transitions
  permissions
}
    `;
export const ReportContactFieldsFragmentDoc = gql`
    fragment reportContactFields on ReportContact {
  ...reportContactListFields
  address
  company
  email
  mobile
  phone
  position
}
    ${ReportContactListFieldsFragmentDoc}`;
export const ReportClientFieldsFragmentDoc = gql`
    fragment reportClientFields on ReportClient {
  _id
  id
  contact {
    ...reportContactFields
  }
  permissions
}
    ${ReportContactFieldsFragmentDoc}`;
export const ReportConsultantFieldsFragmentDoc = gql`
    fragment reportConsultantFields on ReportConsultant {
  _id
  id
  qualifications
  contact {
    ...reportContactFields
  }
  permissions
}
    ${ReportContactFieldsFragmentDoc}`;
export const ReportVersionFieldsFragmentDoc = gql`
    fragment reportVersionFields on ReportVersion {
  ...reportVersionListFields
  client {
    ...reportClientFields
  }
  consultant {
    ...reportConsultantFields
  }
  contact {
    ...reportContactFields
  }
  testName
  testTypes
  testPerformedFrom
  testPerformedTo
  testApplicationVersion
  testServerVersion
  testHostname
  testEffortDays
}
    ${ReportVersionListFieldsFragmentDoc}
${ReportClientFieldsFragmentDoc}
${ReportConsultantFieldsFragmentDoc}
${ReportContactFieldsFragmentDoc}`;
export const ReportVulnerabilityActionListFieldsFragmentDoc = gql`
    fragment reportVulnerabilityActionListFields on ReportVulnerabilityAction {
  _id
  id
  dateActioned
  description
  clientReference
  createdAt
  createdByFullName
  permissions
}
    `;
export const ReportVulnerabilityActionFieldsFragmentDoc = gql`
    fragment reportVulnerabilityActionFields on ReportVulnerabilityAction {
  ...reportVulnerabilityActionListFields
  files {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportMediaObjectFields
      }
    }
  }
}
    ${ReportVulnerabilityActionListFieldsFragmentDoc}
${ReportMediaObjectFieldsFragmentDoc}`;
export const ReportVulnerabilityClientNotificationListFieldsFragmentDoc = gql`
    fragment reportVulnerabilityClientNotificationListFields on ReportVulnerabilityClientNotification {
  _id
  id
  createdAt
  createdByFullName
  permissions
}
    `;
export const ReportVulnerabilityCommentFieldsFragmentDoc = gql`
    fragment reportVulnerabilityCommentFields on ReportVulnerabilityComment {
  _id
  id
  message
  createdAt
  createdByFullName
  permissions
}
    `;
export const ReportVulnerabilityRetestRequestListFieldsFragmentDoc = gql`
    fragment reportVulnerabilityRetestRequestListFields on ReportVulnerabilityRetestRequest {
  _id
  id
  createdAt
  createdByFullName
  permissions
}
    `;
export const ReportVulnerabilityListFieldsFragmentDoc = gql`
    fragment reportVulnerabilityListFields on ReportVulnerability {
  _id
  id
  status
  dateDiscovered
  dateResolved
  issueNumber
  numberOfIssues
  severity
  title
  resolvedAt
  riskAcceptedAt
  reportVersion {
    _id
    id
    report {
      _id
      id
    }
  }
  permissions
}
    `;
export const VulnerabilityListFieldsFragmentDoc = gql`
    fragment vulnerabilityListFields on Vulnerability {
  _id
  id
  identifier
  title
  severity
  createdAt
  createdByFullName
  permissions
}
    `;
export const ReportVulnerabilityFileFieldsFragmentDoc = gql`
    fragment reportVulnerabilityFileFields on ReportVulnerabilityFile {
  _id
  id
  caption
  position
  description
  reportVulnerability {
    _id
    id
  }
  reportMediaObject {
    ...reportMediaObjectFields
  }
  permissions
}
    ${ReportMediaObjectFieldsFragmentDoc}`;
export const TestingTypeListFieldsFragmentDoc = gql`
    fragment testingTypeListFields on TestingType {
  _id
  id
  name
  permissions
}
    `;
export const TestingTypeFieldsFragmentDoc = gql`
    fragment testingTypeFields on TestingType {
  ...testingTypeListFields
  createdAt
  createdByFullName
}
    ${TestingTypeListFieldsFragmentDoc}`;
export const ReportVulnerabilityFieldsFragmentDoc = gql`
    fragment reportVulnerabilityFields on ReportVulnerability {
  ...reportVulnerabilityListFields
  advice
  affectedHosts
  cvssScore
  cvssVector
  cveScore
  cwe
  owaspCategory
  issueDetail
  createdAt
  updatedAt
  resolvedByFullName
  riskAcceptedByFullName
  reopenedAt
  reopenedByFullName
  reopenedReason
  baseVulnerability {
    ...vulnerabilityListFields
  }
  files(order: {position: "ASC"}) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVulnerabilityFileFields
      }
    }
  }
  testingTypes {
    edges {
      node {
        ...testingTypeFields
      }
    }
  }
  permissions
}
    ${ReportVulnerabilityListFieldsFragmentDoc}
${VulnerabilityListFieldsFragmentDoc}
${ReportVulnerabilityFileFieldsFragmentDoc}
${TestingTypeFieldsFragmentDoc}`;
export const UserNotificationFieldsFragmentDoc = gql`
    fragment userNotificationFields on UserNotification {
  _id
  id
  message
  type
  data
  createdAt
  readAt
  permissions
}
    `;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  ...userListFields
  roles
}
    ${UserListFieldsFragmentDoc}`;
export const VulnerabilityFieldsFragmentDoc = gql`
    fragment vulnerabilityFields on Vulnerability {
  ...vulnerabilityListFields
  cvssScore
  cvssVector
  cveScore
  cwe
  owaspCategory
  issueDetail
  advice
  testingTypes {
    edges {
      node {
        ...testingTypeFields
      }
    }
  }
}
    ${VulnerabilityListFieldsFragmentDoc}
${TestingTypeFieldsFragmentDoc}`;
export const CreateCompanyContactDocument = gql`
    mutation CreateCompanyContact($input: createCompanyContactInput!) {
  createCompanyContact(input: $input) {
    companyContact {
      ...companyContactFields
    }
  }
}
    ${CompanyContactFieldsFragmentDoc}`;
export type CreateCompanyContactMutationFn = Apollo.MutationFunction<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>;

/**
 * __useCreateCompanyContactMutation__
 *
 * To run a mutation, you first call `useCreateCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyContactMutation, { data, loading, error }] = useCreateCompanyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>(CreateCompanyContactDocument, options);
      }
export type CreateCompanyContactMutationHookResult = ReturnType<typeof useCreateCompanyContactMutation>;
export type CreateCompanyContactMutationResult = Apollo.MutationResult<CreateCompanyContactMutation>;
export type CreateCompanyContactMutationOptions = Apollo.BaseMutationOptions<CreateCompanyContactMutation, CreateCompanyContactMutationVariables>;
export const UpdateCompanyContactDocument = gql`
    mutation UpdateCompanyContact($input: updateCompanyContactInput!) {
  updateCompanyContact(input: $input) {
    companyContact {
      ...companyContactFields
    }
  }
}
    ${CompanyContactFieldsFragmentDoc}`;
export type UpdateCompanyContactMutationFn = Apollo.MutationFunction<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>;

/**
 * __useUpdateCompanyContactMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyContactMutation, { data, loading, error }] = useUpdateCompanyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>(UpdateCompanyContactDocument, options);
      }
export type UpdateCompanyContactMutationHookResult = ReturnType<typeof useUpdateCompanyContactMutation>;
export type UpdateCompanyContactMutationResult = Apollo.MutationResult<UpdateCompanyContactMutation>;
export type UpdateCompanyContactMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyContactMutation, UpdateCompanyContactMutationVariables>;
export const DeleteCompanyContactDocument = gql`
    mutation DeleteCompanyContact($input: deleteCompanyContactInput!) {
  deleteCompanyContact(input: $input) {
    __typename
  }
}
    `;
export type DeleteCompanyContactMutationFn = Apollo.MutationFunction<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>;

/**
 * __useDeleteCompanyContactMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyContactMutation, { data, loading, error }] = useDeleteCompanyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>(DeleteCompanyContactDocument, options);
      }
export type DeleteCompanyContactMutationHookResult = ReturnType<typeof useDeleteCompanyContactMutation>;
export type DeleteCompanyContactMutationResult = Apollo.MutationResult<DeleteCompanyContactMutation>;
export type DeleteCompanyContactMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyContactMutation, DeleteCompanyContactMutationVariables>;
export const CreateCompanyInviteDocument = gql`
    mutation CreateCompanyInvite($input: createCompanyInviteInput!) {
  createCompanyInvite(input: $input) {
    companyInvite {
      ...createCompanyInviteFields
    }
  }
}
    ${CreateCompanyInviteFieldsFragmentDoc}`;
export type CreateCompanyInviteMutationFn = Apollo.MutationFunction<CreateCompanyInviteMutation, CreateCompanyInviteMutationVariables>;

/**
 * __useCreateCompanyInviteMutation__
 *
 * To run a mutation, you first call `useCreateCompanyInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyInviteMutation, { data, loading, error }] = useCreateCompanyInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyInviteMutation, CreateCompanyInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyInviteMutation, CreateCompanyInviteMutationVariables>(CreateCompanyInviteDocument, options);
      }
export type CreateCompanyInviteMutationHookResult = ReturnType<typeof useCreateCompanyInviteMutation>;
export type CreateCompanyInviteMutationResult = Apollo.MutationResult<CreateCompanyInviteMutation>;
export type CreateCompanyInviteMutationOptions = Apollo.BaseMutationOptions<CreateCompanyInviteMutation, CreateCompanyInviteMutationVariables>;
export const AcceptCompanyInviteDocument = gql`
    mutation AcceptCompanyInvite($input: acceptCompanyInviteInput!) {
  acceptCompanyInvite(input: $input) {
    companyInvite {
      ...companyInviteFields
    }
  }
}
    ${CompanyInviteFieldsFragmentDoc}`;
export type AcceptCompanyInviteMutationFn = Apollo.MutationFunction<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>;

/**
 * __useAcceptCompanyInviteMutation__
 *
 * To run a mutation, you first call `useAcceptCompanyInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptCompanyInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptCompanyInviteMutation, { data, loading, error }] = useAcceptCompanyInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptCompanyInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>(AcceptCompanyInviteDocument, options);
      }
export type AcceptCompanyInviteMutationHookResult = ReturnType<typeof useAcceptCompanyInviteMutation>;
export type AcceptCompanyInviteMutationResult = Apollo.MutationResult<AcceptCompanyInviteMutation>;
export type AcceptCompanyInviteMutationOptions = Apollo.BaseMutationOptions<AcceptCompanyInviteMutation, AcceptCompanyInviteMutationVariables>;
export const ResendCompanyInviteDocument = gql`
    mutation ResendCompanyInvite($input: resendCompanyInviteInput!) {
  resendCompanyInvite(input: $input) {
    companyInvite {
      ...companyInviteFields
    }
  }
}
    ${CompanyInviteFieldsFragmentDoc}`;
export type ResendCompanyInviteMutationFn = Apollo.MutationFunction<ResendCompanyInviteMutation, ResendCompanyInviteMutationVariables>;

/**
 * __useResendCompanyInviteMutation__
 *
 * To run a mutation, you first call `useResendCompanyInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendCompanyInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendCompanyInviteMutation, { data, loading, error }] = useResendCompanyInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendCompanyInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendCompanyInviteMutation, ResendCompanyInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendCompanyInviteMutation, ResendCompanyInviteMutationVariables>(ResendCompanyInviteDocument, options);
      }
export type ResendCompanyInviteMutationHookResult = ReturnType<typeof useResendCompanyInviteMutation>;
export type ResendCompanyInviteMutationResult = Apollo.MutationResult<ResendCompanyInviteMutation>;
export type ResendCompanyInviteMutationOptions = Apollo.BaseMutationOptions<ResendCompanyInviteMutation, ResendCompanyInviteMutationVariables>;
export const DeleteCompanyInviteDocument = gql`
    mutation DeleteCompanyInvite($inviteId: ID!) {
  deleteCompanyInvite(input: {id: $inviteId}) {
    __typename
  }
}
    `;
export type DeleteCompanyInviteMutationFn = Apollo.MutationFunction<DeleteCompanyInviteMutation, DeleteCompanyInviteMutationVariables>;

/**
 * __useDeleteCompanyInviteMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyInviteMutation, { data, loading, error }] = useDeleteCompanyInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeleteCompanyInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyInviteMutation, DeleteCompanyInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyInviteMutation, DeleteCompanyInviteMutationVariables>(DeleteCompanyInviteDocument, options);
      }
export type DeleteCompanyInviteMutationHookResult = ReturnType<typeof useDeleteCompanyInviteMutation>;
export type DeleteCompanyInviteMutationResult = Apollo.MutationResult<DeleteCompanyInviteMutation>;
export type DeleteCompanyInviteMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyInviteMutation, DeleteCompanyInviteMutationVariables>;
export const UpdateCompanyUserDocument = gql`
    mutation UpdateCompanyUser($input: updateCompanyUserInput!) {
  updateCompanyUser(input: $input) {
    companyUser {
      ...companyUserListFields
    }
  }
}
    ${CompanyUserListFieldsFragmentDoc}`;
export type UpdateCompanyUserMutationFn = Apollo.MutationFunction<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>;

/**
 * __useUpdateCompanyUserMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserMutation, { data, loading, error }] = useUpdateCompanyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>(UpdateCompanyUserDocument, options);
      }
export type UpdateCompanyUserMutationHookResult = ReturnType<typeof useUpdateCompanyUserMutation>;
export type UpdateCompanyUserMutationResult = Apollo.MutationResult<UpdateCompanyUserMutation>;
export type UpdateCompanyUserMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyUserMutation, UpdateCompanyUserMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($input: createCompanyInput!) {
  createCompany(input: $input) {
    company {
      ...companyFields
    }
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($input: updateCompanyInput!) {
  updateCompany(input: $input) {
    company {
      ...companyFields
    }
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const DeleteCompanyDocument = gql`
    mutation DeleteCompany($input: deleteCompanyInput!) {
  deleteCompany(input: $input) {
    __typename
  }
}
    `;
export type DeleteCompanyMutationFn = Apollo.MutationFunction<DeleteCompanyMutation, DeleteCompanyMutationVariables>;

/**
 * __useDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyMutation, { data, loading, error }] = useDeleteCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyMutation, DeleteCompanyMutationVariables>(DeleteCompanyDocument, options);
      }
export type DeleteCompanyMutationHookResult = ReturnType<typeof useDeleteCompanyMutation>;
export type DeleteCompanyMutationResult = Apollo.MutationResult<DeleteCompanyMutation>;
export type DeleteCompanyMutationOptions = Apollo.BaseMutationOptions<DeleteCompanyMutation, DeleteCompanyMutationVariables>;
export const AddUserToCompanyDocument = gql`
    mutation AddUserToCompany($companyId: ID!, $userId: ID!, $role: CompanyRole!) {
  addUserToCompany(input: {id: $companyId, user: $userId, role: $role}) {
    company {
      ...companyListFields
    }
  }
}
    ${CompanyListFieldsFragmentDoc}`;
export type AddUserToCompanyMutationFn = Apollo.MutationFunction<AddUserToCompanyMutation, AddUserToCompanyMutationVariables>;

/**
 * __useAddUserToCompanyMutation__
 *
 * To run a mutation, you first call `useAddUserToCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToCompanyMutation, { data, loading, error }] = useAddUserToCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddUserToCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToCompanyMutation, AddUserToCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToCompanyMutation, AddUserToCompanyMutationVariables>(AddUserToCompanyDocument, options);
      }
export type AddUserToCompanyMutationHookResult = ReturnType<typeof useAddUserToCompanyMutation>;
export type AddUserToCompanyMutationResult = Apollo.MutationResult<AddUserToCompanyMutation>;
export type AddUserToCompanyMutationOptions = Apollo.BaseMutationOptions<AddUserToCompanyMutation, AddUserToCompanyMutationVariables>;
export const RemoveUserFromCompanyDocument = gql`
    mutation RemoveUserFromCompany($companyId: ID!, $userId: ID!) {
  removeUserFromCompany(input: {id: $companyId, user: $userId}) {
    company {
      ...companyListFields
    }
  }
}
    ${CompanyListFieldsFragmentDoc}`;
export type RemoveUserFromCompanyMutationFn = Apollo.MutationFunction<RemoveUserFromCompanyMutation, RemoveUserFromCompanyMutationVariables>;

/**
 * __useRemoveUserFromCompanyMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromCompanyMutation, { data, loading, error }] = useRemoveUserFromCompanyMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromCompanyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromCompanyMutation, RemoveUserFromCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromCompanyMutation, RemoveUserFromCompanyMutationVariables>(RemoveUserFromCompanyDocument, options);
      }
export type RemoveUserFromCompanyMutationHookResult = ReturnType<typeof useRemoveUserFromCompanyMutation>;
export type RemoveUserFromCompanyMutationResult = Apollo.MutationResult<RemoveUserFromCompanyMutation>;
export type RemoveUserFromCompanyMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromCompanyMutation, RemoveUserFromCompanyMutationVariables>;
export const UploadCompanyLogoDocument = gql`
    mutation UploadCompanyLogo($input: uploadLogoCompanyInput!) {
  uploadLogoCompany(input: $input) {
    company {
      ...companyFields
    }
  }
}
    ${CompanyFieldsFragmentDoc}`;
export type UploadCompanyLogoMutationFn = Apollo.MutationFunction<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;

/**
 * __useUploadCompanyLogoMutation__
 *
 * To run a mutation, you first call `useUploadCompanyLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCompanyLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCompanyLogoMutation, { data, loading, error }] = useUploadCompanyLogoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCompanyLogoMutation(baseOptions?: Apollo.MutationHookOptions<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>(UploadCompanyLogoDocument, options);
      }
export type UploadCompanyLogoMutationHookResult = ReturnType<typeof useUploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationResult = Apollo.MutationResult<UploadCompanyLogoMutation>;
export type UploadCompanyLogoMutationOptions = Apollo.BaseMutationOptions<UploadCompanyLogoMutation, UploadCompanyLogoMutationVariables>;
export const CreateContactDocument = gql`
    mutation CreateContact($input: createContactInput!) {
  createContact(input: $input) {
    contact {
      ...contactFields
    }
  }
}
    ${ContactFieldsFragmentDoc}`;
export type CreateContactMutationFn = Apollo.MutationFunction<CreateContactMutation, CreateContactMutationVariables>;

/**
 * __useCreateContactMutation__
 *
 * To run a mutation, you first call `useCreateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactMutation, { data, loading, error }] = useCreateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactMutation, CreateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactMutation, CreateContactMutationVariables>(CreateContactDocument, options);
      }
export type CreateContactMutationHookResult = ReturnType<typeof useCreateContactMutation>;
export type CreateContactMutationResult = Apollo.MutationResult<CreateContactMutation>;
export type CreateContactMutationOptions = Apollo.BaseMutationOptions<CreateContactMutation, CreateContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($input: updateContactInput!) {
  updateContact(input: $input) {
    contact {
      ...contactFields
    }
  }
}
    ${ContactFieldsFragmentDoc}`;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($input: deleteContactInput!) {
  deleteContact(input: $input) {
    __typename
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const CreateReportAccessInformationCredentialsDocument = gql`
    mutation CreateReportAccessInformationCredentials($input: createReportAccessInformationCredentialsInput!) {
  createReportAccessInformationCredentials(input: $input) {
    reportAccessInformationCredentials {
      ...reportAccessInformationCredentialsFields
    }
  }
}
    ${ReportAccessInformationCredentialsFieldsFragmentDoc}`;
export type CreateReportAccessInformationCredentialsMutationFn = Apollo.MutationFunction<CreateReportAccessInformationCredentialsMutation, CreateReportAccessInformationCredentialsMutationVariables>;

/**
 * __useCreateReportAccessInformationCredentialsMutation__
 *
 * To run a mutation, you first call `useCreateReportAccessInformationCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportAccessInformationCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportAccessInformationCredentialsMutation, { data, loading, error }] = useCreateReportAccessInformationCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportAccessInformationCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportAccessInformationCredentialsMutation, CreateReportAccessInformationCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportAccessInformationCredentialsMutation, CreateReportAccessInformationCredentialsMutationVariables>(CreateReportAccessInformationCredentialsDocument, options);
      }
export type CreateReportAccessInformationCredentialsMutationHookResult = ReturnType<typeof useCreateReportAccessInformationCredentialsMutation>;
export type CreateReportAccessInformationCredentialsMutationResult = Apollo.MutationResult<CreateReportAccessInformationCredentialsMutation>;
export type CreateReportAccessInformationCredentialsMutationOptions = Apollo.BaseMutationOptions<CreateReportAccessInformationCredentialsMutation, CreateReportAccessInformationCredentialsMutationVariables>;
export const UpdateReportAccessInformationCredentialsDocument = gql`
    mutation UpdateReportAccessInformationCredentials($input: updateReportAccessInformationCredentialsInput!) {
  updateReportAccessInformationCredentials(input: $input) {
    reportAccessInformationCredentials {
      ...reportAccessInformationCredentialsFields
    }
  }
}
    ${ReportAccessInformationCredentialsFieldsFragmentDoc}`;
export type UpdateReportAccessInformationCredentialsMutationFn = Apollo.MutationFunction<UpdateReportAccessInformationCredentialsMutation, UpdateReportAccessInformationCredentialsMutationVariables>;

/**
 * __useUpdateReportAccessInformationCredentialsMutation__
 *
 * To run a mutation, you first call `useUpdateReportAccessInformationCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportAccessInformationCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportAccessInformationCredentialsMutation, { data, loading, error }] = useUpdateReportAccessInformationCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportAccessInformationCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportAccessInformationCredentialsMutation, UpdateReportAccessInformationCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportAccessInformationCredentialsMutation, UpdateReportAccessInformationCredentialsMutationVariables>(UpdateReportAccessInformationCredentialsDocument, options);
      }
export type UpdateReportAccessInformationCredentialsMutationHookResult = ReturnType<typeof useUpdateReportAccessInformationCredentialsMutation>;
export type UpdateReportAccessInformationCredentialsMutationResult = Apollo.MutationResult<UpdateReportAccessInformationCredentialsMutation>;
export type UpdateReportAccessInformationCredentialsMutationOptions = Apollo.BaseMutationOptions<UpdateReportAccessInformationCredentialsMutation, UpdateReportAccessInformationCredentialsMutationVariables>;
export const DeleteReportAccessInformationCredentialsDocument = gql`
    mutation DeleteReportAccessInformationCredentials($input: deleteReportAccessInformationCredentialsInput!) {
  deleteReportAccessInformationCredentials(input: $input) {
    __typename
  }
}
    `;
export type DeleteReportAccessInformationCredentialsMutationFn = Apollo.MutationFunction<DeleteReportAccessInformationCredentialsMutation, DeleteReportAccessInformationCredentialsMutationVariables>;

/**
 * __useDeleteReportAccessInformationCredentialsMutation__
 *
 * To run a mutation, you first call `useDeleteReportAccessInformationCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportAccessInformationCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportAccessInformationCredentialsMutation, { data, loading, error }] = useDeleteReportAccessInformationCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportAccessInformationCredentialsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportAccessInformationCredentialsMutation, DeleteReportAccessInformationCredentialsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportAccessInformationCredentialsMutation, DeleteReportAccessInformationCredentialsMutationVariables>(DeleteReportAccessInformationCredentialsDocument, options);
      }
export type DeleteReportAccessInformationCredentialsMutationHookResult = ReturnType<typeof useDeleteReportAccessInformationCredentialsMutation>;
export type DeleteReportAccessInformationCredentialsMutationResult = Apollo.MutationResult<DeleteReportAccessInformationCredentialsMutation>;
export type DeleteReportAccessInformationCredentialsMutationOptions = Apollo.BaseMutationOptions<DeleteReportAccessInformationCredentialsMutation, DeleteReportAccessInformationCredentialsMutationVariables>;
export const CreateReportAccessInformationFileDocument = gql`
    mutation CreateReportAccessInformationFile($input: createReportAccessInformationFileInput!) {
  createReportAccessInformationFile(input: $input) {
    reportAccessInformationFile {
      ...reportAccessInformationFileFields
    }
  }
}
    ${ReportAccessInformationFileFieldsFragmentDoc}`;
export type CreateReportAccessInformationFileMutationFn = Apollo.MutationFunction<CreateReportAccessInformationFileMutation, CreateReportAccessInformationFileMutationVariables>;

/**
 * __useCreateReportAccessInformationFileMutation__
 *
 * To run a mutation, you first call `useCreateReportAccessInformationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportAccessInformationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportAccessInformationFileMutation, { data, loading, error }] = useCreateReportAccessInformationFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportAccessInformationFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportAccessInformationFileMutation, CreateReportAccessInformationFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportAccessInformationFileMutation, CreateReportAccessInformationFileMutationVariables>(CreateReportAccessInformationFileDocument, options);
      }
export type CreateReportAccessInformationFileMutationHookResult = ReturnType<typeof useCreateReportAccessInformationFileMutation>;
export type CreateReportAccessInformationFileMutationResult = Apollo.MutationResult<CreateReportAccessInformationFileMutation>;
export type CreateReportAccessInformationFileMutationOptions = Apollo.BaseMutationOptions<CreateReportAccessInformationFileMutation, CreateReportAccessInformationFileMutationVariables>;
export const UpdateReportAccessInformationFileDocument = gql`
    mutation UpdateReportAccessInformationFile($input: updateReportAccessInformationFileInput!) {
  updateReportAccessInformationFile(input: $input) {
    reportAccessInformationFile {
      ...reportAccessInformationFileFields
    }
  }
}
    ${ReportAccessInformationFileFieldsFragmentDoc}`;
export type UpdateReportAccessInformationFileMutationFn = Apollo.MutationFunction<UpdateReportAccessInformationFileMutation, UpdateReportAccessInformationFileMutationVariables>;

/**
 * __useUpdateReportAccessInformationFileMutation__
 *
 * To run a mutation, you first call `useUpdateReportAccessInformationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportAccessInformationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportAccessInformationFileMutation, { data, loading, error }] = useUpdateReportAccessInformationFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportAccessInformationFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportAccessInformationFileMutation, UpdateReportAccessInformationFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportAccessInformationFileMutation, UpdateReportAccessInformationFileMutationVariables>(UpdateReportAccessInformationFileDocument, options);
      }
export type UpdateReportAccessInformationFileMutationHookResult = ReturnType<typeof useUpdateReportAccessInformationFileMutation>;
export type UpdateReportAccessInformationFileMutationResult = Apollo.MutationResult<UpdateReportAccessInformationFileMutation>;
export type UpdateReportAccessInformationFileMutationOptions = Apollo.BaseMutationOptions<UpdateReportAccessInformationFileMutation, UpdateReportAccessInformationFileMutationVariables>;
export const DeleteReportAccessInformationFileDocument = gql`
    mutation DeleteReportAccessInformationFile($input: deleteReportAccessInformationFileInput!) {
  deleteReportAccessInformationFile(input: $input) {
    __typename
  }
}
    `;
export type DeleteReportAccessInformationFileMutationFn = Apollo.MutationFunction<DeleteReportAccessInformationFileMutation, DeleteReportAccessInformationFileMutationVariables>;

/**
 * __useDeleteReportAccessInformationFileMutation__
 *
 * To run a mutation, you first call `useDeleteReportAccessInformationFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportAccessInformationFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportAccessInformationFileMutation, { data, loading, error }] = useDeleteReportAccessInformationFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportAccessInformationFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportAccessInformationFileMutation, DeleteReportAccessInformationFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportAccessInformationFileMutation, DeleteReportAccessInformationFileMutationVariables>(DeleteReportAccessInformationFileDocument, options);
      }
export type DeleteReportAccessInformationFileMutationHookResult = ReturnType<typeof useDeleteReportAccessInformationFileMutation>;
export type DeleteReportAccessInformationFileMutationResult = Apollo.MutationResult<DeleteReportAccessInformationFileMutation>;
export type DeleteReportAccessInformationFileMutationOptions = Apollo.BaseMutationOptions<DeleteReportAccessInformationFileMutation, DeleteReportAccessInformationFileMutationVariables>;
export const UpdateReportAccessInformationDocument = gql`
    mutation UpdateReportAccessInformation($input: updateReportAccessInformationInput!) {
  updateReportAccessInformation(input: $input) {
    reportAccessInformation {
      ...reportAccessInformationFields
    }
  }
}
    ${ReportAccessInformationFieldsFragmentDoc}`;
export type UpdateReportAccessInformationMutationFn = Apollo.MutationFunction<UpdateReportAccessInformationMutation, UpdateReportAccessInformationMutationVariables>;

/**
 * __useUpdateReportAccessInformationMutation__
 *
 * To run a mutation, you first call `useUpdateReportAccessInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportAccessInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportAccessInformationMutation, { data, loading, error }] = useUpdateReportAccessInformationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportAccessInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportAccessInformationMutation, UpdateReportAccessInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportAccessInformationMutation, UpdateReportAccessInformationMutationVariables>(UpdateReportAccessInformationDocument, options);
      }
export type UpdateReportAccessInformationMutationHookResult = ReturnType<typeof useUpdateReportAccessInformationMutation>;
export type UpdateReportAccessInformationMutationResult = Apollo.MutationResult<UpdateReportAccessInformationMutation>;
export type UpdateReportAccessInformationMutationOptions = Apollo.BaseMutationOptions<UpdateReportAccessInformationMutation, UpdateReportAccessInformationMutationVariables>;
export const UpdateReportClientDocument = gql`
    mutation UpdateReportClient($input: updateReportClientInput!) {
  updateReportClient(input: $input) {
    reportClient {
      ...reportClientFields
    }
  }
}
    ${ReportClientFieldsFragmentDoc}`;
export type UpdateReportClientMutationFn = Apollo.MutationFunction<UpdateReportClientMutation, UpdateReportClientMutationVariables>;

/**
 * __useUpdateReportClientMutation__
 *
 * To run a mutation, you first call `useUpdateReportClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportClientMutation, { data, loading, error }] = useUpdateReportClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportClientMutation, UpdateReportClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportClientMutation, UpdateReportClientMutationVariables>(UpdateReportClientDocument, options);
      }
export type UpdateReportClientMutationHookResult = ReturnType<typeof useUpdateReportClientMutation>;
export type UpdateReportClientMutationResult = Apollo.MutationResult<UpdateReportClientMutation>;
export type UpdateReportClientMutationOptions = Apollo.BaseMutationOptions<UpdateReportClientMutation, UpdateReportClientMutationVariables>;
export const UpdateReportConsultantDocument = gql`
    mutation UpdateReportConsultant($input: updateReportConsultantInput!) {
  updateReportConsultant(input: $input) {
    reportConsultant {
      ...reportConsultantFields
    }
  }
}
    ${ReportConsultantFieldsFragmentDoc}`;
export type UpdateReportConsultantMutationFn = Apollo.MutationFunction<UpdateReportConsultantMutation, UpdateReportConsultantMutationVariables>;

/**
 * __useUpdateReportConsultantMutation__
 *
 * To run a mutation, you first call `useUpdateReportConsultantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportConsultantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportConsultantMutation, { data, loading, error }] = useUpdateReportConsultantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportConsultantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportConsultantMutation, UpdateReportConsultantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportConsultantMutation, UpdateReportConsultantMutationVariables>(UpdateReportConsultantDocument, options);
      }
export type UpdateReportConsultantMutationHookResult = ReturnType<typeof useUpdateReportConsultantMutation>;
export type UpdateReportConsultantMutationResult = Apollo.MutationResult<UpdateReportConsultantMutation>;
export type UpdateReportConsultantMutationOptions = Apollo.BaseMutationOptions<UpdateReportConsultantMutation, UpdateReportConsultantMutationVariables>;
export const UpdateReportContactDocument = gql`
    mutation UpdateReportContact($input: updateReportContactInput!) {
  updateReportContact(input: $input) {
    reportContact {
      ...reportContactFields
    }
  }
}
    ${ReportContactFieldsFragmentDoc}`;
export type UpdateReportContactMutationFn = Apollo.MutationFunction<UpdateReportContactMutation, UpdateReportContactMutationVariables>;

/**
 * __useUpdateReportContactMutation__
 *
 * To run a mutation, you first call `useUpdateReportContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportContactMutation, { data, loading, error }] = useUpdateReportContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportContactMutation, UpdateReportContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportContactMutation, UpdateReportContactMutationVariables>(UpdateReportContactDocument, options);
      }
export type UpdateReportContactMutationHookResult = ReturnType<typeof useUpdateReportContactMutation>;
export type UpdateReportContactMutationResult = Apollo.MutationResult<UpdateReportContactMutation>;
export type UpdateReportContactMutationOptions = Apollo.BaseMutationOptions<UpdateReportContactMutation, UpdateReportContactMutationVariables>;
export const CreateReportDeliverableFileDocument = gql`
    mutation CreateReportDeliverableFile($input: createReportDeliverableFileInput!) {
  createReportDeliverableFile(input: $input) {
    reportDeliverableFile {
      ...reportDeliverableFileFields
    }
  }
}
    ${ReportDeliverableFileFieldsFragmentDoc}`;
export type CreateReportDeliverableFileMutationFn = Apollo.MutationFunction<CreateReportDeliverableFileMutation, CreateReportDeliverableFileMutationVariables>;

/**
 * __useCreateReportDeliverableFileMutation__
 *
 * To run a mutation, you first call `useCreateReportDeliverableFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportDeliverableFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportDeliverableFileMutation, { data, loading, error }] = useCreateReportDeliverableFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportDeliverableFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportDeliverableFileMutation, CreateReportDeliverableFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportDeliverableFileMutation, CreateReportDeliverableFileMutationVariables>(CreateReportDeliverableFileDocument, options);
      }
export type CreateReportDeliverableFileMutationHookResult = ReturnType<typeof useCreateReportDeliverableFileMutation>;
export type CreateReportDeliverableFileMutationResult = Apollo.MutationResult<CreateReportDeliverableFileMutation>;
export type CreateReportDeliverableFileMutationOptions = Apollo.BaseMutationOptions<CreateReportDeliverableFileMutation, CreateReportDeliverableFileMutationVariables>;
export const UpdateReportDeliverableFileDocument = gql`
    mutation UpdateReportDeliverableFile($input: updateReportDeliverableFileInput!) {
  updateReportDeliverableFile(input: $input) {
    reportDeliverableFile {
      ...reportDeliverableFileFields
    }
  }
}
    ${ReportDeliverableFileFieldsFragmentDoc}`;
export type UpdateReportDeliverableFileMutationFn = Apollo.MutationFunction<UpdateReportDeliverableFileMutation, UpdateReportDeliverableFileMutationVariables>;

/**
 * __useUpdateReportDeliverableFileMutation__
 *
 * To run a mutation, you first call `useUpdateReportDeliverableFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportDeliverableFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportDeliverableFileMutation, { data, loading, error }] = useUpdateReportDeliverableFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportDeliverableFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportDeliverableFileMutation, UpdateReportDeliverableFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportDeliverableFileMutation, UpdateReportDeliverableFileMutationVariables>(UpdateReportDeliverableFileDocument, options);
      }
export type UpdateReportDeliverableFileMutationHookResult = ReturnType<typeof useUpdateReportDeliverableFileMutation>;
export type UpdateReportDeliverableFileMutationResult = Apollo.MutationResult<UpdateReportDeliverableFileMutation>;
export type UpdateReportDeliverableFileMutationOptions = Apollo.BaseMutationOptions<UpdateReportDeliverableFileMutation, UpdateReportDeliverableFileMutationVariables>;
export const DeleteReportDeliverableFileDocument = gql`
    mutation DeleteReportDeliverableFile($input: deleteReportDeliverableFileInput!) {
  deleteReportDeliverableFile(input: $input) {
    __typename
  }
}
    `;
export type DeleteReportDeliverableFileMutationFn = Apollo.MutationFunction<DeleteReportDeliverableFileMutation, DeleteReportDeliverableFileMutationVariables>;

/**
 * __useDeleteReportDeliverableFileMutation__
 *
 * To run a mutation, you first call `useDeleteReportDeliverableFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportDeliverableFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportDeliverableFileMutation, { data, loading, error }] = useDeleteReportDeliverableFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportDeliverableFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportDeliverableFileMutation, DeleteReportDeliverableFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportDeliverableFileMutation, DeleteReportDeliverableFileMutationVariables>(DeleteReportDeliverableFileDocument, options);
      }
export type DeleteReportDeliverableFileMutationHookResult = ReturnType<typeof useDeleteReportDeliverableFileMutation>;
export type DeleteReportDeliverableFileMutationResult = Apollo.MutationResult<DeleteReportDeliverableFileMutation>;
export type DeleteReportDeliverableFileMutationOptions = Apollo.BaseMutationOptions<DeleteReportDeliverableFileMutation, DeleteReportDeliverableFileMutationVariables>;
export const UpdateReportEngagementOverviewDocument = gql`
    mutation UpdateReportEngagementOverview($input: updateReportEngagementOverviewInput!) {
  updateReportEngagementOverview(input: $input) {
    reportEngagementOverview {
      ...reportEngagementOverviewFields
    }
  }
}
    ${ReportEngagementOverviewFieldsFragmentDoc}`;
export type UpdateReportEngagementOverviewMutationFn = Apollo.MutationFunction<UpdateReportEngagementOverviewMutation, UpdateReportEngagementOverviewMutationVariables>;

/**
 * __useUpdateReportEngagementOverviewMutation__
 *
 * To run a mutation, you first call `useUpdateReportEngagementOverviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportEngagementOverviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportEngagementOverviewMutation, { data, loading, error }] = useUpdateReportEngagementOverviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportEngagementOverviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportEngagementOverviewMutation, UpdateReportEngagementOverviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportEngagementOverviewMutation, UpdateReportEngagementOverviewMutationVariables>(UpdateReportEngagementOverviewDocument, options);
      }
export type UpdateReportEngagementOverviewMutationHookResult = ReturnType<typeof useUpdateReportEngagementOverviewMutation>;
export type UpdateReportEngagementOverviewMutationResult = Apollo.MutationResult<UpdateReportEngagementOverviewMutation>;
export type UpdateReportEngagementOverviewMutationOptions = Apollo.BaseMutationOptions<UpdateReportEngagementOverviewMutation, UpdateReportEngagementOverviewMutationVariables>;
export const CreateReportInviteDocument = gql`
    mutation CreateReportInvite($input: createReportInviteInput!) {
  createReportInvite(input: $input) {
    reportInvite {
      ...createReportInviteFields
    }
  }
}
    ${CreateReportInviteFieldsFragmentDoc}`;
export type CreateReportInviteMutationFn = Apollo.MutationFunction<CreateReportInviteMutation, CreateReportInviteMutationVariables>;

/**
 * __useCreateReportInviteMutation__
 *
 * To run a mutation, you first call `useCreateReportInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportInviteMutation, { data, loading, error }] = useCreateReportInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportInviteMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportInviteMutation, CreateReportInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportInviteMutation, CreateReportInviteMutationVariables>(CreateReportInviteDocument, options);
      }
export type CreateReportInviteMutationHookResult = ReturnType<typeof useCreateReportInviteMutation>;
export type CreateReportInviteMutationResult = Apollo.MutationResult<CreateReportInviteMutation>;
export type CreateReportInviteMutationOptions = Apollo.BaseMutationOptions<CreateReportInviteMutation, CreateReportInviteMutationVariables>;
export const AcceptReportInviteDocument = gql`
    mutation AcceptReportInvite($input: acceptReportInviteInput!) {
  acceptReportInvite(input: $input) {
    reportInvite {
      ...reportInviteFields
    }
  }
}
    ${ReportInviteFieldsFragmentDoc}`;
export type AcceptReportInviteMutationFn = Apollo.MutationFunction<AcceptReportInviteMutation, AcceptReportInviteMutationVariables>;

/**
 * __useAcceptReportInviteMutation__
 *
 * To run a mutation, you first call `useAcceptReportInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReportInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReportInviteMutation, { data, loading, error }] = useAcceptReportInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptReportInviteMutation(baseOptions?: Apollo.MutationHookOptions<AcceptReportInviteMutation, AcceptReportInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptReportInviteMutation, AcceptReportInviteMutationVariables>(AcceptReportInviteDocument, options);
      }
export type AcceptReportInviteMutationHookResult = ReturnType<typeof useAcceptReportInviteMutation>;
export type AcceptReportInviteMutationResult = Apollo.MutationResult<AcceptReportInviteMutation>;
export type AcceptReportInviteMutationOptions = Apollo.BaseMutationOptions<AcceptReportInviteMutation, AcceptReportInviteMutationVariables>;
export const ResendReportInviteDocument = gql`
    mutation ResendReportInvite($input: resendReportInviteInput!) {
  resendReportInvite(input: $input) {
    reportInvite {
      ...reportInviteFields
    }
  }
}
    ${ReportInviteFieldsFragmentDoc}`;
export type ResendReportInviteMutationFn = Apollo.MutationFunction<ResendReportInviteMutation, ResendReportInviteMutationVariables>;

/**
 * __useResendReportInviteMutation__
 *
 * To run a mutation, you first call `useResendReportInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendReportInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendReportInviteMutation, { data, loading, error }] = useResendReportInviteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendReportInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendReportInviteMutation, ResendReportInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendReportInviteMutation, ResendReportInviteMutationVariables>(ResendReportInviteDocument, options);
      }
export type ResendReportInviteMutationHookResult = ReturnType<typeof useResendReportInviteMutation>;
export type ResendReportInviteMutationResult = Apollo.MutationResult<ResendReportInviteMutation>;
export type ResendReportInviteMutationOptions = Apollo.BaseMutationOptions<ResendReportInviteMutation, ResendReportInviteMutationVariables>;
export const DeleteReportInviteDocument = gql`
    mutation DeleteReportInvite($inviteId: ID!) {
  deleteReportInvite(input: {id: $inviteId}) {
    __typename
  }
}
    `;
export type DeleteReportInviteMutationFn = Apollo.MutationFunction<DeleteReportInviteMutation, DeleteReportInviteMutationVariables>;

/**
 * __useDeleteReportInviteMutation__
 *
 * To run a mutation, you first call `useDeleteReportInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportInviteMutation, { data, loading, error }] = useDeleteReportInviteMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useDeleteReportInviteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportInviteMutation, DeleteReportInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportInviteMutation, DeleteReportInviteMutationVariables>(DeleteReportInviteDocument, options);
      }
export type DeleteReportInviteMutationHookResult = ReturnType<typeof useDeleteReportInviteMutation>;
export type DeleteReportInviteMutationResult = Apollo.MutationResult<DeleteReportInviteMutation>;
export type DeleteReportInviteMutationOptions = Apollo.BaseMutationOptions<DeleteReportInviteMutation, DeleteReportInviteMutationVariables>;
export const UploadReportMediaObjectDocument = gql`
    mutation UploadReportMediaObject($file: Upload!, $versionId: ID!) {
  uploadReportMediaObject(input: {file: $file, version: $versionId}) {
    reportMediaObject {
      ...reportMediaObjectFields
    }
  }
}
    ${ReportMediaObjectFieldsFragmentDoc}`;
export type UploadReportMediaObjectMutationFn = Apollo.MutationFunction<UploadReportMediaObjectMutation, UploadReportMediaObjectMutationVariables>;

/**
 * __useUploadReportMediaObjectMutation__
 *
 * To run a mutation, you first call `useUploadReportMediaObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadReportMediaObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadReportMediaObjectMutation, { data, loading, error }] = useUploadReportMediaObjectMutation({
 *   variables: {
 *      file: // value for 'file'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useUploadReportMediaObjectMutation(baseOptions?: Apollo.MutationHookOptions<UploadReportMediaObjectMutation, UploadReportMediaObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadReportMediaObjectMutation, UploadReportMediaObjectMutationVariables>(UploadReportMediaObjectDocument, options);
      }
export type UploadReportMediaObjectMutationHookResult = ReturnType<typeof useUploadReportMediaObjectMutation>;
export type UploadReportMediaObjectMutationResult = Apollo.MutationResult<UploadReportMediaObjectMutation>;
export type UploadReportMediaObjectMutationOptions = Apollo.BaseMutationOptions<UploadReportMediaObjectMutation, UploadReportMediaObjectMutationVariables>;
export const CreateReportReadReceiptDocument = gql`
    mutation CreateReportReadReceipt($input: createReportReadReceiptInput!) {
  createReportReadReceipt(input: $input) {
    reportReadReceipt {
      ...reportReadReceiptListFields
    }
  }
}
    ${ReportReadReceiptListFieldsFragmentDoc}`;
export type CreateReportReadReceiptMutationFn = Apollo.MutationFunction<CreateReportReadReceiptMutation, CreateReportReadReceiptMutationVariables>;

/**
 * __useCreateReportReadReceiptMutation__
 *
 * To run a mutation, you first call `useCreateReportReadReceiptMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportReadReceiptMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportReadReceiptMutation, { data, loading, error }] = useCreateReportReadReceiptMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportReadReceiptMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportReadReceiptMutation, CreateReportReadReceiptMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportReadReceiptMutation, CreateReportReadReceiptMutationVariables>(CreateReportReadReceiptDocument, options);
      }
export type CreateReportReadReceiptMutationHookResult = ReturnType<typeof useCreateReportReadReceiptMutation>;
export type CreateReportReadReceiptMutationResult = Apollo.MutationResult<CreateReportReadReceiptMutation>;
export type CreateReportReadReceiptMutationOptions = Apollo.BaseMutationOptions<CreateReportReadReceiptMutation, CreateReportReadReceiptMutationVariables>;
export const UpdateReportScopeDocument = gql`
    mutation UpdateReportScope($input: updateReportScopeInput!) {
  updateReportScope(input: $input) {
    reportScope {
      ...reportScopeFields
    }
  }
}
    ${ReportScopeFieldsFragmentDoc}`;
export type UpdateReportScopeMutationFn = Apollo.MutationFunction<UpdateReportScopeMutation, UpdateReportScopeMutationVariables>;

/**
 * __useUpdateReportScopeMutation__
 *
 * To run a mutation, you first call `useUpdateReportScopeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportScopeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportScopeMutation, { data, loading, error }] = useUpdateReportScopeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportScopeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportScopeMutation, UpdateReportScopeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportScopeMutation, UpdateReportScopeMutationVariables>(UpdateReportScopeDocument, options);
      }
export type UpdateReportScopeMutationHookResult = ReturnType<typeof useUpdateReportScopeMutation>;
export type UpdateReportScopeMutationResult = Apollo.MutationResult<UpdateReportScopeMutation>;
export type UpdateReportScopeMutationOptions = Apollo.BaseMutationOptions<UpdateReportScopeMutation, UpdateReportScopeMutationVariables>;
export const UpdateReportSectionDocument = gql`
    mutation UpdateReportSection($input: updateReportSectionInput!) {
  updateReportSection(input: $input) {
    reportSection {
      ...reportSectionFields
    }
  }
}
    ${ReportSectionFieldsFragmentDoc}`;
export type UpdateReportSectionMutationFn = Apollo.MutationFunction<UpdateReportSectionMutation, UpdateReportSectionMutationVariables>;

/**
 * __useUpdateReportSectionMutation__
 *
 * To run a mutation, you first call `useUpdateReportSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportSectionMutation, { data, loading, error }] = useUpdateReportSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportSectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportSectionMutation, UpdateReportSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportSectionMutation, UpdateReportSectionMutationVariables>(UpdateReportSectionDocument, options);
      }
export type UpdateReportSectionMutationHookResult = ReturnType<typeof useUpdateReportSectionMutation>;
export type UpdateReportSectionMutationResult = Apollo.MutationResult<UpdateReportSectionMutation>;
export type UpdateReportSectionMutationOptions = Apollo.BaseMutationOptions<UpdateReportSectionMutation, UpdateReportSectionMutationVariables>;
export const CreateReportTestTypePrerequisiteDocument = gql`
    mutation CreateReportTestTypePrerequisite($input: createReportTestTypePrerequisiteInput!) {
  createReportTestTypePrerequisite(input: $input) {
    reportTestTypePrerequisite {
      ...reportTestTypePrerequisiteFields
    }
  }
}
    ${ReportTestTypePrerequisiteFieldsFragmentDoc}`;
export type CreateReportTestTypePrerequisiteMutationFn = Apollo.MutationFunction<CreateReportTestTypePrerequisiteMutation, CreateReportTestTypePrerequisiteMutationVariables>;

/**
 * __useCreateReportTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useCreateReportTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportTestTypePrerequisiteMutation, { data, loading, error }] = useCreateReportTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportTestTypePrerequisiteMutation, CreateReportTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportTestTypePrerequisiteMutation, CreateReportTestTypePrerequisiteMutationVariables>(CreateReportTestTypePrerequisiteDocument, options);
      }
export type CreateReportTestTypePrerequisiteMutationHookResult = ReturnType<typeof useCreateReportTestTypePrerequisiteMutation>;
export type CreateReportTestTypePrerequisiteMutationResult = Apollo.MutationResult<CreateReportTestTypePrerequisiteMutation>;
export type CreateReportTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<CreateReportTestTypePrerequisiteMutation, CreateReportTestTypePrerequisiteMutationVariables>;
export const UpdateReportTestTypePrerequisiteDocument = gql`
    mutation UpdateReportTestTypePrerequisite($input: updateReportTestTypePrerequisiteInput!) {
  updateReportTestTypePrerequisite(input: $input) {
    reportTestTypePrerequisite {
      ...reportTestTypePrerequisiteFields
    }
  }
}
    ${ReportTestTypePrerequisiteFieldsFragmentDoc}`;
export type UpdateReportTestTypePrerequisiteMutationFn = Apollo.MutationFunction<UpdateReportTestTypePrerequisiteMutation, UpdateReportTestTypePrerequisiteMutationVariables>;

/**
 * __useUpdateReportTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useUpdateReportTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportTestTypePrerequisiteMutation, { data, loading, error }] = useUpdateReportTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportTestTypePrerequisiteMutation, UpdateReportTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportTestTypePrerequisiteMutation, UpdateReportTestTypePrerequisiteMutationVariables>(UpdateReportTestTypePrerequisiteDocument, options);
      }
export type UpdateReportTestTypePrerequisiteMutationHookResult = ReturnType<typeof useUpdateReportTestTypePrerequisiteMutation>;
export type UpdateReportTestTypePrerequisiteMutationResult = Apollo.MutationResult<UpdateReportTestTypePrerequisiteMutation>;
export type UpdateReportTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<UpdateReportTestTypePrerequisiteMutation, UpdateReportTestTypePrerequisiteMutationVariables>;
export const DeleteReportTestTypePrerequisiteDocument = gql`
    mutation DeleteReportTestTypePrerequisite($input: deleteReportTestTypePrerequisiteInput!) {
  deleteReportTestTypePrerequisite(input: $input) {
    __typename
  }
}
    `;
export type DeleteReportTestTypePrerequisiteMutationFn = Apollo.MutationFunction<DeleteReportTestTypePrerequisiteMutation, DeleteReportTestTypePrerequisiteMutationVariables>;

/**
 * __useDeleteReportTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useDeleteReportTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportTestTypePrerequisiteMutation, { data, loading, error }] = useDeleteReportTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportTestTypePrerequisiteMutation, DeleteReportTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportTestTypePrerequisiteMutation, DeleteReportTestTypePrerequisiteMutationVariables>(DeleteReportTestTypePrerequisiteDocument, options);
      }
export type DeleteReportTestTypePrerequisiteMutationHookResult = ReturnType<typeof useDeleteReportTestTypePrerequisiteMutation>;
export type DeleteReportTestTypePrerequisiteMutationResult = Apollo.MutationResult<DeleteReportTestTypePrerequisiteMutation>;
export type DeleteReportTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<DeleteReportTestTypePrerequisiteMutation, DeleteReportTestTypePrerequisiteMutationVariables>;
export const CompleteReportTestTypePrerequisiteDocument = gql`
    mutation CompleteReportTestTypePrerequisite($input: completeReportTestTypePrerequisiteInput!) {
  completeReportTestTypePrerequisite(input: $input) {
    reportTestTypePrerequisite {
      ...reportTestTypePrerequisiteFields
    }
  }
}
    ${ReportTestTypePrerequisiteFieldsFragmentDoc}`;
export type CompleteReportTestTypePrerequisiteMutationFn = Apollo.MutationFunction<CompleteReportTestTypePrerequisiteMutation, CompleteReportTestTypePrerequisiteMutationVariables>;

/**
 * __useCompleteReportTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useCompleteReportTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteReportTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeReportTestTypePrerequisiteMutation, { data, loading, error }] = useCompleteReportTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteReportTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<CompleteReportTestTypePrerequisiteMutation, CompleteReportTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteReportTestTypePrerequisiteMutation, CompleteReportTestTypePrerequisiteMutationVariables>(CompleteReportTestTypePrerequisiteDocument, options);
      }
export type CompleteReportTestTypePrerequisiteMutationHookResult = ReturnType<typeof useCompleteReportTestTypePrerequisiteMutation>;
export type CompleteReportTestTypePrerequisiteMutationResult = Apollo.MutationResult<CompleteReportTestTypePrerequisiteMutation>;
export type CompleteReportTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<CompleteReportTestTypePrerequisiteMutation, CompleteReportTestTypePrerequisiteMutationVariables>;
export const UpdateReportUserDocument = gql`
    mutation UpdateReportUser($input: updateReportUserInput!) {
  updateReportUser(input: $input) {
    reportUser {
      ...reportUserListFields
    }
  }
}
    ${ReportUserListFieldsFragmentDoc}`;
export type UpdateReportUserMutationFn = Apollo.MutationFunction<UpdateReportUserMutation, UpdateReportUserMutationVariables>;

/**
 * __useUpdateReportUserMutation__
 *
 * To run a mutation, you first call `useUpdateReportUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportUserMutation, { data, loading, error }] = useUpdateReportUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportUserMutation, UpdateReportUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportUserMutation, UpdateReportUserMutationVariables>(UpdateReportUserDocument, options);
      }
export type UpdateReportUserMutationHookResult = ReturnType<typeof useUpdateReportUserMutation>;
export type UpdateReportUserMutationResult = Apollo.MutationResult<UpdateReportUserMutation>;
export type UpdateReportUserMutationOptions = Apollo.BaseMutationOptions<UpdateReportUserMutation, UpdateReportUserMutationVariables>;
export const UpdateReportVersionDocument = gql`
    mutation UpdateReportVersion($input: updateReportVersionInput!) {
  updateReportVersion(input: $input) {
    reportVersion {
      ...reportVersionFields
    }
  }
}
    ${ReportVersionFieldsFragmentDoc}`;
export type UpdateReportVersionMutationFn = Apollo.MutationFunction<UpdateReportVersionMutation, UpdateReportVersionMutationVariables>;

/**
 * __useUpdateReportVersionMutation__
 *
 * To run a mutation, you first call `useUpdateReportVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportVersionMutation, { data, loading, error }] = useUpdateReportVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportVersionMutation, UpdateReportVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportVersionMutation, UpdateReportVersionMutationVariables>(UpdateReportVersionDocument, options);
      }
export type UpdateReportVersionMutationHookResult = ReturnType<typeof useUpdateReportVersionMutation>;
export type UpdateReportVersionMutationResult = Apollo.MutationResult<UpdateReportVersionMutation>;
export type UpdateReportVersionMutationOptions = Apollo.BaseMutationOptions<UpdateReportVersionMutation, UpdateReportVersionMutationVariables>;
export const TransitionReportVersionStatusDocument = gql`
    mutation TransitionReportVersionStatus($reportVersionId: ID!, $transition: ReportVersionTransition!) {
  transitionReportVersion(input: {id: $reportVersionId, transition: $transition}) {
    reportVersion {
      ...reportVersionFields
    }
  }
}
    ${ReportVersionFieldsFragmentDoc}`;
export type TransitionReportVersionStatusMutationFn = Apollo.MutationFunction<TransitionReportVersionStatusMutation, TransitionReportVersionStatusMutationVariables>;

/**
 * __useTransitionReportVersionStatusMutation__
 *
 * To run a mutation, you first call `useTransitionReportVersionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransitionReportVersionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transitionReportVersionStatusMutation, { data, loading, error }] = useTransitionReportVersionStatusMutation({
 *   variables: {
 *      reportVersionId: // value for 'reportVersionId'
 *      transition: // value for 'transition'
 *   },
 * });
 */
export function useTransitionReportVersionStatusMutation(baseOptions?: Apollo.MutationHookOptions<TransitionReportVersionStatusMutation, TransitionReportVersionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransitionReportVersionStatusMutation, TransitionReportVersionStatusMutationVariables>(TransitionReportVersionStatusDocument, options);
      }
export type TransitionReportVersionStatusMutationHookResult = ReturnType<typeof useTransitionReportVersionStatusMutation>;
export type TransitionReportVersionStatusMutationResult = Apollo.MutationResult<TransitionReportVersionStatusMutation>;
export type TransitionReportVersionStatusMutationOptions = Apollo.BaseMutationOptions<TransitionReportVersionStatusMutation, TransitionReportVersionStatusMutationVariables>;
export const SendCustomReportVersionEmailDocument = gql`
    mutation SendCustomReportVersionEmail($input: sendCustomEmailReportVersionInput!) {
  sendCustomEmailReportVersion(input: $input) {
    clientMutationId
  }
}
    `;
export type SendCustomReportVersionEmailMutationFn = Apollo.MutationFunction<SendCustomReportVersionEmailMutation, SendCustomReportVersionEmailMutationVariables>;

/**
 * __useSendCustomReportVersionEmailMutation__
 *
 * To run a mutation, you first call `useSendCustomReportVersionEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomReportVersionEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomReportVersionEmailMutation, { data, loading, error }] = useSendCustomReportVersionEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCustomReportVersionEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendCustomReportVersionEmailMutation, SendCustomReportVersionEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendCustomReportVersionEmailMutation, SendCustomReportVersionEmailMutationVariables>(SendCustomReportVersionEmailDocument, options);
      }
export type SendCustomReportVersionEmailMutationHookResult = ReturnType<typeof useSendCustomReportVersionEmailMutation>;
export type SendCustomReportVersionEmailMutationResult = Apollo.MutationResult<SendCustomReportVersionEmailMutation>;
export type SendCustomReportVersionEmailMutationOptions = Apollo.BaseMutationOptions<SendCustomReportVersionEmailMutation, SendCustomReportVersionEmailMutationVariables>;
export const SendDailyTestCommencementEmailDocument = gql`
    mutation SendDailyTestCommencementEmail($reportVersionId: ID!) {
  sendDailyTestCommencementEmailReportVersion(input: {id: $reportVersionId}) {
    clientMutationId
  }
}
    `;
export type SendDailyTestCommencementEmailMutationFn = Apollo.MutationFunction<SendDailyTestCommencementEmailMutation, SendDailyTestCommencementEmailMutationVariables>;

/**
 * __useSendDailyTestCommencementEmailMutation__
 *
 * To run a mutation, you first call `useSendDailyTestCommencementEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDailyTestCommencementEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDailyTestCommencementEmailMutation, { data, loading, error }] = useSendDailyTestCommencementEmailMutation({
 *   variables: {
 *      reportVersionId: // value for 'reportVersionId'
 *   },
 * });
 */
export function useSendDailyTestCommencementEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendDailyTestCommencementEmailMutation, SendDailyTestCommencementEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDailyTestCommencementEmailMutation, SendDailyTestCommencementEmailMutationVariables>(SendDailyTestCommencementEmailDocument, options);
      }
export type SendDailyTestCommencementEmailMutationHookResult = ReturnType<typeof useSendDailyTestCommencementEmailMutation>;
export type SendDailyTestCommencementEmailMutationResult = Apollo.MutationResult<SendDailyTestCommencementEmailMutation>;
export type SendDailyTestCommencementEmailMutationOptions = Apollo.BaseMutationOptions<SendDailyTestCommencementEmailMutation, SendDailyTestCommencementEmailMutationVariables>;
export const SendDailyTestCompletionEmailDocument = gql`
    mutation SendDailyTestCompletionEmail($reportVersionId: ID!) {
  sendDailyTestCompletionEmailReportVersion(input: {id: $reportVersionId}) {
    clientMutationId
  }
}
    `;
export type SendDailyTestCompletionEmailMutationFn = Apollo.MutationFunction<SendDailyTestCompletionEmailMutation, SendDailyTestCompletionEmailMutationVariables>;

/**
 * __useSendDailyTestCompletionEmailMutation__
 *
 * To run a mutation, you first call `useSendDailyTestCompletionEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDailyTestCompletionEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDailyTestCompletionEmailMutation, { data, loading, error }] = useSendDailyTestCompletionEmailMutation({
 *   variables: {
 *      reportVersionId: // value for 'reportVersionId'
 *   },
 * });
 */
export function useSendDailyTestCompletionEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendDailyTestCompletionEmailMutation, SendDailyTestCompletionEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDailyTestCompletionEmailMutation, SendDailyTestCompletionEmailMutationVariables>(SendDailyTestCompletionEmailDocument, options);
      }
export type SendDailyTestCompletionEmailMutationHookResult = ReturnType<typeof useSendDailyTestCompletionEmailMutation>;
export type SendDailyTestCompletionEmailMutationResult = Apollo.MutationResult<SendDailyTestCompletionEmailMutation>;
export type SendDailyTestCompletionEmailMutationOptions = Apollo.BaseMutationOptions<SendDailyTestCompletionEmailMutation, SendDailyTestCompletionEmailMutationVariables>;
export const SendPrerequisitesRequestInformationEmailDocument = gql`
    mutation SendPrerequisitesRequestInformationEmail($reportVersionId: ID!) {
  sendPrerequisitesRequestInformationEmailReportVersion(
    input: {id: $reportVersionId}
  ) {
    clientMutationId
  }
}
    `;
export type SendPrerequisitesRequestInformationEmailMutationFn = Apollo.MutationFunction<SendPrerequisitesRequestInformationEmailMutation, SendPrerequisitesRequestInformationEmailMutationVariables>;

/**
 * __useSendPrerequisitesRequestInformationEmailMutation__
 *
 * To run a mutation, you first call `useSendPrerequisitesRequestInformationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPrerequisitesRequestInformationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPrerequisitesRequestInformationEmailMutation, { data, loading, error }] = useSendPrerequisitesRequestInformationEmailMutation({
 *   variables: {
 *      reportVersionId: // value for 'reportVersionId'
 *   },
 * });
 */
export function useSendPrerequisitesRequestInformationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendPrerequisitesRequestInformationEmailMutation, SendPrerequisitesRequestInformationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPrerequisitesRequestInformationEmailMutation, SendPrerequisitesRequestInformationEmailMutationVariables>(SendPrerequisitesRequestInformationEmailDocument, options);
      }
export type SendPrerequisitesRequestInformationEmailMutationHookResult = ReturnType<typeof useSendPrerequisitesRequestInformationEmailMutation>;
export type SendPrerequisitesRequestInformationEmailMutationResult = Apollo.MutationResult<SendPrerequisitesRequestInformationEmailMutation>;
export type SendPrerequisitesRequestInformationEmailMutationOptions = Apollo.BaseMutationOptions<SendPrerequisitesRequestInformationEmailMutation, SendPrerequisitesRequestInformationEmailMutationVariables>;
export const SendScopeRequestInformationEmailDocument = gql`
    mutation SendScopeRequestInformationEmail($reportVersionId: ID!) {
  sendScopeRequestInformationEmailReportVersion(input: {id: $reportVersionId}) {
    clientMutationId
  }
}
    `;
export type SendScopeRequestInformationEmailMutationFn = Apollo.MutationFunction<SendScopeRequestInformationEmailMutation, SendScopeRequestInformationEmailMutationVariables>;

/**
 * __useSendScopeRequestInformationEmailMutation__
 *
 * To run a mutation, you first call `useSendScopeRequestInformationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendScopeRequestInformationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendScopeRequestInformationEmailMutation, { data, loading, error }] = useSendScopeRequestInformationEmailMutation({
 *   variables: {
 *      reportVersionId: // value for 'reportVersionId'
 *   },
 * });
 */
export function useSendScopeRequestInformationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendScopeRequestInformationEmailMutation, SendScopeRequestInformationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendScopeRequestInformationEmailMutation, SendScopeRequestInformationEmailMutationVariables>(SendScopeRequestInformationEmailDocument, options);
      }
export type SendScopeRequestInformationEmailMutationHookResult = ReturnType<typeof useSendScopeRequestInformationEmailMutation>;
export type SendScopeRequestInformationEmailMutationResult = Apollo.MutationResult<SendScopeRequestInformationEmailMutation>;
export type SendScopeRequestInformationEmailMutationOptions = Apollo.BaseMutationOptions<SendScopeRequestInformationEmailMutation, SendScopeRequestInformationEmailMutationVariables>;
export const CreateReportVulnerabilityActionDocument = gql`
    mutation CreateReportVulnerabilityAction($input: createReportVulnerabilityActionInput!) {
  createReportVulnerabilityAction(input: $input) {
    reportVulnerabilityAction {
      ...reportVulnerabilityActionFields
    }
  }
}
    ${ReportVulnerabilityActionFieldsFragmentDoc}`;
export type CreateReportVulnerabilityActionMutationFn = Apollo.MutationFunction<CreateReportVulnerabilityActionMutation, CreateReportVulnerabilityActionMutationVariables>;

/**
 * __useCreateReportVulnerabilityActionMutation__
 *
 * To run a mutation, you first call `useCreateReportVulnerabilityActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportVulnerabilityActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportVulnerabilityActionMutation, { data, loading, error }] = useCreateReportVulnerabilityActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportVulnerabilityActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportVulnerabilityActionMutation, CreateReportVulnerabilityActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportVulnerabilityActionMutation, CreateReportVulnerabilityActionMutationVariables>(CreateReportVulnerabilityActionDocument, options);
      }
export type CreateReportVulnerabilityActionMutationHookResult = ReturnType<typeof useCreateReportVulnerabilityActionMutation>;
export type CreateReportVulnerabilityActionMutationResult = Apollo.MutationResult<CreateReportVulnerabilityActionMutation>;
export type CreateReportVulnerabilityActionMutationOptions = Apollo.BaseMutationOptions<CreateReportVulnerabilityActionMutation, CreateReportVulnerabilityActionMutationVariables>;
export const UpdateReportVulnerabilityActionDocument = gql`
    mutation UpdateReportVulnerabilityAction($input: updateReportVulnerabilityActionInput!) {
  updateReportVulnerabilityAction(input: $input) {
    reportVulnerabilityAction {
      ...reportVulnerabilityActionFields
    }
  }
}
    ${ReportVulnerabilityActionFieldsFragmentDoc}`;
export type UpdateReportVulnerabilityActionMutationFn = Apollo.MutationFunction<UpdateReportVulnerabilityActionMutation, UpdateReportVulnerabilityActionMutationVariables>;

/**
 * __useUpdateReportVulnerabilityActionMutation__
 *
 * To run a mutation, you first call `useUpdateReportVulnerabilityActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportVulnerabilityActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportVulnerabilityActionMutation, { data, loading, error }] = useUpdateReportVulnerabilityActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportVulnerabilityActionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportVulnerabilityActionMutation, UpdateReportVulnerabilityActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportVulnerabilityActionMutation, UpdateReportVulnerabilityActionMutationVariables>(UpdateReportVulnerabilityActionDocument, options);
      }
export type UpdateReportVulnerabilityActionMutationHookResult = ReturnType<typeof useUpdateReportVulnerabilityActionMutation>;
export type UpdateReportVulnerabilityActionMutationResult = Apollo.MutationResult<UpdateReportVulnerabilityActionMutation>;
export type UpdateReportVulnerabilityActionMutationOptions = Apollo.BaseMutationOptions<UpdateReportVulnerabilityActionMutation, UpdateReportVulnerabilityActionMutationVariables>;
export const DeleteReportVulnerabilityActionDocument = gql`
    mutation DeleteReportVulnerabilityAction($actionId: ID!) {
  deleteReportVulnerabilityAction(input: {id: $actionId}) {
    __typename
  }
}
    `;
export type DeleteReportVulnerabilityActionMutationFn = Apollo.MutationFunction<DeleteReportVulnerabilityActionMutation, DeleteReportVulnerabilityActionMutationVariables>;

/**
 * __useDeleteReportVulnerabilityActionMutation__
 *
 * To run a mutation, you first call `useDeleteReportVulnerabilityActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportVulnerabilityActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportVulnerabilityActionMutation, { data, loading, error }] = useDeleteReportVulnerabilityActionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDeleteReportVulnerabilityActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportVulnerabilityActionMutation, DeleteReportVulnerabilityActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportVulnerabilityActionMutation, DeleteReportVulnerabilityActionMutationVariables>(DeleteReportVulnerabilityActionDocument, options);
      }
export type DeleteReportVulnerabilityActionMutationHookResult = ReturnType<typeof useDeleteReportVulnerabilityActionMutation>;
export type DeleteReportVulnerabilityActionMutationResult = Apollo.MutationResult<DeleteReportVulnerabilityActionMutation>;
export type DeleteReportVulnerabilityActionMutationOptions = Apollo.BaseMutationOptions<DeleteReportVulnerabilityActionMutation, DeleteReportVulnerabilityActionMutationVariables>;
export const CreateReportVulnerabilityClientNotificationDocument = gql`
    mutation CreateReportVulnerabilityClientNotification($input: createReportVulnerabilityClientNotificationInput!) {
  createReportVulnerabilityClientNotification(input: $input) {
    reportVulnerabilityClientNotification {
      ...reportVulnerabilityClientNotificationListFields
    }
  }
}
    ${ReportVulnerabilityClientNotificationListFieldsFragmentDoc}`;
export type CreateReportVulnerabilityClientNotificationMutationFn = Apollo.MutationFunction<CreateReportVulnerabilityClientNotificationMutation, CreateReportVulnerabilityClientNotificationMutationVariables>;

/**
 * __useCreateReportVulnerabilityClientNotificationMutation__
 *
 * To run a mutation, you first call `useCreateReportVulnerabilityClientNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportVulnerabilityClientNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportVulnerabilityClientNotificationMutation, { data, loading, error }] = useCreateReportVulnerabilityClientNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportVulnerabilityClientNotificationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportVulnerabilityClientNotificationMutation, CreateReportVulnerabilityClientNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportVulnerabilityClientNotificationMutation, CreateReportVulnerabilityClientNotificationMutationVariables>(CreateReportVulnerabilityClientNotificationDocument, options);
      }
export type CreateReportVulnerabilityClientNotificationMutationHookResult = ReturnType<typeof useCreateReportVulnerabilityClientNotificationMutation>;
export type CreateReportVulnerabilityClientNotificationMutationResult = Apollo.MutationResult<CreateReportVulnerabilityClientNotificationMutation>;
export type CreateReportVulnerabilityClientNotificationMutationOptions = Apollo.BaseMutationOptions<CreateReportVulnerabilityClientNotificationMutation, CreateReportVulnerabilityClientNotificationMutationVariables>;
export const CreateReportVulnerabilityCommentDocument = gql`
    mutation CreateReportVulnerabilityComment($input: createReportVulnerabilityCommentInput!) {
  createReportVulnerabilityComment(input: $input) {
    reportVulnerabilityComment {
      ...reportVulnerabilityCommentFields
    }
  }
}
    ${ReportVulnerabilityCommentFieldsFragmentDoc}`;
export type CreateReportVulnerabilityCommentMutationFn = Apollo.MutationFunction<CreateReportVulnerabilityCommentMutation, CreateReportVulnerabilityCommentMutationVariables>;

/**
 * __useCreateReportVulnerabilityCommentMutation__
 *
 * To run a mutation, you first call `useCreateReportVulnerabilityCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportVulnerabilityCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportVulnerabilityCommentMutation, { data, loading, error }] = useCreateReportVulnerabilityCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportVulnerabilityCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportVulnerabilityCommentMutation, CreateReportVulnerabilityCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportVulnerabilityCommentMutation, CreateReportVulnerabilityCommentMutationVariables>(CreateReportVulnerabilityCommentDocument, options);
      }
export type CreateReportVulnerabilityCommentMutationHookResult = ReturnType<typeof useCreateReportVulnerabilityCommentMutation>;
export type CreateReportVulnerabilityCommentMutationResult = Apollo.MutationResult<CreateReportVulnerabilityCommentMutation>;
export type CreateReportVulnerabilityCommentMutationOptions = Apollo.BaseMutationOptions<CreateReportVulnerabilityCommentMutation, CreateReportVulnerabilityCommentMutationVariables>;
export const DeleteReportVulnerabilityCommentDocument = gql`
    mutation DeleteReportVulnerabilityComment($commentId: ID!) {
  deleteReportVulnerabilityComment(input: {id: $commentId}) {
    __typename
  }
}
    `;
export type DeleteReportVulnerabilityCommentMutationFn = Apollo.MutationFunction<DeleteReportVulnerabilityCommentMutation, DeleteReportVulnerabilityCommentMutationVariables>;

/**
 * __useDeleteReportVulnerabilityCommentMutation__
 *
 * To run a mutation, you first call `useDeleteReportVulnerabilityCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportVulnerabilityCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportVulnerabilityCommentMutation, { data, loading, error }] = useDeleteReportVulnerabilityCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteReportVulnerabilityCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportVulnerabilityCommentMutation, DeleteReportVulnerabilityCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportVulnerabilityCommentMutation, DeleteReportVulnerabilityCommentMutationVariables>(DeleteReportVulnerabilityCommentDocument, options);
      }
export type DeleteReportVulnerabilityCommentMutationHookResult = ReturnType<typeof useDeleteReportVulnerabilityCommentMutation>;
export type DeleteReportVulnerabilityCommentMutationResult = Apollo.MutationResult<DeleteReportVulnerabilityCommentMutation>;
export type DeleteReportVulnerabilityCommentMutationOptions = Apollo.BaseMutationOptions<DeleteReportVulnerabilityCommentMutation, DeleteReportVulnerabilityCommentMutationVariables>;
export const CreateReportVulnerabilityFileDocument = gql`
    mutation CreateReportVulnerabilityFile($input: createReportVulnerabilityFileInput!) {
  createReportVulnerabilityFile(input: $input) {
    reportVulnerabilityFile {
      ...reportVulnerabilityFileFields
    }
  }
}
    ${ReportVulnerabilityFileFieldsFragmentDoc}`;
export type CreateReportVulnerabilityFileMutationFn = Apollo.MutationFunction<CreateReportVulnerabilityFileMutation, CreateReportVulnerabilityFileMutationVariables>;

/**
 * __useCreateReportVulnerabilityFileMutation__
 *
 * To run a mutation, you first call `useCreateReportVulnerabilityFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportVulnerabilityFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportVulnerabilityFileMutation, { data, loading, error }] = useCreateReportVulnerabilityFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportVulnerabilityFileMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportVulnerabilityFileMutation, CreateReportVulnerabilityFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportVulnerabilityFileMutation, CreateReportVulnerabilityFileMutationVariables>(CreateReportVulnerabilityFileDocument, options);
      }
export type CreateReportVulnerabilityFileMutationHookResult = ReturnType<typeof useCreateReportVulnerabilityFileMutation>;
export type CreateReportVulnerabilityFileMutationResult = Apollo.MutationResult<CreateReportVulnerabilityFileMutation>;
export type CreateReportVulnerabilityFileMutationOptions = Apollo.BaseMutationOptions<CreateReportVulnerabilityFileMutation, CreateReportVulnerabilityFileMutationVariables>;
export const UpdateReportVulnerabilityFileDocument = gql`
    mutation UpdateReportVulnerabilityFile($input: updateReportVulnerabilityFileInput!) {
  updateReportVulnerabilityFile(input: $input) {
    reportVulnerabilityFile {
      ...reportVulnerabilityFileFields
    }
  }
}
    ${ReportVulnerabilityFileFieldsFragmentDoc}`;
export type UpdateReportVulnerabilityFileMutationFn = Apollo.MutationFunction<UpdateReportVulnerabilityFileMutation, UpdateReportVulnerabilityFileMutationVariables>;

/**
 * __useUpdateReportVulnerabilityFileMutation__
 *
 * To run a mutation, you first call `useUpdateReportVulnerabilityFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportVulnerabilityFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportVulnerabilityFileMutation, { data, loading, error }] = useUpdateReportVulnerabilityFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportVulnerabilityFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportVulnerabilityFileMutation, UpdateReportVulnerabilityFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportVulnerabilityFileMutation, UpdateReportVulnerabilityFileMutationVariables>(UpdateReportVulnerabilityFileDocument, options);
      }
export type UpdateReportVulnerabilityFileMutationHookResult = ReturnType<typeof useUpdateReportVulnerabilityFileMutation>;
export type UpdateReportVulnerabilityFileMutationResult = Apollo.MutationResult<UpdateReportVulnerabilityFileMutation>;
export type UpdateReportVulnerabilityFileMutationOptions = Apollo.BaseMutationOptions<UpdateReportVulnerabilityFileMutation, UpdateReportVulnerabilityFileMutationVariables>;
export const DeleteReportVulnerabilityFileDocument = gql`
    mutation DeleteReportVulnerabilityFile($input: deleteReportVulnerabilityFileInput!) {
  deleteReportVulnerabilityFile(input: $input) {
    __typename
  }
}
    `;
export type DeleteReportVulnerabilityFileMutationFn = Apollo.MutationFunction<DeleteReportVulnerabilityFileMutation, DeleteReportVulnerabilityFileMutationVariables>;

/**
 * __useDeleteReportVulnerabilityFileMutation__
 *
 * To run a mutation, you first call `useDeleteReportVulnerabilityFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportVulnerabilityFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportVulnerabilityFileMutation, { data, loading, error }] = useDeleteReportVulnerabilityFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportVulnerabilityFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportVulnerabilityFileMutation, DeleteReportVulnerabilityFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportVulnerabilityFileMutation, DeleteReportVulnerabilityFileMutationVariables>(DeleteReportVulnerabilityFileDocument, options);
      }
export type DeleteReportVulnerabilityFileMutationHookResult = ReturnType<typeof useDeleteReportVulnerabilityFileMutation>;
export type DeleteReportVulnerabilityFileMutationResult = Apollo.MutationResult<DeleteReportVulnerabilityFileMutation>;
export type DeleteReportVulnerabilityFileMutationOptions = Apollo.BaseMutationOptions<DeleteReportVulnerabilityFileMutation, DeleteReportVulnerabilityFileMutationVariables>;
export const CreateReportVulnerabilityRetestRequestDocument = gql`
    mutation CreateReportVulnerabilityRetestRequest($input: createReportVulnerabilityRetestRequestInput!) {
  createReportVulnerabilityRetestRequest(input: $input) {
    reportVulnerabilityRetestRequest {
      ...reportVulnerabilityRetestRequestListFields
    }
  }
}
    ${ReportVulnerabilityRetestRequestListFieldsFragmentDoc}`;
export type CreateReportVulnerabilityRetestRequestMutationFn = Apollo.MutationFunction<CreateReportVulnerabilityRetestRequestMutation, CreateReportVulnerabilityRetestRequestMutationVariables>;

/**
 * __useCreateReportVulnerabilityRetestRequestMutation__
 *
 * To run a mutation, you first call `useCreateReportVulnerabilityRetestRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportVulnerabilityRetestRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportVulnerabilityRetestRequestMutation, { data, loading, error }] = useCreateReportVulnerabilityRetestRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportVulnerabilityRetestRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportVulnerabilityRetestRequestMutation, CreateReportVulnerabilityRetestRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportVulnerabilityRetestRequestMutation, CreateReportVulnerabilityRetestRequestMutationVariables>(CreateReportVulnerabilityRetestRequestDocument, options);
      }
export type CreateReportVulnerabilityRetestRequestMutationHookResult = ReturnType<typeof useCreateReportVulnerabilityRetestRequestMutation>;
export type CreateReportVulnerabilityRetestRequestMutationResult = Apollo.MutationResult<CreateReportVulnerabilityRetestRequestMutation>;
export type CreateReportVulnerabilityRetestRequestMutationOptions = Apollo.BaseMutationOptions<CreateReportVulnerabilityRetestRequestMutation, CreateReportVulnerabilityRetestRequestMutationVariables>;
export const CreateReportVulnerabilityDocument = gql`
    mutation CreateReportVulnerability($input: createReportVulnerabilityInput!) {
  createReportVulnerability(input: $input) {
    reportVulnerability {
      ...reportVulnerabilityFields
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;
export type CreateReportVulnerabilityMutationFn = Apollo.MutationFunction<CreateReportVulnerabilityMutation, CreateReportVulnerabilityMutationVariables>;

/**
 * __useCreateReportVulnerabilityMutation__
 *
 * To run a mutation, you first call `useCreateReportVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportVulnerabilityMutation, { data, loading, error }] = useCreateReportVulnerabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportVulnerabilityMutation, CreateReportVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportVulnerabilityMutation, CreateReportVulnerabilityMutationVariables>(CreateReportVulnerabilityDocument, options);
      }
export type CreateReportVulnerabilityMutationHookResult = ReturnType<typeof useCreateReportVulnerabilityMutation>;
export type CreateReportVulnerabilityMutationResult = Apollo.MutationResult<CreateReportVulnerabilityMutation>;
export type CreateReportVulnerabilityMutationOptions = Apollo.BaseMutationOptions<CreateReportVulnerabilityMutation, CreateReportVulnerabilityMutationVariables>;
export const UpdateReportVulnerabilityDocument = gql`
    mutation UpdateReportVulnerability($input: updateReportVulnerabilityInput!) {
  updateReportVulnerability(input: $input) {
    reportVulnerability {
      ...reportVulnerabilityFields
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;
export type UpdateReportVulnerabilityMutationFn = Apollo.MutationFunction<UpdateReportVulnerabilityMutation, UpdateReportVulnerabilityMutationVariables>;

/**
 * __useUpdateReportVulnerabilityMutation__
 *
 * To run a mutation, you first call `useUpdateReportVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportVulnerabilityMutation, { data, loading, error }] = useUpdateReportVulnerabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportVulnerabilityMutation, UpdateReportVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportVulnerabilityMutation, UpdateReportVulnerabilityMutationVariables>(UpdateReportVulnerabilityDocument, options);
      }
export type UpdateReportVulnerabilityMutationHookResult = ReturnType<typeof useUpdateReportVulnerabilityMutation>;
export type UpdateReportVulnerabilityMutationResult = Apollo.MutationResult<UpdateReportVulnerabilityMutation>;
export type UpdateReportVulnerabilityMutationOptions = Apollo.BaseMutationOptions<UpdateReportVulnerabilityMutation, UpdateReportVulnerabilityMutationVariables>;
export const ResolveReportVulnerabilityDocument = gql`
    mutation ResolveReportVulnerability($vulnerabilityId: ID!, $dateResolved: String!) {
  transitionReportVulnerability(
    input: {id: $vulnerabilityId, dateResolved: $dateResolved, transition: resolve}
  ) {
    reportVulnerability {
      ...reportVulnerabilityFields
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;
export type ResolveReportVulnerabilityMutationFn = Apollo.MutationFunction<ResolveReportVulnerabilityMutation, ResolveReportVulnerabilityMutationVariables>;

/**
 * __useResolveReportVulnerabilityMutation__
 *
 * To run a mutation, you first call `useResolveReportVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveReportVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveReportVulnerabilityMutation, { data, loading, error }] = useResolveReportVulnerabilityMutation({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      dateResolved: // value for 'dateResolved'
 *   },
 * });
 */
export function useResolveReportVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<ResolveReportVulnerabilityMutation, ResolveReportVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveReportVulnerabilityMutation, ResolveReportVulnerabilityMutationVariables>(ResolveReportVulnerabilityDocument, options);
      }
export type ResolveReportVulnerabilityMutationHookResult = ReturnType<typeof useResolveReportVulnerabilityMutation>;
export type ResolveReportVulnerabilityMutationResult = Apollo.MutationResult<ResolveReportVulnerabilityMutation>;
export type ResolveReportVulnerabilityMutationOptions = Apollo.BaseMutationOptions<ResolveReportVulnerabilityMutation, ResolveReportVulnerabilityMutationVariables>;
export const AcceptReportVulnerabilityRiskDocument = gql`
    mutation AcceptReportVulnerabilityRisk($vulnerabilityId: ID!) {
  transitionReportVulnerability(
    input: {id: $vulnerabilityId, transition: accept_risk}
  ) {
    reportVulnerability {
      ...reportVulnerabilityFields
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;
export type AcceptReportVulnerabilityRiskMutationFn = Apollo.MutationFunction<AcceptReportVulnerabilityRiskMutation, AcceptReportVulnerabilityRiskMutationVariables>;

/**
 * __useAcceptReportVulnerabilityRiskMutation__
 *
 * To run a mutation, you first call `useAcceptReportVulnerabilityRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReportVulnerabilityRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReportVulnerabilityRiskMutation, { data, loading, error }] = useAcceptReportVulnerabilityRiskMutation({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *   },
 * });
 */
export function useAcceptReportVulnerabilityRiskMutation(baseOptions?: Apollo.MutationHookOptions<AcceptReportVulnerabilityRiskMutation, AcceptReportVulnerabilityRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptReportVulnerabilityRiskMutation, AcceptReportVulnerabilityRiskMutationVariables>(AcceptReportVulnerabilityRiskDocument, options);
      }
export type AcceptReportVulnerabilityRiskMutationHookResult = ReturnType<typeof useAcceptReportVulnerabilityRiskMutation>;
export type AcceptReportVulnerabilityRiskMutationResult = Apollo.MutationResult<AcceptReportVulnerabilityRiskMutation>;
export type AcceptReportVulnerabilityRiskMutationOptions = Apollo.BaseMutationOptions<AcceptReportVulnerabilityRiskMutation, AcceptReportVulnerabilityRiskMutationVariables>;
export const ReopenReportVulnerabilityDocument = gql`
    mutation ReopenReportVulnerability($vulnerabilityId: ID!, $reopenedReason: String!) {
  transitionReportVulnerability(
    input: {id: $vulnerabilityId, reopenedReason: $reopenedReason, transition: reopen}
  ) {
    reportVulnerability {
      ...reportVulnerabilityFields
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;
export type ReopenReportVulnerabilityMutationFn = Apollo.MutationFunction<ReopenReportVulnerabilityMutation, ReopenReportVulnerabilityMutationVariables>;

/**
 * __useReopenReportVulnerabilityMutation__
 *
 * To run a mutation, you first call `useReopenReportVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenReportVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenReportVulnerabilityMutation, { data, loading, error }] = useReopenReportVulnerabilityMutation({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      reopenedReason: // value for 'reopenedReason'
 *   },
 * });
 */
export function useReopenReportVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<ReopenReportVulnerabilityMutation, ReopenReportVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenReportVulnerabilityMutation, ReopenReportVulnerabilityMutationVariables>(ReopenReportVulnerabilityDocument, options);
      }
export type ReopenReportVulnerabilityMutationHookResult = ReturnType<typeof useReopenReportVulnerabilityMutation>;
export type ReopenReportVulnerabilityMutationResult = Apollo.MutationResult<ReopenReportVulnerabilityMutation>;
export type ReopenReportVulnerabilityMutationOptions = Apollo.BaseMutationOptions<ReopenReportVulnerabilityMutation, ReopenReportVulnerabilityMutationVariables>;
export const VerifyResolvedVulnerabilityRiskDocument = gql`
    mutation VerifyResolvedVulnerabilityRisk($vulnerabilityId: ID!) {
  transitionReportVulnerability(
    input: {id: $vulnerabilityId, transition: verify_resolved}
  ) {
    reportVulnerability {
      ...reportVulnerabilityFields
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;
export type VerifyResolvedVulnerabilityRiskMutationFn = Apollo.MutationFunction<VerifyResolvedVulnerabilityRiskMutation, VerifyResolvedVulnerabilityRiskMutationVariables>;

/**
 * __useVerifyResolvedVulnerabilityRiskMutation__
 *
 * To run a mutation, you first call `useVerifyResolvedVulnerabilityRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyResolvedVulnerabilityRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyResolvedVulnerabilityRiskMutation, { data, loading, error }] = useVerifyResolvedVulnerabilityRiskMutation({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *   },
 * });
 */
export function useVerifyResolvedVulnerabilityRiskMutation(baseOptions?: Apollo.MutationHookOptions<VerifyResolvedVulnerabilityRiskMutation, VerifyResolvedVulnerabilityRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyResolvedVulnerabilityRiskMutation, VerifyResolvedVulnerabilityRiskMutationVariables>(VerifyResolvedVulnerabilityRiskDocument, options);
      }
export type VerifyResolvedVulnerabilityRiskMutationHookResult = ReturnType<typeof useVerifyResolvedVulnerabilityRiskMutation>;
export type VerifyResolvedVulnerabilityRiskMutationResult = Apollo.MutationResult<VerifyResolvedVulnerabilityRiskMutation>;
export type VerifyResolvedVulnerabilityRiskMutationOptions = Apollo.BaseMutationOptions<VerifyResolvedVulnerabilityRiskMutation, VerifyResolvedVulnerabilityRiskMutationVariables>;
export const DeleteReportVulnerabilityDocument = gql`
    mutation DeleteReportVulnerability($vulnerabilityId: ID!) {
  deleteReportVulnerability(input: {id: $vulnerabilityId}) {
    __typename
  }
}
    `;
export type DeleteReportVulnerabilityMutationFn = Apollo.MutationFunction<DeleteReportVulnerabilityMutation, DeleteReportVulnerabilityMutationVariables>;

/**
 * __useDeleteReportVulnerabilityMutation__
 *
 * To run a mutation, you first call `useDeleteReportVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportVulnerabilityMutation, { data, loading, error }] = useDeleteReportVulnerabilityMutation({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *   },
 * });
 */
export function useDeleteReportVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportVulnerabilityMutation, DeleteReportVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportVulnerabilityMutation, DeleteReportVulnerabilityMutationVariables>(DeleteReportVulnerabilityDocument, options);
      }
export type DeleteReportVulnerabilityMutationHookResult = ReturnType<typeof useDeleteReportVulnerabilityMutation>;
export type DeleteReportVulnerabilityMutationResult = Apollo.MutationResult<DeleteReportVulnerabilityMutation>;
export type DeleteReportVulnerabilityMutationOptions = Apollo.BaseMutationOptions<DeleteReportVulnerabilityMutation, DeleteReportVulnerabilityMutationVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($input: createReportInput!) {
  createReport(input: $input) {
    report {
      ...reportListFields
      latestVersion {
        _id
        id
      }
      versions {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            _id
            id
          }
        }
      }
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($input: updateReportInput!) {
  updateReport(input: $input) {
    report {
      ...reportListFields
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const DeleteReportDocument = gql`
    mutation DeleteReport($input: deleteReportInput!) {
  deleteReport(input: $input) {
    __typename
  }
}
    `;
export type DeleteReportMutationFn = Apollo.MutationFunction<DeleteReportMutation, DeleteReportMutationVariables>;

/**
 * __useDeleteReportMutation__
 *
 * To run a mutation, you first call `useDeleteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportMutation, { data, loading, error }] = useDeleteReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportMutation, DeleteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportMutation, DeleteReportMutationVariables>(DeleteReportDocument, options);
      }
export type DeleteReportMutationHookResult = ReturnType<typeof useDeleteReportMutation>;
export type DeleteReportMutationResult = Apollo.MutationResult<DeleteReportMutation>;
export type DeleteReportMutationOptions = Apollo.BaseMutationOptions<DeleteReportMutation, DeleteReportMutationVariables>;
export const NewVersionOfReportDocument = gql`
    mutation NewVersionOfReport($input: newVersionOfReportInput!) {
  newVersionOfReport(input: $input) {
    report {
      ...reportListFields
      latestVersion {
        _id
        id
      }
      versions {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            _id
            id
          }
        }
      }
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;
export type NewVersionOfReportMutationFn = Apollo.MutationFunction<NewVersionOfReportMutation, NewVersionOfReportMutationVariables>;

/**
 * __useNewVersionOfReportMutation__
 *
 * To run a mutation, you first call `useNewVersionOfReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNewVersionOfReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [newVersionOfReportMutation, { data, loading, error }] = useNewVersionOfReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNewVersionOfReportMutation(baseOptions?: Apollo.MutationHookOptions<NewVersionOfReportMutation, NewVersionOfReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NewVersionOfReportMutation, NewVersionOfReportMutationVariables>(NewVersionOfReportDocument, options);
      }
export type NewVersionOfReportMutationHookResult = ReturnType<typeof useNewVersionOfReportMutation>;
export type NewVersionOfReportMutationResult = Apollo.MutationResult<NewVersionOfReportMutation>;
export type NewVersionOfReportMutationOptions = Apollo.BaseMutationOptions<NewVersionOfReportMutation, NewVersionOfReportMutationVariables>;
export const AddUserToReportDocument = gql`
    mutation AddUserToReport($reportId: ID!, $userId: ID!, $role: ReportRole!) {
  addUserToReport(input: {id: $reportId, user: $userId, role: $role}) {
    report {
      ...reportListFields
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;
export type AddUserToReportMutationFn = Apollo.MutationFunction<AddUserToReportMutation, AddUserToReportMutationVariables>;

/**
 * __useAddUserToReportMutation__
 *
 * To run a mutation, you first call `useAddUserToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToReportMutation, { data, loading, error }] = useAddUserToReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddUserToReportMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToReportMutation, AddUserToReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToReportMutation, AddUserToReportMutationVariables>(AddUserToReportDocument, options);
      }
export type AddUserToReportMutationHookResult = ReturnType<typeof useAddUserToReportMutation>;
export type AddUserToReportMutationResult = Apollo.MutationResult<AddUserToReportMutation>;
export type AddUserToReportMutationOptions = Apollo.BaseMutationOptions<AddUserToReportMutation, AddUserToReportMutationVariables>;
export const AddCompanyUserToReportDocument = gql`
    mutation AddCompanyUserToReport($reportId: ID!, $companyUserId: ID!, $role: ReportRole!) {
  addCompanyUserToReport(
    input: {id: $reportId, companyUser: $companyUserId, role: $role}
  ) {
    report {
      ...reportListFields
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;
export type AddCompanyUserToReportMutationFn = Apollo.MutationFunction<AddCompanyUserToReportMutation, AddCompanyUserToReportMutationVariables>;

/**
 * __useAddCompanyUserToReportMutation__
 *
 * To run a mutation, you first call `useAddCompanyUserToReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyUserToReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyUserToReportMutation, { data, loading, error }] = useAddCompanyUserToReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      companyUserId: // value for 'companyUserId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddCompanyUserToReportMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyUserToReportMutation, AddCompanyUserToReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyUserToReportMutation, AddCompanyUserToReportMutationVariables>(AddCompanyUserToReportDocument, options);
      }
export type AddCompanyUserToReportMutationHookResult = ReturnType<typeof useAddCompanyUserToReportMutation>;
export type AddCompanyUserToReportMutationResult = Apollo.MutationResult<AddCompanyUserToReportMutation>;
export type AddCompanyUserToReportMutationOptions = Apollo.BaseMutationOptions<AddCompanyUserToReportMutation, AddCompanyUserToReportMutationVariables>;
export const RemoveUserFromReportDocument = gql`
    mutation RemoveUserFromReport($reportId: ID!, $userId: ID!) {
  removeUserFromReport(input: {id: $reportId, user: $userId}) {
    report {
      ...reportListFields
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;
export type RemoveUserFromReportMutationFn = Apollo.MutationFunction<RemoveUserFromReportMutation, RemoveUserFromReportMutationVariables>;

/**
 * __useRemoveUserFromReportMutation__
 *
 * To run a mutation, you first call `useRemoveUserFromReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserFromReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserFromReportMutation, { data, loading, error }] = useRemoveUserFromReportMutation({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUserFromReportMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserFromReportMutation, RemoveUserFromReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserFromReportMutation, RemoveUserFromReportMutationVariables>(RemoveUserFromReportDocument, options);
      }
export type RemoveUserFromReportMutationHookResult = ReturnType<typeof useRemoveUserFromReportMutation>;
export type RemoveUserFromReportMutationResult = Apollo.MutationResult<RemoveUserFromReportMutation>;
export type RemoveUserFromReportMutationOptions = Apollo.BaseMutationOptions<RemoveUserFromReportMutation, RemoveUserFromReportMutationVariables>;
export const CreateTestTypePrerequisiteDocument = gql`
    mutation CreateTestTypePrerequisite($input: createTestTypePrerequisiteInput!) {
  createTestTypePrerequisite(input: $input) {
    testTypePrerequisite {
      ...testTypePrerequisiteFields
    }
  }
}
    ${TestTypePrerequisiteFieldsFragmentDoc}`;
export type CreateTestTypePrerequisiteMutationFn = Apollo.MutationFunction<CreateTestTypePrerequisiteMutation, CreateTestTypePrerequisiteMutationVariables>;

/**
 * __useCreateTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useCreateTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestTypePrerequisiteMutation, { data, loading, error }] = useCreateTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestTypePrerequisiteMutation, CreateTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestTypePrerequisiteMutation, CreateTestTypePrerequisiteMutationVariables>(CreateTestTypePrerequisiteDocument, options);
      }
export type CreateTestTypePrerequisiteMutationHookResult = ReturnType<typeof useCreateTestTypePrerequisiteMutation>;
export type CreateTestTypePrerequisiteMutationResult = Apollo.MutationResult<CreateTestTypePrerequisiteMutation>;
export type CreateTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<CreateTestTypePrerequisiteMutation, CreateTestTypePrerequisiteMutationVariables>;
export const UpdateTestTypePrerequisiteDocument = gql`
    mutation UpdateTestTypePrerequisite($input: updateTestTypePrerequisiteInput!) {
  updateTestTypePrerequisite(input: $input) {
    testTypePrerequisite {
      ...testTypePrerequisiteFields
    }
  }
}
    ${TestTypePrerequisiteFieldsFragmentDoc}`;
export type UpdateTestTypePrerequisiteMutationFn = Apollo.MutationFunction<UpdateTestTypePrerequisiteMutation, UpdateTestTypePrerequisiteMutationVariables>;

/**
 * __useUpdateTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useUpdateTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestTypePrerequisiteMutation, { data, loading, error }] = useUpdateTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestTypePrerequisiteMutation, UpdateTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestTypePrerequisiteMutation, UpdateTestTypePrerequisiteMutationVariables>(UpdateTestTypePrerequisiteDocument, options);
      }
export type UpdateTestTypePrerequisiteMutationHookResult = ReturnType<typeof useUpdateTestTypePrerequisiteMutation>;
export type UpdateTestTypePrerequisiteMutationResult = Apollo.MutationResult<UpdateTestTypePrerequisiteMutation>;
export type UpdateTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<UpdateTestTypePrerequisiteMutation, UpdateTestTypePrerequisiteMutationVariables>;
export const DeleteAllVersionsOfTestTypePrerequisiteDocument = gql`
    mutation DeleteAllVersionsOfTestTypePrerequisite($input: deleteAllVersionsOfTestTypePrerequisiteInput!) {
  deleteAllVersionsOfTestTypePrerequisite(input: $input) {
    __typename
  }
}
    `;
export type DeleteAllVersionsOfTestTypePrerequisiteMutationFn = Apollo.MutationFunction<DeleteAllVersionsOfTestTypePrerequisiteMutation, DeleteAllVersionsOfTestTypePrerequisiteMutationVariables>;

/**
 * __useDeleteAllVersionsOfTestTypePrerequisiteMutation__
 *
 * To run a mutation, you first call `useDeleteAllVersionsOfTestTypePrerequisiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllVersionsOfTestTypePrerequisiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllVersionsOfTestTypePrerequisiteMutation, { data, loading, error }] = useDeleteAllVersionsOfTestTypePrerequisiteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllVersionsOfTestTypePrerequisiteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllVersionsOfTestTypePrerequisiteMutation, DeleteAllVersionsOfTestTypePrerequisiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllVersionsOfTestTypePrerequisiteMutation, DeleteAllVersionsOfTestTypePrerequisiteMutationVariables>(DeleteAllVersionsOfTestTypePrerequisiteDocument, options);
      }
export type DeleteAllVersionsOfTestTypePrerequisiteMutationHookResult = ReturnType<typeof useDeleteAllVersionsOfTestTypePrerequisiteMutation>;
export type DeleteAllVersionsOfTestTypePrerequisiteMutationResult = Apollo.MutationResult<DeleteAllVersionsOfTestTypePrerequisiteMutation>;
export type DeleteAllVersionsOfTestTypePrerequisiteMutationOptions = Apollo.BaseMutationOptions<DeleteAllVersionsOfTestTypePrerequisiteMutation, DeleteAllVersionsOfTestTypePrerequisiteMutationVariables>;
export const CreateTestingTypeDocument = gql`
    mutation CreateTestingType($input: createTestingTypeInput!) {
  createTestingType(input: $input) {
    testingType {
      ...testingTypeFields
    }
  }
}
    ${TestingTypeFieldsFragmentDoc}`;
export type CreateTestingTypeMutationFn = Apollo.MutationFunction<CreateTestingTypeMutation, CreateTestingTypeMutationVariables>;

/**
 * __useCreateTestingTypeMutation__
 *
 * To run a mutation, you first call `useCreateTestingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestingTypeMutation, { data, loading, error }] = useCreateTestingTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestingTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestingTypeMutation, CreateTestingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestingTypeMutation, CreateTestingTypeMutationVariables>(CreateTestingTypeDocument, options);
      }
export type CreateTestingTypeMutationHookResult = ReturnType<typeof useCreateTestingTypeMutation>;
export type CreateTestingTypeMutationResult = Apollo.MutationResult<CreateTestingTypeMutation>;
export type CreateTestingTypeMutationOptions = Apollo.BaseMutationOptions<CreateTestingTypeMutation, CreateTestingTypeMutationVariables>;
export const UpdateTestingTypeDocument = gql`
    mutation UpdateTestingType($input: updateTestingTypeInput!) {
  updateTestingType(input: $input) {
    testingType {
      ...testingTypeFields
    }
  }
}
    ${TestingTypeFieldsFragmentDoc}`;
export type UpdateTestingTypeMutationFn = Apollo.MutationFunction<UpdateTestingTypeMutation, UpdateTestingTypeMutationVariables>;

/**
 * __useUpdateTestingTypeMutation__
 *
 * To run a mutation, you first call `useUpdateTestingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestingTypeMutation, { data, loading, error }] = useUpdateTestingTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTestingTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestingTypeMutation, UpdateTestingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestingTypeMutation, UpdateTestingTypeMutationVariables>(UpdateTestingTypeDocument, options);
      }
export type UpdateTestingTypeMutationHookResult = ReturnType<typeof useUpdateTestingTypeMutation>;
export type UpdateTestingTypeMutationResult = Apollo.MutationResult<UpdateTestingTypeMutation>;
export type UpdateTestingTypeMutationOptions = Apollo.BaseMutationOptions<UpdateTestingTypeMutation, UpdateTestingTypeMutationVariables>;
export const DeleteTestingTypeDocument = gql`
    mutation DeleteTestingType($input: deleteTestingTypeInput!) {
  deleteTestingType(input: $input) {
    __typename
  }
}
    `;
export type DeleteTestingTypeMutationFn = Apollo.MutationFunction<DeleteTestingTypeMutation, DeleteTestingTypeMutationVariables>;

/**
 * __useDeleteTestingTypeMutation__
 *
 * To run a mutation, you first call `useDeleteTestingTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTestingTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTestingTypeMutation, { data, loading, error }] = useDeleteTestingTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTestingTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTestingTypeMutation, DeleteTestingTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTestingTypeMutation, DeleteTestingTypeMutationVariables>(DeleteTestingTypeDocument, options);
      }
export type DeleteTestingTypeMutationHookResult = ReturnType<typeof useDeleteTestingTypeMutation>;
export type DeleteTestingTypeMutationResult = Apollo.MutationResult<DeleteTestingTypeMutation>;
export type DeleteTestingTypeMutationOptions = Apollo.BaseMutationOptions<DeleteTestingTypeMutation, DeleteTestingTypeMutationVariables>;
export const CreateUserMobileNumberChangeRequestDocument = gql`
    mutation CreateUserMobileNumberChangeRequest($input: createUserMobileNumberChangeRequestInput!) {
  createUserMobileNumberChangeRequest(input: $input) {
    userMobileNumberChangeRequest {
      _id
      id
    }
  }
}
    `;
export type CreateUserMobileNumberChangeRequestMutationFn = Apollo.MutationFunction<CreateUserMobileNumberChangeRequestMutation, CreateUserMobileNumberChangeRequestMutationVariables>;

/**
 * __useCreateUserMobileNumberChangeRequestMutation__
 *
 * To run a mutation, you first call `useCreateUserMobileNumberChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMobileNumberChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMobileNumberChangeRequestMutation, { data, loading, error }] = useCreateUserMobileNumberChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMobileNumberChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMobileNumberChangeRequestMutation, CreateUserMobileNumberChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMobileNumberChangeRequestMutation, CreateUserMobileNumberChangeRequestMutationVariables>(CreateUserMobileNumberChangeRequestDocument, options);
      }
export type CreateUserMobileNumberChangeRequestMutationHookResult = ReturnType<typeof useCreateUserMobileNumberChangeRequestMutation>;
export type CreateUserMobileNumberChangeRequestMutationResult = Apollo.MutationResult<CreateUserMobileNumberChangeRequestMutation>;
export type CreateUserMobileNumberChangeRequestMutationOptions = Apollo.BaseMutationOptions<CreateUserMobileNumberChangeRequestMutation, CreateUserMobileNumberChangeRequestMutationVariables>;
export const ApplyUserMobileNumberChangeRequestDocument = gql`
    mutation ApplyUserMobileNumberChangeRequest($input: applyUserMobileNumberChangeRequestInput!) {
  applyUserMobileNumberChangeRequest(input: $input) {
    userMobileNumberChangeRequest {
      _id
      id
    }
  }
}
    `;
export type ApplyUserMobileNumberChangeRequestMutationFn = Apollo.MutationFunction<ApplyUserMobileNumberChangeRequestMutation, ApplyUserMobileNumberChangeRequestMutationVariables>;

/**
 * __useApplyUserMobileNumberChangeRequestMutation__
 *
 * To run a mutation, you first call `useApplyUserMobileNumberChangeRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyUserMobileNumberChangeRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyUserMobileNumberChangeRequestMutation, { data, loading, error }] = useApplyUserMobileNumberChangeRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyUserMobileNumberChangeRequestMutation(baseOptions?: Apollo.MutationHookOptions<ApplyUserMobileNumberChangeRequestMutation, ApplyUserMobileNumberChangeRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyUserMobileNumberChangeRequestMutation, ApplyUserMobileNumberChangeRequestMutationVariables>(ApplyUserMobileNumberChangeRequestDocument, options);
      }
export type ApplyUserMobileNumberChangeRequestMutationHookResult = ReturnType<typeof useApplyUserMobileNumberChangeRequestMutation>;
export type ApplyUserMobileNumberChangeRequestMutationResult = Apollo.MutationResult<ApplyUserMobileNumberChangeRequestMutation>;
export type ApplyUserMobileNumberChangeRequestMutationOptions = Apollo.BaseMutationOptions<ApplyUserMobileNumberChangeRequestMutation, ApplyUserMobileNumberChangeRequestMutationVariables>;
export const MarkReadUserNotificationDocument = gql`
    mutation MarkReadUserNotification($input: markReadUserNotificationInput!) {
  markReadUserNotification(input: $input) {
    userNotification {
      ...userNotificationFields
    }
  }
}
    ${UserNotificationFieldsFragmentDoc}`;
export type MarkReadUserNotificationMutationFn = Apollo.MutationFunction<MarkReadUserNotificationMutation, MarkReadUserNotificationMutationVariables>;

/**
 * __useMarkReadUserNotificationMutation__
 *
 * To run a mutation, you first call `useMarkReadUserNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkReadUserNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markReadUserNotificationMutation, { data, loading, error }] = useMarkReadUserNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkReadUserNotificationMutation(baseOptions?: Apollo.MutationHookOptions<MarkReadUserNotificationMutation, MarkReadUserNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkReadUserNotificationMutation, MarkReadUserNotificationMutationVariables>(MarkReadUserNotificationDocument, options);
      }
export type MarkReadUserNotificationMutationHookResult = ReturnType<typeof useMarkReadUserNotificationMutation>;
export type MarkReadUserNotificationMutationResult = Apollo.MutationResult<MarkReadUserNotificationMutation>;
export type MarkReadUserNotificationMutationOptions = Apollo.BaseMutationOptions<MarkReadUserNotificationMutation, MarkReadUserNotificationMutationVariables>;
export const CreateUserPasswordResetRequsetDocument = gql`
    mutation CreateUserPasswordResetRequset($input: createUserPasswordResetRequestInput!) {
  createUserPasswordResetRequest(input: $input) {
    userPasswordResetRequest {
      id
    }
  }
}
    `;
export type CreateUserPasswordResetRequsetMutationFn = Apollo.MutationFunction<CreateUserPasswordResetRequsetMutation, CreateUserPasswordResetRequsetMutationVariables>;

/**
 * __useCreateUserPasswordResetRequsetMutation__
 *
 * To run a mutation, you first call `useCreateUserPasswordResetRequsetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserPasswordResetRequsetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserPasswordResetRequsetMutation, { data, loading, error }] = useCreateUserPasswordResetRequsetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserPasswordResetRequsetMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserPasswordResetRequsetMutation, CreateUserPasswordResetRequsetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserPasswordResetRequsetMutation, CreateUserPasswordResetRequsetMutationVariables>(CreateUserPasswordResetRequsetDocument, options);
      }
export type CreateUserPasswordResetRequsetMutationHookResult = ReturnType<typeof useCreateUserPasswordResetRequsetMutation>;
export type CreateUserPasswordResetRequsetMutationResult = Apollo.MutationResult<CreateUserPasswordResetRequsetMutation>;
export type CreateUserPasswordResetRequsetMutationOptions = Apollo.BaseMutationOptions<CreateUserPasswordResetRequsetMutation, CreateUserPasswordResetRequsetMutationVariables>;
export const RegisterUserDocument = gql`
    mutation RegisterUser($input: createUserInput!) {
  createUser(input: $input) {
    __typename
  }
}
    `;
export type RegisterUserMutationFn = Apollo.MutationFunction<RegisterUserMutation, RegisterUserMutationVariables>;

/**
 * __useRegisterUserMutation__
 *
 * To run a mutation, you first call `useRegisterUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerUserMutation, { data, loading, error }] = useRegisterUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterUserMutation(baseOptions?: Apollo.MutationHookOptions<RegisterUserMutation, RegisterUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterUserMutation, RegisterUserMutationVariables>(RegisterUserDocument, options);
      }
export type RegisterUserMutationHookResult = ReturnType<typeof useRegisterUserMutation>;
export type RegisterUserMutationResult = Apollo.MutationResult<RegisterUserMutation>;
export type RegisterUserMutationOptions = Apollo.BaseMutationOptions<RegisterUserMutation, RegisterUserMutationVariables>;
export const ResetUserPasswordDocument = gql`
    mutation ResetUserPassword($input: resetPasswordUserInput!) {
  resetPasswordUser(input: $input) {
    user {
      ...userListFields
    }
  }
}
    ${UserListFieldsFragmentDoc}`;
export type ResetUserPasswordMutationFn = Apollo.MutationFunction<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;

/**
 * __useResetUserPasswordMutation__
 *
 * To run a mutation, you first call `useResetUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetUserPasswordMutation, { data, loading, error }] = useResetUserPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>(ResetUserPasswordDocument, options);
      }
export type ResetUserPasswordMutationHookResult = ReturnType<typeof useResetUserPasswordMutation>;
export type ResetUserPasswordMutationResult = Apollo.MutationResult<ResetUserPasswordMutation>;
export type ResetUserPasswordMutationOptions = Apollo.BaseMutationOptions<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const VerifyUserEmailDocument = gql`
    mutation VerifyUserEmail($input: verifyEmailUserInput!) {
  verifyEmailUser(input: $input) {
    user {
      ...userListFields
    }
  }
}
    ${UserListFieldsFragmentDoc}`;
export type VerifyUserEmailMutationFn = Apollo.MutationFunction<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;

/**
 * __useVerifyUserEmailMutation__
 *
 * To run a mutation, you first call `useVerifyUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyUserEmailMutation, { data, loading, error }] = useVerifyUserEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>(VerifyUserEmailDocument, options);
      }
export type VerifyUserEmailMutationHookResult = ReturnType<typeof useVerifyUserEmailMutation>;
export type VerifyUserEmailMutationResult = Apollo.MutationResult<VerifyUserEmailMutation>;
export type VerifyUserEmailMutationOptions = Apollo.BaseMutationOptions<VerifyUserEmailMutation, VerifyUserEmailMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: updateUserInput!) {
  updateUser(input: $input) {
    user {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($input: deleteUserInput!) {
  deleteUser(input: $input) {
    __typename
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const CreateVulnerabilityDocument = gql`
    mutation CreateVulnerability($input: createVulnerabilityInput!) {
  createVulnerability(input: $input) {
    vulnerability {
      ...vulnerabilityFields
    }
  }
}
    ${VulnerabilityFieldsFragmentDoc}`;
export type CreateVulnerabilityMutationFn = Apollo.MutationFunction<CreateVulnerabilityMutation, CreateVulnerabilityMutationVariables>;

/**
 * __useCreateVulnerabilityMutation__
 *
 * To run a mutation, you first call `useCreateVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVulnerabilityMutation, { data, loading, error }] = useCreateVulnerabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateVulnerabilityMutation, CreateVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVulnerabilityMutation, CreateVulnerabilityMutationVariables>(CreateVulnerabilityDocument, options);
      }
export type CreateVulnerabilityMutationHookResult = ReturnType<typeof useCreateVulnerabilityMutation>;
export type CreateVulnerabilityMutationResult = Apollo.MutationResult<CreateVulnerabilityMutation>;
export type CreateVulnerabilityMutationOptions = Apollo.BaseMutationOptions<CreateVulnerabilityMutation, CreateVulnerabilityMutationVariables>;
export const UpdateVulnerabilityDocument = gql`
    mutation UpdateVulnerability($input: updateVulnerabilityInput!) {
  updateVulnerability(input: $input) {
    vulnerability {
      ...vulnerabilityFields
    }
  }
}
    ${VulnerabilityFieldsFragmentDoc}`;
export type UpdateVulnerabilityMutationFn = Apollo.MutationFunction<UpdateVulnerabilityMutation, UpdateVulnerabilityMutationVariables>;

/**
 * __useUpdateVulnerabilityMutation__
 *
 * To run a mutation, you first call `useUpdateVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVulnerabilityMutation, { data, loading, error }] = useUpdateVulnerabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVulnerabilityMutation, UpdateVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVulnerabilityMutation, UpdateVulnerabilityMutationVariables>(UpdateVulnerabilityDocument, options);
      }
export type UpdateVulnerabilityMutationHookResult = ReturnType<typeof useUpdateVulnerabilityMutation>;
export type UpdateVulnerabilityMutationResult = Apollo.MutationResult<UpdateVulnerabilityMutation>;
export type UpdateVulnerabilityMutationOptions = Apollo.BaseMutationOptions<UpdateVulnerabilityMutation, UpdateVulnerabilityMutationVariables>;
export const DeleteAllVersionsOfVulnerabilityDocument = gql`
    mutation DeleteAllVersionsOfVulnerability($input: deleteAllVersionsOfVulnerabilityInput!) {
  deleteAllVersionsOfVulnerability(input: $input) {
    __typename
  }
}
    `;
export type DeleteAllVersionsOfVulnerabilityMutationFn = Apollo.MutationFunction<DeleteAllVersionsOfVulnerabilityMutation, DeleteAllVersionsOfVulnerabilityMutationVariables>;

/**
 * __useDeleteAllVersionsOfVulnerabilityMutation__
 *
 * To run a mutation, you first call `useDeleteAllVersionsOfVulnerabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAllVersionsOfVulnerabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAllVersionsOfVulnerabilityMutation, { data, loading, error }] = useDeleteAllVersionsOfVulnerabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAllVersionsOfVulnerabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAllVersionsOfVulnerabilityMutation, DeleteAllVersionsOfVulnerabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAllVersionsOfVulnerabilityMutation, DeleteAllVersionsOfVulnerabilityMutationVariables>(DeleteAllVersionsOfVulnerabilityDocument, options);
      }
export type DeleteAllVersionsOfVulnerabilityMutationHookResult = ReturnType<typeof useDeleteAllVersionsOfVulnerabilityMutation>;
export type DeleteAllVersionsOfVulnerabilityMutationResult = Apollo.MutationResult<DeleteAllVersionsOfVulnerabilityMutation>;
export type DeleteAllVersionsOfVulnerabilityMutationOptions = Apollo.BaseMutationOptions<DeleteAllVersionsOfVulnerabilityMutation, DeleteAllVersionsOfVulnerabilityMutationVariables>;
export const CompanyContactDocument = gql`
    query CompanyContact($companyContactId: ID!) {
  companyContact(id: $companyContactId) {
    ...companyContactFields
  }
}
    ${CompanyContactFieldsFragmentDoc}`;

/**
 * __useCompanyContactQuery__
 *
 * To run a query within a React component, call `useCompanyContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactQuery({
 *   variables: {
 *      companyContactId: // value for 'companyContactId'
 *   },
 * });
 */
export function useCompanyContactQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactQuery, CompanyContactQueryVariables> & ({ variables: CompanyContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyContactQuery, CompanyContactQueryVariables>(CompanyContactDocument, options);
      }
export function useCompanyContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactQuery, CompanyContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyContactQuery, CompanyContactQueryVariables>(CompanyContactDocument, options);
        }
export function useCompanyContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyContactQuery, CompanyContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyContactQuery, CompanyContactQueryVariables>(CompanyContactDocument, options);
        }
export type CompanyContactQueryHookResult = ReturnType<typeof useCompanyContactQuery>;
export type CompanyContactLazyQueryHookResult = ReturnType<typeof useCompanyContactLazyQuery>;
export type CompanyContactSuspenseQueryHookResult = ReturnType<typeof useCompanyContactSuspenseQuery>;
export type CompanyContactQueryResult = Apollo.QueryResult<CompanyContactQuery, CompanyContactQueryVariables>;
export const CompanyInviteDocument = gql`
    query CompanyInvite($inviteId: ID!) {
  companyInvite(id: $inviteId) {
    ...companyInviteFields
  }
}
    ${CompanyInviteFieldsFragmentDoc}`;

/**
 * __useCompanyInviteQuery__
 *
 * To run a query within a React component, call `useCompanyInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInviteQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useCompanyInviteQuery(baseOptions: Apollo.QueryHookOptions<CompanyInviteQuery, CompanyInviteQueryVariables> & ({ variables: CompanyInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInviteQuery, CompanyInviteQueryVariables>(CompanyInviteDocument, options);
      }
export function useCompanyInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInviteQuery, CompanyInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInviteQuery, CompanyInviteQueryVariables>(CompanyInviteDocument, options);
        }
export function useCompanyInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyInviteQuery, CompanyInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyInviteQuery, CompanyInviteQueryVariables>(CompanyInviteDocument, options);
        }
export type CompanyInviteQueryHookResult = ReturnType<typeof useCompanyInviteQuery>;
export type CompanyInviteLazyQueryHookResult = ReturnType<typeof useCompanyInviteLazyQuery>;
export type CompanyInviteSuspenseQueryHookResult = ReturnType<typeof useCompanyInviteSuspenseQuery>;
export type CompanyInviteQueryResult = Apollo.QueryResult<CompanyInviteQuery, CompanyInviteQueryVariables>;
export const CompanyInviteByTokenDocument = gql`
    query CompanyInviteByToken($token: String!) {
  retrieveCompanyInvite(token: $token) {
    ...companyInviteFields
    company {
      ...companyListFields
    }
  }
}
    ${CompanyInviteFieldsFragmentDoc}
${CompanyListFieldsFragmentDoc}`;

/**
 * __useCompanyInviteByTokenQuery__
 *
 * To run a query within a React component, call `useCompanyInviteByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInviteByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInviteByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useCompanyInviteByTokenQuery(baseOptions: Apollo.QueryHookOptions<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables> & ({ variables: CompanyInviteByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables>(CompanyInviteByTokenDocument, options);
      }
export function useCompanyInviteByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables>(CompanyInviteByTokenDocument, options);
        }
export function useCompanyInviteByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables>(CompanyInviteByTokenDocument, options);
        }
export type CompanyInviteByTokenQueryHookResult = ReturnType<typeof useCompanyInviteByTokenQuery>;
export type CompanyInviteByTokenLazyQueryHookResult = ReturnType<typeof useCompanyInviteByTokenLazyQuery>;
export type CompanyInviteByTokenSuspenseQueryHookResult = ReturnType<typeof useCompanyInviteByTokenSuspenseQuery>;
export type CompanyInviteByTokenQueryResult = Apollo.QueryResult<CompanyInviteByTokenQuery, CompanyInviteByTokenQueryVariables>;
export const CompanyUserDocument = gql`
    query CompanyUser($companyUserId: ID!) {
  companyUser(id: $companyUserId) {
    ...companyUserListFields
  }
}
    ${CompanyUserListFieldsFragmentDoc}`;

/**
 * __useCompanyUserQuery__
 *
 * To run a query within a React component, call `useCompanyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUserQuery({
 *   variables: {
 *      companyUserId: // value for 'companyUserId'
 *   },
 * });
 */
export function useCompanyUserQuery(baseOptions: Apollo.QueryHookOptions<CompanyUserQuery, CompanyUserQueryVariables> & ({ variables: CompanyUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyUserQuery, CompanyUserQueryVariables>(CompanyUserDocument, options);
      }
export function useCompanyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyUserQuery, CompanyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyUserQuery, CompanyUserQueryVariables>(CompanyUserDocument, options);
        }
export function useCompanyUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyUserQuery, CompanyUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyUserQuery, CompanyUserQueryVariables>(CompanyUserDocument, options);
        }
export type CompanyUserQueryHookResult = ReturnType<typeof useCompanyUserQuery>;
export type CompanyUserLazyQueryHookResult = ReturnType<typeof useCompanyUserLazyQuery>;
export type CompanyUserSuspenseQueryHookResult = ReturnType<typeof useCompanyUserSuspenseQuery>;
export type CompanyUserQueryResult = Apollo.QueryResult<CompanyUserQuery, CompanyUserQueryVariables>;
export const CompanyListDocument = gql`
    query CompanyList($first: Int, $after: String, $name: String, $order: CompanyFilter_order) {
  companies(first: $first, after: $after, name: $name, order: [$order]) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...companyListFields
      }
    }
  }
}
    ${CompanyListFieldsFragmentDoc}`;

/**
 * __useCompanyListQuery__
 *
 * To run a query within a React component, call `useCompanyListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      name: // value for 'name'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCompanyListQuery(baseOptions?: Apollo.QueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
      }
export function useCompanyListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
        }
export function useCompanyListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyListQuery, CompanyListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyListQuery, CompanyListQueryVariables>(CompanyListDocument, options);
        }
export type CompanyListQueryHookResult = ReturnType<typeof useCompanyListQuery>;
export type CompanyListLazyQueryHookResult = ReturnType<typeof useCompanyListLazyQuery>;
export type CompanyListSuspenseQueryHookResult = ReturnType<typeof useCompanyListSuspenseQuery>;
export type CompanyListQueryResult = Apollo.QueryResult<CompanyListQuery, CompanyListQueryVariables>;
export const CompanyDocument = gql`
    query Company($companyId: ID!) {
  company(id: $companyId) {
    ...companyFields
  }
}
    ${CompanyFieldsFragmentDoc}`;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery, CompanyQueryVariables> & ({ variables: CompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
      }
export function useCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export function useCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery, CompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery, CompanyQueryVariables>(CompanyDocument, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQueryHookResult = ReturnType<typeof useCompanyLazyQuery>;
export type CompanySuspenseQueryHookResult = ReturnType<typeof useCompanySuspenseQuery>;
export type CompanyQueryResult = Apollo.QueryResult<CompanyQuery, CompanyQueryVariables>;
export const CompanyUsersDocument = gql`
    query CompanyUsers($companyId: ID!, $first: Int, $after: String) {
  company(id: $companyId) {
    _id
    id
    users(first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...companyUserListFields
        }
      }
    }
  }
}
    ${CompanyUserListFieldsFragmentDoc}`;

/**
 * __useCompanyUsersQuery__
 *
 * To run a query within a React component, call `useCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables> & ({ variables: CompanyUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyUsersQuery, CompanyUsersQueryVariables>(CompanyUsersDocument, options);
      }
export function useCompanyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyUsersQuery, CompanyUsersQueryVariables>(CompanyUsersDocument, options);
        }
export function useCompanyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyUsersQuery, CompanyUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyUsersQuery, CompanyUsersQueryVariables>(CompanyUsersDocument, options);
        }
export type CompanyUsersQueryHookResult = ReturnType<typeof useCompanyUsersQuery>;
export type CompanyUsersLazyQueryHookResult = ReturnType<typeof useCompanyUsersLazyQuery>;
export type CompanyUsersSuspenseQueryHookResult = ReturnType<typeof useCompanyUsersSuspenseQuery>;
export type CompanyUsersQueryResult = Apollo.QueryResult<CompanyUsersQuery, CompanyUsersQueryVariables>;
export const CompanyReportsDocument = gql`
    query CompanyReports($companyId: ID!, $first: Int, $after: String, $order: ReportFilter_order) {
  company(id: $companyId) {
    _id
    id
    reports(first: $first, after: $after, order: [$order]) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportListFields
        }
      }
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;

/**
 * __useCompanyReportsQuery__
 *
 * To run a query within a React component, call `useCompanyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useCompanyReportsQuery(baseOptions: Apollo.QueryHookOptions<CompanyReportsQuery, CompanyReportsQueryVariables> & ({ variables: CompanyReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyReportsQuery, CompanyReportsQueryVariables>(CompanyReportsDocument, options);
      }
export function useCompanyReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyReportsQuery, CompanyReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyReportsQuery, CompanyReportsQueryVariables>(CompanyReportsDocument, options);
        }
export function useCompanyReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyReportsQuery, CompanyReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyReportsQuery, CompanyReportsQueryVariables>(CompanyReportsDocument, options);
        }
export type CompanyReportsQueryHookResult = ReturnType<typeof useCompanyReportsQuery>;
export type CompanyReportsLazyQueryHookResult = ReturnType<typeof useCompanyReportsLazyQuery>;
export type CompanyReportsSuspenseQueryHookResult = ReturnType<typeof useCompanyReportsSuspenseQuery>;
export type CompanyReportsQueryResult = Apollo.QueryResult<CompanyReportsQuery, CompanyReportsQueryVariables>;
export const CompanyInvitesListDocument = gql`
    query CompanyInvitesList($companyId: ID!, $first: Int, $after: String) {
  company(id: $companyId) {
    _id
    id
    invites(first: $first, after: $after, order: {id: "desc"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...companyInviteListFields
        }
      }
    }
  }
}
    ${CompanyInviteListFieldsFragmentDoc}`;

/**
 * __useCompanyInvitesListQuery__
 *
 * To run a query within a React component, call `useCompanyInvitesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInvitesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInvitesListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCompanyInvitesListQuery(baseOptions: Apollo.QueryHookOptions<CompanyInvitesListQuery, CompanyInvitesListQueryVariables> & ({ variables: CompanyInvitesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInvitesListQuery, CompanyInvitesListQueryVariables>(CompanyInvitesListDocument, options);
      }
export function useCompanyInvitesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInvitesListQuery, CompanyInvitesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInvitesListQuery, CompanyInvitesListQueryVariables>(CompanyInvitesListDocument, options);
        }
export function useCompanyInvitesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyInvitesListQuery, CompanyInvitesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyInvitesListQuery, CompanyInvitesListQueryVariables>(CompanyInvitesListDocument, options);
        }
export type CompanyInvitesListQueryHookResult = ReturnType<typeof useCompanyInvitesListQuery>;
export type CompanyInvitesListLazyQueryHookResult = ReturnType<typeof useCompanyInvitesListLazyQuery>;
export type CompanyInvitesListSuspenseQueryHookResult = ReturnType<typeof useCompanyInvitesListSuspenseQuery>;
export type CompanyInvitesListQueryResult = Apollo.QueryResult<CompanyInvitesListQuery, CompanyInvitesListQueryVariables>;
export const CompanyContactsDocument = gql`
    query CompanyContacts($companyId: ID!, $first: Int, $after: String) {
  company(id: $companyId) {
    _id
    id
    contacts(first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...companyContactFields
        }
      }
    }
  }
}
    ${CompanyContactFieldsFragmentDoc}`;

/**
 * __useCompanyContactsQuery__
 *
 * To run a query within a React component, call `useCompanyContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyContactsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCompanyContactsQuery(baseOptions: Apollo.QueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables> & ({ variables: CompanyContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
      }
export function useCompanyContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export function useCompanyContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyContactsQuery, CompanyContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyContactsQuery, CompanyContactsQueryVariables>(CompanyContactsDocument, options);
        }
export type CompanyContactsQueryHookResult = ReturnType<typeof useCompanyContactsQuery>;
export type CompanyContactsLazyQueryHookResult = ReturnType<typeof useCompanyContactsLazyQuery>;
export type CompanyContactsSuspenseQueryHookResult = ReturnType<typeof useCompanyContactsSuspenseQuery>;
export type CompanyContactsQueryResult = Apollo.QueryResult<CompanyContactsQuery, CompanyContactsQueryVariables>;
export const PublishedCompanyReportVulnerabilitiesDocument = gql`
    query PublishedCompanyReportVulnerabilities($companyId: ID!, $first: Int, $after: String, $status: String, $severity: String, $title: String, $issueNumber: Int, $testingTypes: [String], $dateDiscovered: ReportVulnerabilityFilter_dateDiscovered, $cvssScore: String) {
  publishedCompanyReportVulnerabilities(
    company: $companyId
    first: $first
    after: $after
    status: $status
    severity: $severity
    title: $title
    issueNumber: $issueNumber
    testingTypes_list: $testingTypes
    dateDiscovered: [$dateDiscovered]
    cvssScore: $cvssScore
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVulnerabilityFields
      }
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __usePublishedCompanyReportVulnerabilitiesQuery__
 *
 * To run a query within a React component, call `usePublishedCompanyReportVulnerabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedCompanyReportVulnerabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedCompanyReportVulnerabilitiesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      severity: // value for 'severity'
 *      title: // value for 'title'
 *      issueNumber: // value for 'issueNumber'
 *      testingTypes: // value for 'testingTypes'
 *      dateDiscovered: // value for 'dateDiscovered'
 *      cvssScore: // value for 'cvssScore'
 *   },
 * });
 */
export function usePublishedCompanyReportVulnerabilitiesQuery(baseOptions: Apollo.QueryHookOptions<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables> & ({ variables: PublishedCompanyReportVulnerabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables>(PublishedCompanyReportVulnerabilitiesDocument, options);
      }
export function usePublishedCompanyReportVulnerabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables>(PublishedCompanyReportVulnerabilitiesDocument, options);
        }
export function usePublishedCompanyReportVulnerabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables>(PublishedCompanyReportVulnerabilitiesDocument, options);
        }
export type PublishedCompanyReportVulnerabilitiesQueryHookResult = ReturnType<typeof usePublishedCompanyReportVulnerabilitiesQuery>;
export type PublishedCompanyReportVulnerabilitiesLazyQueryHookResult = ReturnType<typeof usePublishedCompanyReportVulnerabilitiesLazyQuery>;
export type PublishedCompanyReportVulnerabilitiesSuspenseQueryHookResult = ReturnType<typeof usePublishedCompanyReportVulnerabilitiesSuspenseQuery>;
export type PublishedCompanyReportVulnerabilitiesQueryResult = Apollo.QueryResult<PublishedCompanyReportVulnerabilitiesQuery, PublishedCompanyReportVulnerabilitiesQueryVariables>;
export const PublishedCompanyReportVulnerabilitiesListDocument = gql`
    query PublishedCompanyReportVulnerabilitiesList($companyId: ID!, $first: Int, $after: String, $order: ReportVulnerabilityFilter_order, $status: String, $severity: String, $title: String, $issueNumber: Int, $testingTypes: [String], $dateDiscovered: ReportVulnerabilityFilter_dateDiscovered, $cvssScore: String) {
  publishedCompanyReportVulnerabilities(
    company: $companyId
    first: $first
    after: $after
    order: [$order]
    status: $status
    severity: $severity
    title: $title
    issueNumber: $issueNumber
    testingTypes_list: $testingTypes
    dateDiscovered: [$dateDiscovered]
    cvssScore: $cvssScore
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVulnerabilityFields
      }
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __usePublishedCompanyReportVulnerabilitiesListQuery__
 *
 * To run a query within a React component, call `usePublishedCompanyReportVulnerabilitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedCompanyReportVulnerabilitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedCompanyReportVulnerabilitiesListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      status: // value for 'status'
 *      severity: // value for 'severity'
 *      title: // value for 'title'
 *      issueNumber: // value for 'issueNumber'
 *      testingTypes: // value for 'testingTypes'
 *      dateDiscovered: // value for 'dateDiscovered'
 *      cvssScore: // value for 'cvssScore'
 *   },
 * });
 */
export function usePublishedCompanyReportVulnerabilitiesListQuery(baseOptions: Apollo.QueryHookOptions<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables> & ({ variables: PublishedCompanyReportVulnerabilitiesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables>(PublishedCompanyReportVulnerabilitiesListDocument, options);
      }
export function usePublishedCompanyReportVulnerabilitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables>(PublishedCompanyReportVulnerabilitiesListDocument, options);
        }
export function usePublishedCompanyReportVulnerabilitiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables>(PublishedCompanyReportVulnerabilitiesListDocument, options);
        }
export type PublishedCompanyReportVulnerabilitiesListQueryHookResult = ReturnType<typeof usePublishedCompanyReportVulnerabilitiesListQuery>;
export type PublishedCompanyReportVulnerabilitiesListLazyQueryHookResult = ReturnType<typeof usePublishedCompanyReportVulnerabilitiesListLazyQuery>;
export type PublishedCompanyReportVulnerabilitiesListSuspenseQueryHookResult = ReturnType<typeof usePublishedCompanyReportVulnerabilitiesListSuspenseQuery>;
export type PublishedCompanyReportVulnerabilitiesListQueryResult = Apollo.QueryResult<PublishedCompanyReportVulnerabilitiesListQuery, PublishedCompanyReportVulnerabilitiesListQueryVariables>;
export const ContactDocument = gql`
    query Contact($contactId: ID!) {
  contact(id: $contactId) {
    ...contactFields
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useContactQuery__
 *
 * To run a query within a React component, call `useContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactQuery(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables> & ({ variables: ContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export function useContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQueryHookResult = ReturnType<typeof useContactQuery>;
export type ContactLazyQueryHookResult = ReturnType<typeof useContactLazyQuery>;
export type ContactSuspenseQueryHookResult = ReturnType<typeof useContactSuspenseQuery>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const ContactListDocument = gql`
    query ContactList($first: Int, $after: String) {
  contacts(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...contactListFields
      }
    }
  }
}
    ${ContactListFieldsFragmentDoc}`;

/**
 * __useContactListQuery__
 *
 * To run a query within a React component, call `useContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactListQuery(baseOptions?: Apollo.QueryHookOptions<ContactListQuery, ContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactListQuery, ContactListQueryVariables>(ContactListDocument, options);
      }
export function useContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactListQuery, ContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactListQuery, ContactListQueryVariables>(ContactListDocument, options);
        }
export function useContactListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactListQuery, ContactListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactListQuery, ContactListQueryVariables>(ContactListDocument, options);
        }
export type ContactListQueryHookResult = ReturnType<typeof useContactListQuery>;
export type ContactListLazyQueryHookResult = ReturnType<typeof useContactListLazyQuery>;
export type ContactListSuspenseQueryHookResult = ReturnType<typeof useContactListSuspenseQuery>;
export type ContactListQueryResult = Apollo.QueryResult<ContactListQuery, ContactListQueryVariables>;
export const ContactsDocument = gql`
    query Contacts($first: Int, $after: String) {
  contacts(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...contactFields
      }
    }
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useContactsQuery__
 *
 * To run a query within a React component, call `useContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export function useContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQueryHookResult = ReturnType<typeof useContactsQuery>;
export type ContactsLazyQueryHookResult = ReturnType<typeof useContactsLazyQuery>;
export type ContactsSuspenseQueryHookResult = ReturnType<typeof useContactsSuspenseQuery>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const ReportAccessInformationCredentialsDocument = gql`
    query ReportAccessInformationCredentials($credentialsId: ID!) {
  reportAccessInformationCredentials(id: $credentialsId) {
    ...reportAccessInformationCredentialsFields
  }
}
    ${ReportAccessInformationCredentialsFieldsFragmentDoc}`;

/**
 * __useReportAccessInformationCredentialsQuery__
 *
 * To run a query within a React component, call `useReportAccessInformationCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAccessInformationCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAccessInformationCredentialsQuery({
 *   variables: {
 *      credentialsId: // value for 'credentialsId'
 *   },
 * });
 */
export function useReportAccessInformationCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables> & ({ variables: ReportAccessInformationCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables>(ReportAccessInformationCredentialsDocument, options);
      }
export function useReportAccessInformationCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables>(ReportAccessInformationCredentialsDocument, options);
        }
export function useReportAccessInformationCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables>(ReportAccessInformationCredentialsDocument, options);
        }
export type ReportAccessInformationCredentialsQueryHookResult = ReturnType<typeof useReportAccessInformationCredentialsQuery>;
export type ReportAccessInformationCredentialsLazyQueryHookResult = ReturnType<typeof useReportAccessInformationCredentialsLazyQuery>;
export type ReportAccessInformationCredentialsSuspenseQueryHookResult = ReturnType<typeof useReportAccessInformationCredentialsSuspenseQuery>;
export type ReportAccessInformationCredentialsQueryResult = Apollo.QueryResult<ReportAccessInformationCredentialsQuery, ReportAccessInformationCredentialsQueryVariables>;
export const ReportVersionAccessInformationCredentialsDocument = gql`
    query ReportVersionAccessInformationCredentials($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    accessInformation {
      ...reportAccessInformationFields
      credentials {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...reportAccessInformationCredentialsFields
          }
        }
      }
    }
  }
}
    ${ReportAccessInformationFieldsFragmentDoc}
${ReportAccessInformationCredentialsFieldsFragmentDoc}`;

/**
 * __useReportVersionAccessInformationCredentialsQuery__
 *
 * To run a query within a React component, call `useReportVersionAccessInformationCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionAccessInformationCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionAccessInformationCredentialsQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionAccessInformationCredentialsQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables> & ({ variables: ReportVersionAccessInformationCredentialsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables>(ReportVersionAccessInformationCredentialsDocument, options);
      }
export function useReportVersionAccessInformationCredentialsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables>(ReportVersionAccessInformationCredentialsDocument, options);
        }
export function useReportVersionAccessInformationCredentialsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables>(ReportVersionAccessInformationCredentialsDocument, options);
        }
export type ReportVersionAccessInformationCredentialsQueryHookResult = ReturnType<typeof useReportVersionAccessInformationCredentialsQuery>;
export type ReportVersionAccessInformationCredentialsLazyQueryHookResult = ReturnType<typeof useReportVersionAccessInformationCredentialsLazyQuery>;
export type ReportVersionAccessInformationCredentialsSuspenseQueryHookResult = ReturnType<typeof useReportVersionAccessInformationCredentialsSuspenseQuery>;
export type ReportVersionAccessInformationCredentialsQueryResult = Apollo.QueryResult<ReportVersionAccessInformationCredentialsQuery, ReportVersionAccessInformationCredentialsQueryVariables>;
export const ReportVersionAccessInformationFilesDocument = gql`
    query ReportVersionAccessInformationFiles($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    accessInformation {
      ...reportAccessInformationFields
      files {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...reportAccessInformationFileFields
          }
        }
      }
    }
  }
}
    ${ReportAccessInformationFieldsFragmentDoc}
${ReportAccessInformationFileFieldsFragmentDoc}`;

/**
 * __useReportVersionAccessInformationFilesQuery__
 *
 * To run a query within a React component, call `useReportVersionAccessInformationFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionAccessInformationFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionAccessInformationFilesQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionAccessInformationFilesQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables> & ({ variables: ReportVersionAccessInformationFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables>(ReportVersionAccessInformationFilesDocument, options);
      }
export function useReportVersionAccessInformationFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables>(ReportVersionAccessInformationFilesDocument, options);
        }
export function useReportVersionAccessInformationFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables>(ReportVersionAccessInformationFilesDocument, options);
        }
export type ReportVersionAccessInformationFilesQueryHookResult = ReturnType<typeof useReportVersionAccessInformationFilesQuery>;
export type ReportVersionAccessInformationFilesLazyQueryHookResult = ReturnType<typeof useReportVersionAccessInformationFilesLazyQuery>;
export type ReportVersionAccessInformationFilesSuspenseQueryHookResult = ReturnType<typeof useReportVersionAccessInformationFilesSuspenseQuery>;
export type ReportVersionAccessInformationFilesQueryResult = Apollo.QueryResult<ReportVersionAccessInformationFilesQuery, ReportVersionAccessInformationFilesQueryVariables>;
export const ReportAccessInformationFileDocument = gql`
    query ReportAccessInformationFile($fileId: ID!) {
  reportAccessInformationFile(id: $fileId) {
    ...reportAccessInformationFileFields
  }
}
    ${ReportAccessInformationFileFieldsFragmentDoc}`;

/**
 * __useReportAccessInformationFileQuery__
 *
 * To run a query within a React component, call `useReportAccessInformationFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAccessInformationFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAccessInformationFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useReportAccessInformationFileQuery(baseOptions: Apollo.QueryHookOptions<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables> & ({ variables: ReportAccessInformationFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables>(ReportAccessInformationFileDocument, options);
      }
export function useReportAccessInformationFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables>(ReportAccessInformationFileDocument, options);
        }
export function useReportAccessInformationFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables>(ReportAccessInformationFileDocument, options);
        }
export type ReportAccessInformationFileQueryHookResult = ReturnType<typeof useReportAccessInformationFileQuery>;
export type ReportAccessInformationFileLazyQueryHookResult = ReturnType<typeof useReportAccessInformationFileLazyQuery>;
export type ReportAccessInformationFileSuspenseQueryHookResult = ReturnType<typeof useReportAccessInformationFileSuspenseQuery>;
export type ReportAccessInformationFileQueryResult = Apollo.QueryResult<ReportAccessInformationFileQuery, ReportAccessInformationFileQueryVariables>;
export const ReportAccessInformationDocument = gql`
    query ReportAccessInformation($id: ID!) {
  reportAccessInformation(id: $id) {
    ...reportAccessInformationFields
  }
}
    ${ReportAccessInformationFieldsFragmentDoc}`;

/**
 * __useReportAccessInformationQuery__
 *
 * To run a query within a React component, call `useReportAccessInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAccessInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAccessInformationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportAccessInformationQuery(baseOptions: Apollo.QueryHookOptions<ReportAccessInformationQuery, ReportAccessInformationQueryVariables> & ({ variables: ReportAccessInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportAccessInformationQuery, ReportAccessInformationQueryVariables>(ReportAccessInformationDocument, options);
      }
export function useReportAccessInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportAccessInformationQuery, ReportAccessInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportAccessInformationQuery, ReportAccessInformationQueryVariables>(ReportAccessInformationDocument, options);
        }
export function useReportAccessInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportAccessInformationQuery, ReportAccessInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportAccessInformationQuery, ReportAccessInformationQueryVariables>(ReportAccessInformationDocument, options);
        }
export type ReportAccessInformationQueryHookResult = ReturnType<typeof useReportAccessInformationQuery>;
export type ReportAccessInformationLazyQueryHookResult = ReturnType<typeof useReportAccessInformationLazyQuery>;
export type ReportAccessInformationSuspenseQueryHookResult = ReturnType<typeof useReportAccessInformationSuspenseQuery>;
export type ReportAccessInformationQueryResult = Apollo.QueryResult<ReportAccessInformationQuery, ReportAccessInformationQueryVariables>;
export const ReportConsultantDocument = gql`
    query ReportConsultant($consultantId: ID!) {
  reportConsultant(id: $consultantId) {
    ...reportConsultantFields
  }
}
    ${ReportConsultantFieldsFragmentDoc}`;

/**
 * __useReportConsultantQuery__
 *
 * To run a query within a React component, call `useReportConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportConsultantQuery({
 *   variables: {
 *      consultantId: // value for 'consultantId'
 *   },
 * });
 */
export function useReportConsultantQuery(baseOptions: Apollo.QueryHookOptions<ReportConsultantQuery, ReportConsultantQueryVariables> & ({ variables: ReportConsultantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportConsultantQuery, ReportConsultantQueryVariables>(ReportConsultantDocument, options);
      }
export function useReportConsultantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportConsultantQuery, ReportConsultantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportConsultantQuery, ReportConsultantQueryVariables>(ReportConsultantDocument, options);
        }
export function useReportConsultantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportConsultantQuery, ReportConsultantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportConsultantQuery, ReportConsultantQueryVariables>(ReportConsultantDocument, options);
        }
export type ReportConsultantQueryHookResult = ReturnType<typeof useReportConsultantQuery>;
export type ReportConsultantLazyQueryHookResult = ReturnType<typeof useReportConsultantLazyQuery>;
export type ReportConsultantSuspenseQueryHookResult = ReturnType<typeof useReportConsultantSuspenseQuery>;
export type ReportConsultantQueryResult = Apollo.QueryResult<ReportConsultantQuery, ReportConsultantQueryVariables>;
export const ReportContactDocument = gql`
    query ReportContact($contactId: ID!) {
  reportContact(id: $contactId) {
    ...reportContactFields
  }
}
    ${ReportContactFieldsFragmentDoc}`;

/**
 * __useReportContactQuery__
 *
 * To run a query within a React component, call `useReportContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportContactQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useReportContactQuery(baseOptions: Apollo.QueryHookOptions<ReportContactQuery, ReportContactQueryVariables> & ({ variables: ReportContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportContactQuery, ReportContactQueryVariables>(ReportContactDocument, options);
      }
export function useReportContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportContactQuery, ReportContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportContactQuery, ReportContactQueryVariables>(ReportContactDocument, options);
        }
export function useReportContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportContactQuery, ReportContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportContactQuery, ReportContactQueryVariables>(ReportContactDocument, options);
        }
export type ReportContactQueryHookResult = ReturnType<typeof useReportContactQuery>;
export type ReportContactLazyQueryHookResult = ReturnType<typeof useReportContactLazyQuery>;
export type ReportContactSuspenseQueryHookResult = ReturnType<typeof useReportContactSuspenseQuery>;
export type ReportContactQueryResult = Apollo.QueryResult<ReportContactQuery, ReportContactQueryVariables>;
export const ReportDeliverableFileDocument = gql`
    query ReportDeliverableFile($fileId: ID!) {
  reportDeliverableFile(id: $fileId) {
    ...reportDeliverableFileFields
  }
}
    ${ReportDeliverableFileFieldsFragmentDoc}`;

/**
 * __useReportDeliverableFileQuery__
 *
 * To run a query within a React component, call `useReportDeliverableFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportDeliverableFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportDeliverableFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useReportDeliverableFileQuery(baseOptions: Apollo.QueryHookOptions<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables> & ({ variables: ReportDeliverableFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables>(ReportDeliverableFileDocument, options);
      }
export function useReportDeliverableFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables>(ReportDeliverableFileDocument, options);
        }
export function useReportDeliverableFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables>(ReportDeliverableFileDocument, options);
        }
export type ReportDeliverableFileQueryHookResult = ReturnType<typeof useReportDeliverableFileQuery>;
export type ReportDeliverableFileLazyQueryHookResult = ReturnType<typeof useReportDeliverableFileLazyQuery>;
export type ReportDeliverableFileSuspenseQueryHookResult = ReturnType<typeof useReportDeliverableFileSuspenseQuery>;
export type ReportDeliverableFileQueryResult = Apollo.QueryResult<ReportDeliverableFileQuery, ReportDeliverableFileQueryVariables>;
export const ReportEngagementOverviewDocument = gql`
    query ReportEngagementOverview($id: ID!) {
  reportEngagementOverview(id: $id) {
    ...reportEngagementOverviewFields
  }
}
    ${ReportEngagementOverviewFieldsFragmentDoc}`;

/**
 * __useReportEngagementOverviewQuery__
 *
 * To run a query within a React component, call `useReportEngagementOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportEngagementOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportEngagementOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportEngagementOverviewQuery(baseOptions: Apollo.QueryHookOptions<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables> & ({ variables: ReportEngagementOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables>(ReportEngagementOverviewDocument, options);
      }
export function useReportEngagementOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables>(ReportEngagementOverviewDocument, options);
        }
export function useReportEngagementOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables>(ReportEngagementOverviewDocument, options);
        }
export type ReportEngagementOverviewQueryHookResult = ReturnType<typeof useReportEngagementOverviewQuery>;
export type ReportEngagementOverviewLazyQueryHookResult = ReturnType<typeof useReportEngagementOverviewLazyQuery>;
export type ReportEngagementOverviewSuspenseQueryHookResult = ReturnType<typeof useReportEngagementOverviewSuspenseQuery>;
export type ReportEngagementOverviewQueryResult = Apollo.QueryResult<ReportEngagementOverviewQuery, ReportEngagementOverviewQueryVariables>;
export const ReportInviteDocument = gql`
    query ReportInvite($inviteId: ID!) {
  reportInvite(id: $inviteId) {
    ...reportInviteFields
  }
}
    ${ReportInviteFieldsFragmentDoc}`;

/**
 * __useReportInviteQuery__
 *
 * To run a query within a React component, call `useReportInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportInviteQuery({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *   },
 * });
 */
export function useReportInviteQuery(baseOptions: Apollo.QueryHookOptions<ReportInviteQuery, ReportInviteQueryVariables> & ({ variables: ReportInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportInviteQuery, ReportInviteQueryVariables>(ReportInviteDocument, options);
      }
export function useReportInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportInviteQuery, ReportInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportInviteQuery, ReportInviteQueryVariables>(ReportInviteDocument, options);
        }
export function useReportInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportInviteQuery, ReportInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportInviteQuery, ReportInviteQueryVariables>(ReportInviteDocument, options);
        }
export type ReportInviteQueryHookResult = ReturnType<typeof useReportInviteQuery>;
export type ReportInviteLazyQueryHookResult = ReturnType<typeof useReportInviteLazyQuery>;
export type ReportInviteSuspenseQueryHookResult = ReturnType<typeof useReportInviteSuspenseQuery>;
export type ReportInviteQueryResult = Apollo.QueryResult<ReportInviteQuery, ReportInviteQueryVariables>;
export const ReportInviteByTokenDocument = gql`
    query ReportInviteByToken($token: String!) {
  retrieveReportInvite(token: $token) {
    ...reportInviteFields
    report {
      ...reportListFields
    }
  }
}
    ${ReportInviteFieldsFragmentDoc}
${ReportListFieldsFragmentDoc}`;

/**
 * __useReportInviteByTokenQuery__
 *
 * To run a query within a React component, call `useReportInviteByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportInviteByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportInviteByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReportInviteByTokenQuery(baseOptions: Apollo.QueryHookOptions<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables> & ({ variables: ReportInviteByTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables>(ReportInviteByTokenDocument, options);
      }
export function useReportInviteByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables>(ReportInviteByTokenDocument, options);
        }
export function useReportInviteByTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables>(ReportInviteByTokenDocument, options);
        }
export type ReportInviteByTokenQueryHookResult = ReturnType<typeof useReportInviteByTokenQuery>;
export type ReportInviteByTokenLazyQueryHookResult = ReturnType<typeof useReportInviteByTokenLazyQuery>;
export type ReportInviteByTokenSuspenseQueryHookResult = ReturnType<typeof useReportInviteByTokenSuspenseQuery>;
export type ReportInviteByTokenQueryResult = Apollo.QueryResult<ReportInviteByTokenQuery, ReportInviteByTokenQueryVariables>;
export const ReportScopeDocument = gql`
    query ReportScope($id: ID!) {
  reportScope(id: $id) {
    ...reportScopeFields
  }
}
    ${ReportScopeFieldsFragmentDoc}`;

/**
 * __useReportScopeQuery__
 *
 * To run a query within a React component, call `useReportScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportScopeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportScopeQuery(baseOptions: Apollo.QueryHookOptions<ReportScopeQuery, ReportScopeQueryVariables> & ({ variables: ReportScopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportScopeQuery, ReportScopeQueryVariables>(ReportScopeDocument, options);
      }
export function useReportScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportScopeQuery, ReportScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportScopeQuery, ReportScopeQueryVariables>(ReportScopeDocument, options);
        }
export function useReportScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportScopeQuery, ReportScopeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportScopeQuery, ReportScopeQueryVariables>(ReportScopeDocument, options);
        }
export type ReportScopeQueryHookResult = ReturnType<typeof useReportScopeQuery>;
export type ReportScopeLazyQueryHookResult = ReturnType<typeof useReportScopeLazyQuery>;
export type ReportScopeSuspenseQueryHookResult = ReturnType<typeof useReportScopeSuspenseQuery>;
export type ReportScopeQueryResult = Apollo.QueryResult<ReportScopeQuery, ReportScopeQueryVariables>;
export const ReportSectionDocument = gql`
    query ReportSection($sectionId: ID!) {
  reportSection(id: $sectionId) {
    ...reportSectionFields
  }
}
    ${ReportSectionFieldsFragmentDoc}`;

/**
 * __useReportSectionQuery__
 *
 * To run a query within a React component, call `useReportSectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportSectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportSectionQuery({
 *   variables: {
 *      sectionId: // value for 'sectionId'
 *   },
 * });
 */
export function useReportSectionQuery(baseOptions: Apollo.QueryHookOptions<ReportSectionQuery, ReportSectionQueryVariables> & ({ variables: ReportSectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportSectionQuery, ReportSectionQueryVariables>(ReportSectionDocument, options);
      }
export function useReportSectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportSectionQuery, ReportSectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportSectionQuery, ReportSectionQueryVariables>(ReportSectionDocument, options);
        }
export function useReportSectionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportSectionQuery, ReportSectionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportSectionQuery, ReportSectionQueryVariables>(ReportSectionDocument, options);
        }
export type ReportSectionQueryHookResult = ReturnType<typeof useReportSectionQuery>;
export type ReportSectionLazyQueryHookResult = ReturnType<typeof useReportSectionLazyQuery>;
export type ReportSectionSuspenseQueryHookResult = ReturnType<typeof useReportSectionSuspenseQuery>;
export type ReportSectionQueryResult = Apollo.QueryResult<ReportSectionQuery, ReportSectionQueryVariables>;
export const ReportUserDocument = gql`
    query ReportUser($reportUserId: ID!) {
  reportUser(id: $reportUserId) {
    ...reportUserListFields
  }
}
    ${ReportUserListFieldsFragmentDoc}`;

/**
 * __useReportUserQuery__
 *
 * To run a query within a React component, call `useReportUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportUserQuery({
 *   variables: {
 *      reportUserId: // value for 'reportUserId'
 *   },
 * });
 */
export function useReportUserQuery(baseOptions: Apollo.QueryHookOptions<ReportUserQuery, ReportUserQueryVariables> & ({ variables: ReportUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUserQuery, ReportUserQueryVariables>(ReportUserDocument, options);
      }
export function useReportUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUserQuery, ReportUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUserQuery, ReportUserQueryVariables>(ReportUserDocument, options);
        }
export function useReportUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUserQuery, ReportUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUserQuery, ReportUserQueryVariables>(ReportUserDocument, options);
        }
export type ReportUserQueryHookResult = ReturnType<typeof useReportUserQuery>;
export type ReportUserLazyQueryHookResult = ReturnType<typeof useReportUserLazyQuery>;
export type ReportUserSuspenseQueryHookResult = ReturnType<typeof useReportUserSuspenseQuery>;
export type ReportUserQueryResult = Apollo.QueryResult<ReportUserQuery, ReportUserQueryVariables>;
export const ReportVersionDocument = gql`
    query ReportVersion($versionId: ID!) {
  reportVersion(id: $versionId) {
    ...reportVersionFields
    report {
      _id
      id
      title
      company {
        ...companyListFields
      }
    }
  }
}
    ${ReportVersionFieldsFragmentDoc}
${CompanyListFieldsFragmentDoc}`;

/**
 * __useReportVersionQuery__
 *
 * To run a query within a React component, call `useReportVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionQuery, ReportVersionQueryVariables> & ({ variables: ReportVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionQuery, ReportVersionQueryVariables>(ReportVersionDocument, options);
      }
export function useReportVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionQuery, ReportVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionQuery, ReportVersionQueryVariables>(ReportVersionDocument, options);
        }
export function useReportVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionQuery, ReportVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionQuery, ReportVersionQueryVariables>(ReportVersionDocument, options);
        }
export type ReportVersionQueryHookResult = ReturnType<typeof useReportVersionQuery>;
export type ReportVersionLazyQueryHookResult = ReturnType<typeof useReportVersionLazyQuery>;
export type ReportVersionSuspenseQueryHookResult = ReturnType<typeof useReportVersionSuspenseQuery>;
export type ReportVersionQueryResult = Apollo.QueryResult<ReportVersionQuery, ReportVersionQueryVariables>;
export const ReportVersionVersionDocument = gql`
    query ReportVersionVersion($versionId: ID!) {
  reportVersion(id: $versionId) {
    ...reportVersionFields
  }
}
    ${ReportVersionFieldsFragmentDoc}`;

/**
 * __useReportVersionVersionQuery__
 *
 * To run a query within a React component, call `useReportVersionVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionVersionQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionVersionQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionVersionQuery, ReportVersionVersionQueryVariables> & ({ variables: ReportVersionVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionVersionQuery, ReportVersionVersionQueryVariables>(ReportVersionVersionDocument, options);
      }
export function useReportVersionVersionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionVersionQuery, ReportVersionVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionVersionQuery, ReportVersionVersionQueryVariables>(ReportVersionVersionDocument, options);
        }
export function useReportVersionVersionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionVersionQuery, ReportVersionVersionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionVersionQuery, ReportVersionVersionQueryVariables>(ReportVersionVersionDocument, options);
        }
export type ReportVersionVersionQueryHookResult = ReturnType<typeof useReportVersionVersionQuery>;
export type ReportVersionVersionLazyQueryHookResult = ReturnType<typeof useReportVersionVersionLazyQuery>;
export type ReportVersionVersionSuspenseQueryHookResult = ReturnType<typeof useReportVersionVersionSuspenseQuery>;
export type ReportVersionVersionQueryResult = Apollo.QueryResult<ReportVersionVersionQuery, ReportVersionVersionQueryVariables>;
export const ReportVersionTestDocument = gql`
    query ReportVersionTest($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    testName
    testTypes
    testPerformedFrom
    testPerformedTo
    testApplicationVersion
    testServerVersion
    testHostname
    testEffortDays
  }
}
    `;

/**
 * __useReportVersionTestQuery__
 *
 * To run a query within a React component, call `useReportVersionTestQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionTestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionTestQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionTestQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionTestQuery, ReportVersionTestQueryVariables> & ({ variables: ReportVersionTestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionTestQuery, ReportVersionTestQueryVariables>(ReportVersionTestDocument, options);
      }
export function useReportVersionTestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionTestQuery, ReportVersionTestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionTestQuery, ReportVersionTestQueryVariables>(ReportVersionTestDocument, options);
        }
export function useReportVersionTestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionTestQuery, ReportVersionTestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionTestQuery, ReportVersionTestQueryVariables>(ReportVersionTestDocument, options);
        }
export type ReportVersionTestQueryHookResult = ReturnType<typeof useReportVersionTestQuery>;
export type ReportVersionTestLazyQueryHookResult = ReturnType<typeof useReportVersionTestLazyQuery>;
export type ReportVersionTestSuspenseQueryHookResult = ReturnType<typeof useReportVersionTestSuspenseQuery>;
export type ReportVersionTestQueryResult = Apollo.QueryResult<ReportVersionTestQuery, ReportVersionTestQueryVariables>;
export const ReportVersionClientDocument = gql`
    query ReportVersionClient($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    client {
      ...reportClientFields
    }
    report {
      _id
      id
      company {
        _id
        id
      }
    }
  }
}
    ${ReportClientFieldsFragmentDoc}`;

/**
 * __useReportVersionClientQuery__
 *
 * To run a query within a React component, call `useReportVersionClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionClientQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionClientQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionClientQuery, ReportVersionClientQueryVariables> & ({ variables: ReportVersionClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionClientQuery, ReportVersionClientQueryVariables>(ReportVersionClientDocument, options);
      }
export function useReportVersionClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionClientQuery, ReportVersionClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionClientQuery, ReportVersionClientQueryVariables>(ReportVersionClientDocument, options);
        }
export function useReportVersionClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionClientQuery, ReportVersionClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionClientQuery, ReportVersionClientQueryVariables>(ReportVersionClientDocument, options);
        }
export type ReportVersionClientQueryHookResult = ReturnType<typeof useReportVersionClientQuery>;
export type ReportVersionClientLazyQueryHookResult = ReturnType<typeof useReportVersionClientLazyQuery>;
export type ReportVersionClientSuspenseQueryHookResult = ReturnType<typeof useReportVersionClientSuspenseQuery>;
export type ReportVersionClientQueryResult = Apollo.QueryResult<ReportVersionClientQuery, ReportVersionClientQueryVariables>;
export const ReportVersionConsultantDocument = gql`
    query ReportVersionConsultant($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    consultant {
      ...reportConsultantFields
    }
    report {
      _id
      id
      company {
        _id
        id
      }
    }
  }
}
    ${ReportConsultantFieldsFragmentDoc}`;

/**
 * __useReportVersionConsultantQuery__
 *
 * To run a query within a React component, call `useReportVersionConsultantQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionConsultantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionConsultantQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionConsultantQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables> & ({ variables: ReportVersionConsultantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables>(ReportVersionConsultantDocument, options);
      }
export function useReportVersionConsultantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables>(ReportVersionConsultantDocument, options);
        }
export function useReportVersionConsultantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables>(ReportVersionConsultantDocument, options);
        }
export type ReportVersionConsultantQueryHookResult = ReturnType<typeof useReportVersionConsultantQuery>;
export type ReportVersionConsultantLazyQueryHookResult = ReturnType<typeof useReportVersionConsultantLazyQuery>;
export type ReportVersionConsultantSuspenseQueryHookResult = ReturnType<typeof useReportVersionConsultantSuspenseQuery>;
export type ReportVersionConsultantQueryResult = Apollo.QueryResult<ReportVersionConsultantQuery, ReportVersionConsultantQueryVariables>;
export const ReportVersionContactDocument = gql`
    query ReportVersionContact($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    contact {
      ...reportContactFields
    }
    report {
      _id
      id
      company {
        _id
        id
      }
    }
  }
}
    ${ReportContactFieldsFragmentDoc}`;

/**
 * __useReportVersionContactQuery__
 *
 * To run a query within a React component, call `useReportVersionContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionContactQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionContactQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionContactQuery, ReportVersionContactQueryVariables> & ({ variables: ReportVersionContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionContactQuery, ReportVersionContactQueryVariables>(ReportVersionContactDocument, options);
      }
export function useReportVersionContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionContactQuery, ReportVersionContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionContactQuery, ReportVersionContactQueryVariables>(ReportVersionContactDocument, options);
        }
export function useReportVersionContactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionContactQuery, ReportVersionContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionContactQuery, ReportVersionContactQueryVariables>(ReportVersionContactDocument, options);
        }
export type ReportVersionContactQueryHookResult = ReturnType<typeof useReportVersionContactQuery>;
export type ReportVersionContactLazyQueryHookResult = ReturnType<typeof useReportVersionContactLazyQuery>;
export type ReportVersionContactSuspenseQueryHookResult = ReturnType<typeof useReportVersionContactSuspenseQuery>;
export type ReportVersionContactQueryResult = Apollo.QueryResult<ReportVersionContactQuery, ReportVersionContactQueryVariables>;
export const ReportVersionEngagementOverviewDocument = gql`
    query ReportVersionEngagementOverview($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    engagementOverview {
      ...reportEngagementOverviewFields
    }
  }
}
    ${ReportEngagementOverviewFieldsFragmentDoc}`;

/**
 * __useReportVersionEngagementOverviewQuery__
 *
 * To run a query within a React component, call `useReportVersionEngagementOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionEngagementOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionEngagementOverviewQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionEngagementOverviewQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables> & ({ variables: ReportVersionEngagementOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables>(ReportVersionEngagementOverviewDocument, options);
      }
export function useReportVersionEngagementOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables>(ReportVersionEngagementOverviewDocument, options);
        }
export function useReportVersionEngagementOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables>(ReportVersionEngagementOverviewDocument, options);
        }
export type ReportVersionEngagementOverviewQueryHookResult = ReturnType<typeof useReportVersionEngagementOverviewQuery>;
export type ReportVersionEngagementOverviewLazyQueryHookResult = ReturnType<typeof useReportVersionEngagementOverviewLazyQuery>;
export type ReportVersionEngagementOverviewSuspenseQueryHookResult = ReturnType<typeof useReportVersionEngagementOverviewSuspenseQuery>;
export type ReportVersionEngagementOverviewQueryResult = Apollo.QueryResult<ReportVersionEngagementOverviewQuery, ReportVersionEngagementOverviewQueryVariables>;
export const ReportVersionScopeDocument = gql`
    query ReportVersionScope($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    permissions
    scope {
      ...reportScopeFields
    }
  }
}
    ${ReportScopeFieldsFragmentDoc}`;

/**
 * __useReportVersionScopeQuery__
 *
 * To run a query within a React component, call `useReportVersionScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionScopeQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionScopeQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionScopeQuery, ReportVersionScopeQueryVariables> & ({ variables: ReportVersionScopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionScopeQuery, ReportVersionScopeQueryVariables>(ReportVersionScopeDocument, options);
      }
export function useReportVersionScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionScopeQuery, ReportVersionScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionScopeQuery, ReportVersionScopeQueryVariables>(ReportVersionScopeDocument, options);
        }
export function useReportVersionScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionScopeQuery, ReportVersionScopeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionScopeQuery, ReportVersionScopeQueryVariables>(ReportVersionScopeDocument, options);
        }
export type ReportVersionScopeQueryHookResult = ReturnType<typeof useReportVersionScopeQuery>;
export type ReportVersionScopeLazyQueryHookResult = ReturnType<typeof useReportVersionScopeLazyQuery>;
export type ReportVersionScopeSuspenseQueryHookResult = ReturnType<typeof useReportVersionScopeSuspenseQuery>;
export type ReportVersionScopeQueryResult = Apollo.QueryResult<ReportVersionScopeQuery, ReportVersionScopeQueryVariables>;
export const ReportVersionAccessInformationDocument = gql`
    query ReportVersionAccessInformation($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    accessInformation {
      ...reportAccessInformationFields
    }
  }
}
    ${ReportAccessInformationFieldsFragmentDoc}`;

/**
 * __useReportVersionAccessInformationQuery__
 *
 * To run a query within a React component, call `useReportVersionAccessInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionAccessInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionAccessInformationQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionAccessInformationQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables> & ({ variables: ReportVersionAccessInformationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables>(ReportVersionAccessInformationDocument, options);
      }
export function useReportVersionAccessInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables>(ReportVersionAccessInformationDocument, options);
        }
export function useReportVersionAccessInformationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables>(ReportVersionAccessInformationDocument, options);
        }
export type ReportVersionAccessInformationQueryHookResult = ReturnType<typeof useReportVersionAccessInformationQuery>;
export type ReportVersionAccessInformationLazyQueryHookResult = ReturnType<typeof useReportVersionAccessInformationLazyQuery>;
export type ReportVersionAccessInformationSuspenseQueryHookResult = ReturnType<typeof useReportVersionAccessInformationSuspenseQuery>;
export type ReportVersionAccessInformationQueryResult = Apollo.QueryResult<ReportVersionAccessInformationQuery, ReportVersionAccessInformationQueryVariables>;
export const ReportVersionTestDetailsDocument = gql`
    query ReportVersionTestDetails($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    engagementOverview {
      ...reportEngagementOverviewFields
    }
    scope {
      ...reportScopeFields
    }
    accessInformation {
      ...reportAccessInformationFields
    }
  }
}
    ${ReportEngagementOverviewFieldsFragmentDoc}
${ReportScopeFieldsFragmentDoc}
${ReportAccessInformationFieldsFragmentDoc}`;

/**
 * __useReportVersionTestDetailsQuery__
 *
 * To run a query within a React component, call `useReportVersionTestDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionTestDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionTestDetailsQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionTestDetailsQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables> & ({ variables: ReportVersionTestDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables>(ReportVersionTestDetailsDocument, options);
      }
export function useReportVersionTestDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables>(ReportVersionTestDetailsDocument, options);
        }
export function useReportVersionTestDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables>(ReportVersionTestDetailsDocument, options);
        }
export type ReportVersionTestDetailsQueryHookResult = ReturnType<typeof useReportVersionTestDetailsQuery>;
export type ReportVersionTestDetailsLazyQueryHookResult = ReturnType<typeof useReportVersionTestDetailsLazyQuery>;
export type ReportVersionTestDetailsSuspenseQueryHookResult = ReturnType<typeof useReportVersionTestDetailsSuspenseQuery>;
export type ReportVersionTestDetailsQueryResult = Apollo.QueryResult<ReportVersionTestDetailsQuery, ReportVersionTestDetailsQueryVariables>;
export const ReportVersionSectionsDocument = gql`
    query ReportVersionSections($versionId: ID!, $first: Int, $after: String) {
  reportVersion(id: $versionId) {
    _id
    id
    sections(first: $first, after: $after, order: {identifier: "asc"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportSectionFields
        }
      }
    }
  }
}
    ${ReportSectionFieldsFragmentDoc}`;

/**
 * __useReportVersionSectionsQuery__
 *
 * To run a query within a React component, call `useReportVersionSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionSectionsQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVersionSectionsQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables> & ({ variables: ReportVersionSectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables>(ReportVersionSectionsDocument, options);
      }
export function useReportVersionSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables>(ReportVersionSectionsDocument, options);
        }
export function useReportVersionSectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables>(ReportVersionSectionsDocument, options);
        }
export type ReportVersionSectionsQueryHookResult = ReturnType<typeof useReportVersionSectionsQuery>;
export type ReportVersionSectionsLazyQueryHookResult = ReturnType<typeof useReportVersionSectionsLazyQuery>;
export type ReportVersionSectionsSuspenseQueryHookResult = ReturnType<typeof useReportVersionSectionsSuspenseQuery>;
export type ReportVersionSectionsQueryResult = Apollo.QueryResult<ReportVersionSectionsQuery, ReportVersionSectionsQueryVariables>;
export const ReportVersionSectionsListDocument = gql`
    query ReportVersionSectionsList($versionId: ID!, $first: Int, $after: String) {
  reportVersion(id: $versionId) {
    _id
    id
    sections(first: $first, after: $after, order: {identifier: "asc"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportSectionListFields
        }
      }
    }
  }
}
    ${ReportSectionListFieldsFragmentDoc}`;

/**
 * __useReportVersionSectionsListQuery__
 *
 * To run a query within a React component, call `useReportVersionSectionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionSectionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionSectionsListQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVersionSectionsListQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables> & ({ variables: ReportVersionSectionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables>(ReportVersionSectionsListDocument, options);
      }
export function useReportVersionSectionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables>(ReportVersionSectionsListDocument, options);
        }
export function useReportVersionSectionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables>(ReportVersionSectionsListDocument, options);
        }
export type ReportVersionSectionsListQueryHookResult = ReturnType<typeof useReportVersionSectionsListQuery>;
export type ReportVersionSectionsListLazyQueryHookResult = ReturnType<typeof useReportVersionSectionsListLazyQuery>;
export type ReportVersionSectionsListSuspenseQueryHookResult = ReturnType<typeof useReportVersionSectionsListSuspenseQuery>;
export type ReportVersionSectionsListQueryResult = Apollo.QueryResult<ReportVersionSectionsListQuery, ReportVersionSectionsListQueryVariables>;
export const ReportVersionVulnerabilitiesDocument = gql`
    query ReportVersionVulnerabilities($versionId: ID!, $first: Int, $after: String) {
  reportVersion(id: $versionId) {
    _id
    id
    vulnerabilities(
      first: $first
      after: $after
      order: {issueNumber: "asc", severity: "desc"}
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __useReportVersionVulnerabilitiesQuery__
 *
 * To run a query within a React component, call `useReportVersionVulnerabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionVulnerabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionVulnerabilitiesQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVersionVulnerabilitiesQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables> & ({ variables: ReportVersionVulnerabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables>(ReportVersionVulnerabilitiesDocument, options);
      }
export function useReportVersionVulnerabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables>(ReportVersionVulnerabilitiesDocument, options);
        }
export function useReportVersionVulnerabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables>(ReportVersionVulnerabilitiesDocument, options);
        }
export type ReportVersionVulnerabilitiesQueryHookResult = ReturnType<typeof useReportVersionVulnerabilitiesQuery>;
export type ReportVersionVulnerabilitiesLazyQueryHookResult = ReturnType<typeof useReportVersionVulnerabilitiesLazyQuery>;
export type ReportVersionVulnerabilitiesSuspenseQueryHookResult = ReturnType<typeof useReportVersionVulnerabilitiesSuspenseQuery>;
export type ReportVersionVulnerabilitiesQueryResult = Apollo.QueryResult<ReportVersionVulnerabilitiesQuery, ReportVersionVulnerabilitiesQueryVariables>;
export const ReportVersionVulnerabilitiesListDocument = gql`
    query ReportVersionVulnerabilitiesList($versionId: ID!, $first: Int, $after: String, $order: ReportVulnerabilityFilter_order, $status: String, $severity: String, $title: String, $issueNumber: Int, $testingTypes: [String], $dateDiscovered: ReportVulnerabilityFilter_dateDiscovered, $cvssScore: String) {
  reportVersion(id: $versionId) {
    _id
    id
    vulnerabilities(
      first: $first
      after: $after
      order: [$order]
      status: $status
      severity: $severity
      title: $title
      issueNumber: $issueNumber
      testingTypes_list: $testingTypes
      dateDiscovered: [$dateDiscovered]
      cvssScore: $cvssScore
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityListFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityListFieldsFragmentDoc}`;

/**
 * __useReportVersionVulnerabilitiesListQuery__
 *
 * To run a query within a React component, call `useReportVersionVulnerabilitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionVulnerabilitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionVulnerabilitiesListQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      status: // value for 'status'
 *      severity: // value for 'severity'
 *      title: // value for 'title'
 *      issueNumber: // value for 'issueNumber'
 *      testingTypes: // value for 'testingTypes'
 *      dateDiscovered: // value for 'dateDiscovered'
 *      cvssScore: // value for 'cvssScore'
 *   },
 * });
 */
export function useReportVersionVulnerabilitiesListQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables> & ({ variables: ReportVersionVulnerabilitiesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables>(ReportVersionVulnerabilitiesListDocument, options);
      }
export function useReportVersionVulnerabilitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables>(ReportVersionVulnerabilitiesListDocument, options);
        }
export function useReportVersionVulnerabilitiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables>(ReportVersionVulnerabilitiesListDocument, options);
        }
export type ReportVersionVulnerabilitiesListQueryHookResult = ReturnType<typeof useReportVersionVulnerabilitiesListQuery>;
export type ReportVersionVulnerabilitiesListLazyQueryHookResult = ReturnType<typeof useReportVersionVulnerabilitiesListLazyQuery>;
export type ReportVersionVulnerabilitiesListSuspenseQueryHookResult = ReturnType<typeof useReportVersionVulnerabilitiesListSuspenseQuery>;
export type ReportVersionVulnerabilitiesListQueryResult = Apollo.QueryResult<ReportVersionVulnerabilitiesListQuery, ReportVersionVulnerabilitiesListQueryVariables>;
export const ReportVersionReadReceiptsListDocument = gql`
    query ReportVersionReadReceiptsList($versionId: ID!, $first: Int, $after: String) {
  reportVersion(id: $versionId) {
    _id
    id
    readReceipts(first: $first, after: $after, order: {createdAt: "desc"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportReadReceiptListFields
        }
      }
    }
  }
}
    ${ReportReadReceiptListFieldsFragmentDoc}`;

/**
 * __useReportVersionReadReceiptsListQuery__
 *
 * To run a query within a React component, call `useReportVersionReadReceiptsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionReadReceiptsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionReadReceiptsListQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVersionReadReceiptsListQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables> & ({ variables: ReportVersionReadReceiptsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables>(ReportVersionReadReceiptsListDocument, options);
      }
export function useReportVersionReadReceiptsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables>(ReportVersionReadReceiptsListDocument, options);
        }
export function useReportVersionReadReceiptsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables>(ReportVersionReadReceiptsListDocument, options);
        }
export type ReportVersionReadReceiptsListQueryHookResult = ReturnType<typeof useReportVersionReadReceiptsListQuery>;
export type ReportVersionReadReceiptsListLazyQueryHookResult = ReturnType<typeof useReportVersionReadReceiptsListLazyQuery>;
export type ReportVersionReadReceiptsListSuspenseQueryHookResult = ReturnType<typeof useReportVersionReadReceiptsListSuspenseQuery>;
export type ReportVersionReadReceiptsListQueryResult = Apollo.QueryResult<ReportVersionReadReceiptsListQuery, ReportVersionReadReceiptsListQueryVariables>;
export const AllReportVersionsListDocument = gql`
    query AllReportVersionsList($first: Int, $after: String, $publishedAt: ReportVersionFilter_publishedAt) {
  reportVersions(first: $first, after: $after, publishedAt: [$publishedAt]) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVersionListFields
      }
    }
  }
}
    ${ReportVersionListFieldsFragmentDoc}`;

/**
 * __useAllReportVersionsListQuery__
 *
 * To run a query within a React component, call `useAllReportVersionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllReportVersionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllReportVersionsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      publishedAt: // value for 'publishedAt'
 *   },
 * });
 */
export function useAllReportVersionsListQuery(baseOptions?: Apollo.QueryHookOptions<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>(AllReportVersionsListDocument, options);
      }
export function useAllReportVersionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>(AllReportVersionsListDocument, options);
        }
export function useAllReportVersionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>(AllReportVersionsListDocument, options);
        }
export type AllReportVersionsListQueryHookResult = ReturnType<typeof useAllReportVersionsListQuery>;
export type AllReportVersionsListLazyQueryHookResult = ReturnType<typeof useAllReportVersionsListLazyQuery>;
export type AllReportVersionsListSuspenseQueryHookResult = ReturnType<typeof useAllReportVersionsListSuspenseQuery>;
export type AllReportVersionsListQueryResult = Apollo.QueryResult<AllReportVersionsListQuery, AllReportVersionsListQueryVariables>;
export const CompanyReportVersionsListDocument = gql`
    query CompanyReportVersionsList($companyId: ID!, $first: Int, $after: String, $publishedAt: ReportVersionFilter_publishedAt) {
  companyReportVersions(
    company: $companyId
    first: $first
    after: $after
    publishedAt: [$publishedAt]
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVersionListFields
      }
    }
  }
}
    ${ReportVersionListFieldsFragmentDoc}`;

/**
 * __useCompanyReportVersionsListQuery__
 *
 * To run a query within a React component, call `useCompanyReportVersionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyReportVersionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyReportVersionsListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      publishedAt: // value for 'publishedAt'
 *   },
 * });
 */
export function useCompanyReportVersionsListQuery(baseOptions: Apollo.QueryHookOptions<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables> & ({ variables: CompanyReportVersionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables>(CompanyReportVersionsListDocument, options);
      }
export function useCompanyReportVersionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables>(CompanyReportVersionsListDocument, options);
        }
export function useCompanyReportVersionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables>(CompanyReportVersionsListDocument, options);
        }
export type CompanyReportVersionsListQueryHookResult = ReturnType<typeof useCompanyReportVersionsListQuery>;
export type CompanyReportVersionsListLazyQueryHookResult = ReturnType<typeof useCompanyReportVersionsListLazyQuery>;
export type CompanyReportVersionsListSuspenseQueryHookResult = ReturnType<typeof useCompanyReportVersionsListSuspenseQuery>;
export type CompanyReportVersionsListQueryResult = Apollo.QueryResult<CompanyReportVersionsListQuery, CompanyReportVersionsListQueryVariables>;
export const ReportVersionDeliverableFilesDocument = gql`
    query ReportVersionDeliverableFiles($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    permissions
    deliverableFiles {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportDeliverableFileFields
        }
      }
    }
  }
}
    ${ReportDeliverableFileFieldsFragmentDoc}`;

/**
 * __useReportVersionDeliverableFilesQuery__
 *
 * To run a query within a React component, call `useReportVersionDeliverableFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionDeliverableFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionDeliverableFilesQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionDeliverableFilesQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables> & ({ variables: ReportVersionDeliverableFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables>(ReportVersionDeliverableFilesDocument, options);
      }
export function useReportVersionDeliverableFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables>(ReportVersionDeliverableFilesDocument, options);
        }
export function useReportVersionDeliverableFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables>(ReportVersionDeliverableFilesDocument, options);
        }
export type ReportVersionDeliverableFilesQueryHookResult = ReturnType<typeof useReportVersionDeliverableFilesQuery>;
export type ReportVersionDeliverableFilesLazyQueryHookResult = ReturnType<typeof useReportVersionDeliverableFilesLazyQuery>;
export type ReportVersionDeliverableFilesSuspenseQueryHookResult = ReturnType<typeof useReportVersionDeliverableFilesSuspenseQuery>;
export type ReportVersionDeliverableFilesQueryResult = Apollo.QueryResult<ReportVersionDeliverableFilesQuery, ReportVersionDeliverableFilesQueryVariables>;
export const ReportVersionTestTypePrerequisitesDocument = gql`
    query ReportVersionTestTypePrerequisites($versionId: ID!) {
  reportVersion(id: $versionId) {
    _id
    id
    status
    permissions
    testTypePrerequisites {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportTestTypePrerequisiteFields
        }
      }
    }
  }
}
    ${ReportTestTypePrerequisiteFieldsFragmentDoc}`;

/**
 * __useReportVersionTestTypePrerequisitesQuery__
 *
 * To run a query within a React component, call `useReportVersionTestTypePrerequisitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionTestTypePrerequisitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionTestTypePrerequisitesQuery({
 *   variables: {
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useReportVersionTestTypePrerequisitesQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables> & ({ variables: ReportVersionTestTypePrerequisitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables>(ReportVersionTestTypePrerequisitesDocument, options);
      }
export function useReportVersionTestTypePrerequisitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables>(ReportVersionTestTypePrerequisitesDocument, options);
        }
export function useReportVersionTestTypePrerequisitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables>(ReportVersionTestTypePrerequisitesDocument, options);
        }
export type ReportVersionTestTypePrerequisitesQueryHookResult = ReturnType<typeof useReportVersionTestTypePrerequisitesQuery>;
export type ReportVersionTestTypePrerequisitesLazyQueryHookResult = ReturnType<typeof useReportVersionTestTypePrerequisitesLazyQuery>;
export type ReportVersionTestTypePrerequisitesSuspenseQueryHookResult = ReturnType<typeof useReportVersionTestTypePrerequisitesSuspenseQuery>;
export type ReportVersionTestTypePrerequisitesQueryResult = Apollo.QueryResult<ReportVersionTestTypePrerequisitesQuery, ReportVersionTestTypePrerequisitesQueryVariables>;
export const ReportVulnerabilityActionDocument = gql`
    query ReportVulnerabilityAction($actionId: ID!) {
  reportVulnerabilityAction(id: $actionId) {
    ...reportVulnerabilityActionFields
  }
}
    ${ReportVulnerabilityActionFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityActionQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityActionQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useReportVulnerabilityActionQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables> & ({ variables: ReportVulnerabilityActionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables>(ReportVulnerabilityActionDocument, options);
      }
export function useReportVulnerabilityActionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables>(ReportVulnerabilityActionDocument, options);
        }
export function useReportVulnerabilityActionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables>(ReportVulnerabilityActionDocument, options);
        }
export type ReportVulnerabilityActionQueryHookResult = ReturnType<typeof useReportVulnerabilityActionQuery>;
export type ReportVulnerabilityActionLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityActionLazyQuery>;
export type ReportVulnerabilityActionSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityActionSuspenseQuery>;
export type ReportVulnerabilityActionQueryResult = Apollo.QueryResult<ReportVulnerabilityActionQuery, ReportVulnerabilityActionQueryVariables>;
export const ReportVulnerabilityFileDocument = gql`
    query ReportVulnerabilityFile($fileId: ID!) {
  reportVulnerabilityFile(id: $fileId) {
    ...reportVulnerabilityFileFields
  }
}
    ${ReportVulnerabilityFileFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityFileQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityFileQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useReportVulnerabilityFileQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables> & ({ variables: ReportVulnerabilityFileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables>(ReportVulnerabilityFileDocument, options);
      }
export function useReportVulnerabilityFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables>(ReportVulnerabilityFileDocument, options);
        }
export function useReportVulnerabilityFileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables>(ReportVulnerabilityFileDocument, options);
        }
export type ReportVulnerabilityFileQueryHookResult = ReturnType<typeof useReportVulnerabilityFileQuery>;
export type ReportVulnerabilityFileLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityFileLazyQuery>;
export type ReportVulnerabilityFileSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityFileSuspenseQuery>;
export type ReportVulnerabilityFileQueryResult = Apollo.QueryResult<ReportVulnerabilityFileQuery, ReportVulnerabilityFileQueryVariables>;
export const ReportVulnerabilityDocument = gql`
    query ReportVulnerability($vulnerabilityId: ID!) {
  reportVulnerability(id: $vulnerabilityId) {
    ...reportVulnerabilityFields
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *   },
 * });
 */
export function useReportVulnerabilityQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables> & ({ variables: ReportVulnerabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables>(ReportVulnerabilityDocument, options);
      }
export function useReportVulnerabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables>(ReportVulnerabilityDocument, options);
        }
export function useReportVulnerabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables>(ReportVulnerabilityDocument, options);
        }
export type ReportVulnerabilityQueryHookResult = ReturnType<typeof useReportVulnerabilityQuery>;
export type ReportVulnerabilityLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityLazyQuery>;
export type ReportVulnerabilitySuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilitySuspenseQuery>;
export type ReportVulnerabilityQueryResult = Apollo.QueryResult<ReportVulnerabilityQuery, ReportVulnerabilityQueryVariables>;
export const PublishedReportVulnerabilitiesDocument = gql`
    query PublishedReportVulnerabilities($first: Int, $after: String, $status: String, $severity: String, $title: String, $issueNumber: Int, $testingTypes: [String], $dateDiscovered: ReportVulnerabilityFilter_dateDiscovered, $cvssScore: String) {
  publishedReportVulnerabilities(
    first: $first
    after: $after
    status: $status
    severity: $severity
    title: $title
    issueNumber: $issueNumber
    testingTypes_list: $testingTypes
    dateDiscovered: [$dateDiscovered]
    cvssScore: $cvssScore
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVulnerabilityFields
      }
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __usePublishedReportVulnerabilitiesQuery__
 *
 * To run a query within a React component, call `usePublishedReportVulnerabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedReportVulnerabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedReportVulnerabilitiesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      severity: // value for 'severity'
 *      title: // value for 'title'
 *      issueNumber: // value for 'issueNumber'
 *      testingTypes: // value for 'testingTypes'
 *      dateDiscovered: // value for 'dateDiscovered'
 *      cvssScore: // value for 'cvssScore'
 *   },
 * });
 */
export function usePublishedReportVulnerabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>(PublishedReportVulnerabilitiesDocument, options);
      }
export function usePublishedReportVulnerabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>(PublishedReportVulnerabilitiesDocument, options);
        }
export function usePublishedReportVulnerabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>(PublishedReportVulnerabilitiesDocument, options);
        }
export type PublishedReportVulnerabilitiesQueryHookResult = ReturnType<typeof usePublishedReportVulnerabilitiesQuery>;
export type PublishedReportVulnerabilitiesLazyQueryHookResult = ReturnType<typeof usePublishedReportVulnerabilitiesLazyQuery>;
export type PublishedReportVulnerabilitiesSuspenseQueryHookResult = ReturnType<typeof usePublishedReportVulnerabilitiesSuspenseQuery>;
export type PublishedReportVulnerabilitiesQueryResult = Apollo.QueryResult<PublishedReportVulnerabilitiesQuery, PublishedReportVulnerabilitiesQueryVariables>;
export const PublishedReportVulnerabilitiesListDocument = gql`
    query PublishedReportVulnerabilitiesList($first: Int, $after: String, $order: ReportVulnerabilityFilter_order, $status: String, $severity: String, $title: String, $issueNumber: Int, $testingTypes: [String], $dateDiscovered: ReportVulnerabilityFilter_dateDiscovered, $cvssScore: String) {
  publishedReportVulnerabilities(
    first: $first
    after: $after
    order: [$order]
    status: $status
    severity: $severity
    title: $title
    issueNumber: $issueNumber
    testingTypes_list: $testingTypes
    dateDiscovered: [$dateDiscovered]
    cvssScore: $cvssScore
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportVulnerabilityFields
      }
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __usePublishedReportVulnerabilitiesListQuery__
 *
 * To run a query within a React component, call `usePublishedReportVulnerabilitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublishedReportVulnerabilitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublishedReportVulnerabilitiesListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *      status: // value for 'status'
 *      severity: // value for 'severity'
 *      title: // value for 'title'
 *      issueNumber: // value for 'issueNumber'
 *      testingTypes: // value for 'testingTypes'
 *      dateDiscovered: // value for 'dateDiscovered'
 *      cvssScore: // value for 'cvssScore'
 *   },
 * });
 */
export function usePublishedReportVulnerabilitiesListQuery(baseOptions?: Apollo.QueryHookOptions<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>(PublishedReportVulnerabilitiesListDocument, options);
      }
export function usePublishedReportVulnerabilitiesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>(PublishedReportVulnerabilitiesListDocument, options);
        }
export function usePublishedReportVulnerabilitiesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>(PublishedReportVulnerabilitiesListDocument, options);
        }
export type PublishedReportVulnerabilitiesListQueryHookResult = ReturnType<typeof usePublishedReportVulnerabilitiesListQuery>;
export type PublishedReportVulnerabilitiesListLazyQueryHookResult = ReturnType<typeof usePublishedReportVulnerabilitiesListLazyQuery>;
export type PublishedReportVulnerabilitiesListSuspenseQueryHookResult = ReturnType<typeof usePublishedReportVulnerabilitiesListSuspenseQuery>;
export type PublishedReportVulnerabilitiesListQueryResult = Apollo.QueryResult<PublishedReportVulnerabilitiesListQuery, PublishedReportVulnerabilitiesListQueryVariables>;
export const ReportVulnerabilityActionsListDocument = gql`
    query ReportVulnerabilityActionsList($vulnerabilityId: ID!, $first: Int, $after: String, $order: ReportVulnerabilityActionFilter_order) {
  reportVulnerability(id: $vulnerabilityId) {
    _id
    id
    permissions
    actions(first: $first, after: $after, order: [$order]) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityActionListFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityActionListFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityActionsListQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityActionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityActionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityActionsListQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportVulnerabilityActionsListQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables> & ({ variables: ReportVulnerabilityActionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables>(ReportVulnerabilityActionsListDocument, options);
      }
export function useReportVulnerabilityActionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables>(ReportVulnerabilityActionsListDocument, options);
        }
export function useReportVulnerabilityActionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables>(ReportVulnerabilityActionsListDocument, options);
        }
export type ReportVulnerabilityActionsListQueryHookResult = ReturnType<typeof useReportVulnerabilityActionsListQuery>;
export type ReportVulnerabilityActionsListLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityActionsListLazyQuery>;
export type ReportVulnerabilityActionsListSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityActionsListSuspenseQuery>;
export type ReportVulnerabilityActionsListQueryResult = Apollo.QueryResult<ReportVulnerabilityActionsListQuery, ReportVulnerabilityActionsListQueryVariables>;
export const ReportVulnerabilityActionsDocument = gql`
    query ReportVulnerabilityActions($vulnerabilityId: ID!, $first: Int, $after: String, $order: ReportVulnerabilityActionFilter_order) {
  reportVulnerability(id: $vulnerabilityId) {
    _id
    id
    permissions
    actions(first: $first, after: $after, order: [$order]) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityActionFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityActionFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityActionsQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityActionsQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportVulnerabilityActionsQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables> & ({ variables: ReportVulnerabilityActionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables>(ReportVulnerabilityActionsDocument, options);
      }
export function useReportVulnerabilityActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables>(ReportVulnerabilityActionsDocument, options);
        }
export function useReportVulnerabilityActionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables>(ReportVulnerabilityActionsDocument, options);
        }
export type ReportVulnerabilityActionsQueryHookResult = ReturnType<typeof useReportVulnerabilityActionsQuery>;
export type ReportVulnerabilityActionsLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityActionsLazyQuery>;
export type ReportVulnerabilityActionsSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityActionsSuspenseQuery>;
export type ReportVulnerabilityActionsQueryResult = Apollo.QueryResult<ReportVulnerabilityActionsQuery, ReportVulnerabilityActionsQueryVariables>;
export const ReportVulnerabilityRetestRequestsDocument = gql`
    query ReportVulnerabilityRetestRequests($vulnerabilityId: ID!, $first: Int, $after: String, $order: ReportVulnerabilityRetestRequestFilter_order) {
  reportVulnerability(id: $vulnerabilityId) {
    _id
    id
    permissions
    retestRequests(first: $first, after: $after, order: [$order]) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityRetestRequestListFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityRetestRequestListFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityRetestRequestsQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityRetestRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityRetestRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityRetestRequestsQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useReportVulnerabilityRetestRequestsQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables> & ({ variables: ReportVulnerabilityRetestRequestsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables>(ReportVulnerabilityRetestRequestsDocument, options);
      }
export function useReportVulnerabilityRetestRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables>(ReportVulnerabilityRetestRequestsDocument, options);
        }
export function useReportVulnerabilityRetestRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables>(ReportVulnerabilityRetestRequestsDocument, options);
        }
export type ReportVulnerabilityRetestRequestsQueryHookResult = ReturnType<typeof useReportVulnerabilityRetestRequestsQuery>;
export type ReportVulnerabilityRetestRequestsLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityRetestRequestsLazyQuery>;
export type ReportVulnerabilityRetestRequestsSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityRetestRequestsSuspenseQuery>;
export type ReportVulnerabilityRetestRequestsQueryResult = Apollo.QueryResult<ReportVulnerabilityRetestRequestsQuery, ReportVulnerabilityRetestRequestsQueryVariables>;
export const ReportVulnerabilityCommentsDocument = gql`
    query ReportVulnerabilityComments($vulnerabilityId: ID!, $first: Int, $after: String) {
  reportVulnerability(id: $vulnerabilityId) {
    _id
    id
    permissions
    comments(first: $first, after: $after, order: {createdAt: "DESC"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityCommentFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityCommentFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityCommentsQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityCommentsQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVulnerabilityCommentsQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables> & ({ variables: ReportVulnerabilityCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables>(ReportVulnerabilityCommentsDocument, options);
      }
export function useReportVulnerabilityCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables>(ReportVulnerabilityCommentsDocument, options);
        }
export function useReportVulnerabilityCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables>(ReportVulnerabilityCommentsDocument, options);
        }
export type ReportVulnerabilityCommentsQueryHookResult = ReturnType<typeof useReportVulnerabilityCommentsQuery>;
export type ReportVulnerabilityCommentsLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityCommentsLazyQuery>;
export type ReportVulnerabilityCommentsSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityCommentsSuspenseQuery>;
export type ReportVulnerabilityCommentsQueryResult = Apollo.QueryResult<ReportVulnerabilityCommentsQuery, ReportVulnerabilityCommentsQueryVariables>;
export const ReportVulnerabilityClientNotificationsDocument = gql`
    query ReportVulnerabilityClientNotifications($vulnerabilityId: ID!, $first: Int, $after: String) {
  reportVulnerability(id: $vulnerabilityId) {
    _id
    id
    permissions
    clientNotifications(first: $first, after: $after, order: {createdAt: "DESC"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVulnerabilityClientNotificationListFields
        }
      }
    }
  }
}
    ${ReportVulnerabilityClientNotificationListFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilityClientNotificationsQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilityClientNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilityClientNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilityClientNotificationsQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVulnerabilityClientNotificationsQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables> & ({ variables: ReportVulnerabilityClientNotificationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables>(ReportVulnerabilityClientNotificationsDocument, options);
      }
export function useReportVulnerabilityClientNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables>(ReportVulnerabilityClientNotificationsDocument, options);
        }
export function useReportVulnerabilityClientNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables>(ReportVulnerabilityClientNotificationsDocument, options);
        }
export type ReportVulnerabilityClientNotificationsQueryHookResult = ReturnType<typeof useReportVulnerabilityClientNotificationsQuery>;
export type ReportVulnerabilityClientNotificationsLazyQueryHookResult = ReturnType<typeof useReportVulnerabilityClientNotificationsLazyQuery>;
export type ReportVulnerabilityClientNotificationsSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilityClientNotificationsSuspenseQuery>;
export type ReportVulnerabilityClientNotificationsQueryResult = Apollo.QueryResult<ReportVulnerabilityClientNotificationsQuery, ReportVulnerabilityClientNotificationsQueryVariables>;
export const ReportsListDocument = gql`
    query ReportsList($first: Int, $after: String, $title: String, $order: ReportFilter_order, $status: String) {
  reports(
    first: $first
    after: $after
    order: [$order]
    title: $title
    status: $status
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...reportListFields
        latestVersion {
          _id
          id
        }
      }
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;

/**
 * __useReportsListQuery__
 *
 * To run a query within a React component, call `useReportsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      title: // value for 'title'
 *      order: // value for 'order'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useReportsListQuery(baseOptions?: Apollo.QueryHookOptions<ReportsListQuery, ReportsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportsListQuery, ReportsListQueryVariables>(ReportsListDocument, options);
      }
export function useReportsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportsListQuery, ReportsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportsListQuery, ReportsListQueryVariables>(ReportsListDocument, options);
        }
export function useReportsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportsListQuery, ReportsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportsListQuery, ReportsListQueryVariables>(ReportsListDocument, options);
        }
export type ReportsListQueryHookResult = ReturnType<typeof useReportsListQuery>;
export type ReportsListLazyQueryHookResult = ReturnType<typeof useReportsListLazyQuery>;
export type ReportsListSuspenseQueryHookResult = ReturnType<typeof useReportsListSuspenseQuery>;
export type ReportsListQueryResult = Apollo.QueryResult<ReportsListQuery, ReportsListQueryVariables>;
export const ReportOverviewDocument = gql`
    query ReportOverview($reportId: ID!) {
  report(id: $reportId) {
    ...reportListFields
    latestVersion {
      _id
      id
      status
      versionName
      versionNumber
      permissions
      engagementOverview {
        _id
        id
        permissions
      }
      scope {
        _id
        id
        permissions
      }
      accessInformation {
        _id
        id
        permissions
      }
    }
  }
}
    ${ReportListFieldsFragmentDoc}`;

/**
 * __useReportOverviewQuery__
 *
 * To run a query within a React component, call `useReportOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportOverviewQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportOverviewQuery(baseOptions: Apollo.QueryHookOptions<ReportOverviewQuery, ReportOverviewQueryVariables> & ({ variables: ReportOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportOverviewQuery, ReportOverviewQueryVariables>(ReportOverviewDocument, options);
      }
export function useReportOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportOverviewQuery, ReportOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportOverviewQuery, ReportOverviewQueryVariables>(ReportOverviewDocument, options);
        }
export function useReportOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportOverviewQuery, ReportOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportOverviewQuery, ReportOverviewQueryVariables>(ReportOverviewDocument, options);
        }
export type ReportOverviewQueryHookResult = ReturnType<typeof useReportOverviewQuery>;
export type ReportOverviewLazyQueryHookResult = ReturnType<typeof useReportOverviewLazyQuery>;
export type ReportOverviewSuspenseQueryHookResult = ReturnType<typeof useReportOverviewSuspenseQuery>;
export type ReportOverviewQueryResult = Apollo.QueryResult<ReportOverviewQuery, ReportOverviewQueryVariables>;
export const ReportVersionsListDocument = gql`
    query ReportVersionsList($reportId: ID!, $first: Int, $after: String) {
  report(id: $reportId) {
    _id
    id
    versions(first: $first, after: $after, order: {id: "desc"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportVersionListFields
        }
      }
    }
  }
}
    ${ReportVersionListFieldsFragmentDoc}`;

/**
 * __useReportVersionsListQuery__
 *
 * To run a query within a React component, call `useReportVersionsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVersionsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVersionsListQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVersionsListQuery(baseOptions: Apollo.QueryHookOptions<ReportVersionsListQuery, ReportVersionsListQueryVariables> & ({ variables: ReportVersionsListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVersionsListQuery, ReportVersionsListQueryVariables>(ReportVersionsListDocument, options);
      }
export function useReportVersionsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVersionsListQuery, ReportVersionsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVersionsListQuery, ReportVersionsListQueryVariables>(ReportVersionsListDocument, options);
        }
export function useReportVersionsListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVersionsListQuery, ReportVersionsListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVersionsListQuery, ReportVersionsListQueryVariables>(ReportVersionsListDocument, options);
        }
export type ReportVersionsListQueryHookResult = ReturnType<typeof useReportVersionsListQuery>;
export type ReportVersionsListLazyQueryHookResult = ReturnType<typeof useReportVersionsListLazyQuery>;
export type ReportVersionsListSuspenseQueryHookResult = ReturnType<typeof useReportVersionsListSuspenseQuery>;
export type ReportVersionsListQueryResult = Apollo.QueryResult<ReportVersionsListQuery, ReportVersionsListQueryVariables>;
export const ReportInvitesListDocument = gql`
    query ReportInvitesList($reportId: ID!, $first: Int, $after: String) {
  report(id: $reportId) {
    _id
    id
    invites(first: $first, after: $after, order: {id: "desc"}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportInviteListFields
        }
      }
    }
  }
}
    ${ReportInviteListFieldsFragmentDoc}`;

/**
 * __useReportInvitesListQuery__
 *
 * To run a query within a React component, call `useReportInvitesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportInvitesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportInvitesListQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportInvitesListQuery(baseOptions: Apollo.QueryHookOptions<ReportInvitesListQuery, ReportInvitesListQueryVariables> & ({ variables: ReportInvitesListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportInvitesListQuery, ReportInvitesListQueryVariables>(ReportInvitesListDocument, options);
      }
export function useReportInvitesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportInvitesListQuery, ReportInvitesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportInvitesListQuery, ReportInvitesListQueryVariables>(ReportInvitesListDocument, options);
        }
export function useReportInvitesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportInvitesListQuery, ReportInvitesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportInvitesListQuery, ReportInvitesListQueryVariables>(ReportInvitesListDocument, options);
        }
export type ReportInvitesListQueryHookResult = ReturnType<typeof useReportInvitesListQuery>;
export type ReportInvitesListLazyQueryHookResult = ReturnType<typeof useReportInvitesListLazyQuery>;
export type ReportInvitesListSuspenseQueryHookResult = ReturnType<typeof useReportInvitesListSuspenseQuery>;
export type ReportInvitesListQueryResult = Apollo.QueryResult<ReportInvitesListQuery, ReportInvitesListQueryVariables>;
export const ReportVulnerabilitiesDocument = gql`
    query ReportVulnerabilities($reportId: ID!, $first: Int, $after: String) {
  report(id: $reportId) {
    _id
    id
    latestVersion {
      _id
      id
      vulnerabilities(first: $first, after: $after) {
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            ...reportVulnerabilityFields
          }
        }
      }
    }
  }
}
    ${ReportVulnerabilityFieldsFragmentDoc}`;

/**
 * __useReportVulnerabilitiesQuery__
 *
 * To run a query within a React component, call `useReportVulnerabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportVulnerabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportVulnerabilitiesQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportVulnerabilitiesQuery(baseOptions: Apollo.QueryHookOptions<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables> & ({ variables: ReportVulnerabilitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables>(ReportVulnerabilitiesDocument, options);
      }
export function useReportVulnerabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables>(ReportVulnerabilitiesDocument, options);
        }
export function useReportVulnerabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables>(ReportVulnerabilitiesDocument, options);
        }
export type ReportVulnerabilitiesQueryHookResult = ReturnType<typeof useReportVulnerabilitiesQuery>;
export type ReportVulnerabilitiesLazyQueryHookResult = ReturnType<typeof useReportVulnerabilitiesLazyQuery>;
export type ReportVulnerabilitiesSuspenseQueryHookResult = ReturnType<typeof useReportVulnerabilitiesSuspenseQuery>;
export type ReportVulnerabilitiesQueryResult = Apollo.QueryResult<ReportVulnerabilitiesQuery, ReportVulnerabilitiesQueryVariables>;
export const ReportUsersDocument = gql`
    query ReportUsers($reportId: ID!, $first: Int, $after: String) {
  report(id: $reportId) {
    _id
    id
    company {
      _id
      id
    }
    viewers(first: $first, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...reportUserListFields
        }
      }
    }
  }
}
    ${ReportUserListFieldsFragmentDoc}`;

/**
 * __useReportUsersQuery__
 *
 * To run a query within a React component, call `useReportUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportUsersQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useReportUsersQuery(baseOptions: Apollo.QueryHookOptions<ReportUsersQuery, ReportUsersQueryVariables> & ({ variables: ReportUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportUsersQuery, ReportUsersQueryVariables>(ReportUsersDocument, options);
      }
export function useReportUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportUsersQuery, ReportUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportUsersQuery, ReportUsersQueryVariables>(ReportUsersDocument, options);
        }
export function useReportUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportUsersQuery, ReportUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportUsersQuery, ReportUsersQueryVariables>(ReportUsersDocument, options);
        }
export type ReportUsersQueryHookResult = ReturnType<typeof useReportUsersQuery>;
export type ReportUsersLazyQueryHookResult = ReturnType<typeof useReportUsersLazyQuery>;
export type ReportUsersSuspenseQueryHookResult = ReturnType<typeof useReportUsersSuspenseQuery>;
export type ReportUsersQueryResult = Apollo.QueryResult<ReportUsersQuery, ReportUsersQueryVariables>;
export const TestTypePrerequisiteListDocument = gql`
    query TestTypePrerequisiteList($first: Int, $after: String, $testType: String, $order: TestTypePrerequisiteFilter_order) {
  testTypePrerequisites(
    first: $first
    after: $after
    testType: $testType
    order: [$order]
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...testTypePrerequisiteFields
      }
    }
  }
}
    ${TestTypePrerequisiteFieldsFragmentDoc}`;

/**
 * __useTestTypePrerequisiteListQuery__
 *
 * To run a query within a React component, call `useTestTypePrerequisiteListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestTypePrerequisiteListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestTypePrerequisiteListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      testType: // value for 'testType'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useTestTypePrerequisiteListQuery(baseOptions?: Apollo.QueryHookOptions<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>(TestTypePrerequisiteListDocument, options);
      }
export function useTestTypePrerequisiteListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>(TestTypePrerequisiteListDocument, options);
        }
export function useTestTypePrerequisiteListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>(TestTypePrerequisiteListDocument, options);
        }
export type TestTypePrerequisiteListQueryHookResult = ReturnType<typeof useTestTypePrerequisiteListQuery>;
export type TestTypePrerequisiteListLazyQueryHookResult = ReturnType<typeof useTestTypePrerequisiteListLazyQuery>;
export type TestTypePrerequisiteListSuspenseQueryHookResult = ReturnType<typeof useTestTypePrerequisiteListSuspenseQuery>;
export type TestTypePrerequisiteListQueryResult = Apollo.QueryResult<TestTypePrerequisiteListQuery, TestTypePrerequisiteListQueryVariables>;
export const TestTypePrerequisiteDocument = gql`
    query TestTypePrerequisite($testTypePrerequisiteId: ID!) {
  testTypePrerequisite(id: $testTypePrerequisiteId) {
    ...testTypePrerequisiteFields
  }
}
    ${TestTypePrerequisiteFieldsFragmentDoc}`;

/**
 * __useTestTypePrerequisiteQuery__
 *
 * To run a query within a React component, call `useTestTypePrerequisiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestTypePrerequisiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestTypePrerequisiteQuery({
 *   variables: {
 *      testTypePrerequisiteId: // value for 'testTypePrerequisiteId'
 *   },
 * });
 */
export function useTestTypePrerequisiteQuery(baseOptions: Apollo.QueryHookOptions<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables> & ({ variables: TestTypePrerequisiteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables>(TestTypePrerequisiteDocument, options);
      }
export function useTestTypePrerequisiteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables>(TestTypePrerequisiteDocument, options);
        }
export function useTestTypePrerequisiteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables>(TestTypePrerequisiteDocument, options);
        }
export type TestTypePrerequisiteQueryHookResult = ReturnType<typeof useTestTypePrerequisiteQuery>;
export type TestTypePrerequisiteLazyQueryHookResult = ReturnType<typeof useTestTypePrerequisiteLazyQuery>;
export type TestTypePrerequisiteSuspenseQueryHookResult = ReturnType<typeof useTestTypePrerequisiteSuspenseQuery>;
export type TestTypePrerequisiteQueryResult = Apollo.QueryResult<TestTypePrerequisiteQuery, TestTypePrerequisiteQueryVariables>;
export const TestingTypeDocument = gql`
    query TestingType($testingTypeId: ID!) {
  testingType(id: $testingTypeId) {
    ...testingTypeFields
  }
}
    ${TestingTypeFieldsFragmentDoc}`;

/**
 * __useTestingTypeQuery__
 *
 * To run a query within a React component, call `useTestingTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestingTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestingTypeQuery({
 *   variables: {
 *      testingTypeId: // value for 'testingTypeId'
 *   },
 * });
 */
export function useTestingTypeQuery(baseOptions: Apollo.QueryHookOptions<TestingTypeQuery, TestingTypeQueryVariables> & ({ variables: TestingTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestingTypeQuery, TestingTypeQueryVariables>(TestingTypeDocument, options);
      }
export function useTestingTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestingTypeQuery, TestingTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestingTypeQuery, TestingTypeQueryVariables>(TestingTypeDocument, options);
        }
export function useTestingTypeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestingTypeQuery, TestingTypeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestingTypeQuery, TestingTypeQueryVariables>(TestingTypeDocument, options);
        }
export type TestingTypeQueryHookResult = ReturnType<typeof useTestingTypeQuery>;
export type TestingTypeLazyQueryHookResult = ReturnType<typeof useTestingTypeLazyQuery>;
export type TestingTypeSuspenseQueryHookResult = ReturnType<typeof useTestingTypeSuspenseQuery>;
export type TestingTypeQueryResult = Apollo.QueryResult<TestingTypeQuery, TestingTypeQueryVariables>;
export const TestingTypeListDocument = gql`
    query TestingTypeList($first: Int, $after: String) {
  testingTypes(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...testingTypeListFields
      }
    }
  }
}
    ${TestingTypeListFieldsFragmentDoc}`;

/**
 * __useTestingTypeListQuery__
 *
 * To run a query within a React component, call `useTestingTypeListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestingTypeListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestingTypeListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTestingTypeListQuery(baseOptions?: Apollo.QueryHookOptions<TestingTypeListQuery, TestingTypeListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestingTypeListQuery, TestingTypeListQueryVariables>(TestingTypeListDocument, options);
      }
export function useTestingTypeListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestingTypeListQuery, TestingTypeListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestingTypeListQuery, TestingTypeListQueryVariables>(TestingTypeListDocument, options);
        }
export function useTestingTypeListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestingTypeListQuery, TestingTypeListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestingTypeListQuery, TestingTypeListQueryVariables>(TestingTypeListDocument, options);
        }
export type TestingTypeListQueryHookResult = ReturnType<typeof useTestingTypeListQuery>;
export type TestingTypeListLazyQueryHookResult = ReturnType<typeof useTestingTypeListLazyQuery>;
export type TestingTypeListSuspenseQueryHookResult = ReturnType<typeof useTestingTypeListSuspenseQuery>;
export type TestingTypeListQueryResult = Apollo.QueryResult<TestingTypeListQuery, TestingTypeListQueryVariables>;
export const TestingTypesDocument = gql`
    query TestingTypes($first: Int, $after: String) {
  testingTypes(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...testingTypeFields
      }
    }
  }
}
    ${TestingTypeFieldsFragmentDoc}`;

/**
 * __useTestingTypesQuery__
 *
 * To run a query within a React component, call `useTestingTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestingTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestingTypesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useTestingTypesQuery(baseOptions?: Apollo.QueryHookOptions<TestingTypesQuery, TestingTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestingTypesQuery, TestingTypesQueryVariables>(TestingTypesDocument, options);
      }
export function useTestingTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestingTypesQuery, TestingTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestingTypesQuery, TestingTypesQueryVariables>(TestingTypesDocument, options);
        }
export function useTestingTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestingTypesQuery, TestingTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestingTypesQuery, TestingTypesQueryVariables>(TestingTypesDocument, options);
        }
export type TestingTypesQueryHookResult = ReturnType<typeof useTestingTypesQuery>;
export type TestingTypesLazyQueryHookResult = ReturnType<typeof useTestingTypesLazyQuery>;
export type TestingTypesSuspenseQueryHookResult = ReturnType<typeof useTestingTypesSuspenseQuery>;
export type TestingTypesQueryResult = Apollo.QueryResult<TestingTypesQuery, TestingTypesQueryVariables>;
export const GetUserNotificationsDocument = gql`
    query GetUserNotifications($first: Int, $after: String) {
  userNotifications(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...userNotificationFields
      }
    }
  }
}
    ${UserNotificationFieldsFragmentDoc}`;

/**
 * __useGetUserNotificationsQuery__
 *
 * To run a query within a React component, call `useGetUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
      }
export function useGetUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export function useGetUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>(GetUserNotificationsDocument, options);
        }
export type GetUserNotificationsQueryHookResult = ReturnType<typeof useGetUserNotificationsQuery>;
export type GetUserNotificationsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationsLazyQuery>;
export type GetUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationsSuspenseQuery>;
export type GetUserNotificationsQueryResult = Apollo.QueryResult<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const UserListDocument = gql`
    query UserList($first: Int, $after: String, $firstName: String, $lastName: String, $email: String, $order: UserFilter_order) {
  users(
    first: $first
    after: $after
    firstName: $firstName
    lastName: $lastName
    email: $email
    order: [$order]
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...userListFields
      }
    }
  }
}
    ${UserListFieldsFragmentDoc}`;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useUserListQuery(baseOptions?: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export function useUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListSuspenseQueryHookResult = ReturnType<typeof useUserListSuspenseQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const ConsultantUserListDocument = gql`
    query ConsultantUserList($first: Int, $after: String, $firstName: String, $lastName: String, $email: String, $order: UserFilter_order) {
  consultantUsers(
    first: $first
    after: $after
    firstName: $firstName
    lastName: $lastName
    email: $email
    order: [$order]
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...userListFields
      }
    }
  }
}
    ${UserListFieldsFragmentDoc}`;

/**
 * __useConsultantUserListQuery__
 *
 * To run a query within a React component, call `useConsultantUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultantUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultantUserListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useConsultantUserListQuery(baseOptions?: Apollo.QueryHookOptions<ConsultantUserListQuery, ConsultantUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultantUserListQuery, ConsultantUserListQueryVariables>(ConsultantUserListDocument, options);
      }
export function useConsultantUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultantUserListQuery, ConsultantUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultantUserListQuery, ConsultantUserListQueryVariables>(ConsultantUserListDocument, options);
        }
export function useConsultantUserListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConsultantUserListQuery, ConsultantUserListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConsultantUserListQuery, ConsultantUserListQueryVariables>(ConsultantUserListDocument, options);
        }
export type ConsultantUserListQueryHookResult = ReturnType<typeof useConsultantUserListQuery>;
export type ConsultantUserListLazyQueryHookResult = ReturnType<typeof useConsultantUserListLazyQuery>;
export type ConsultantUserListSuspenseQueryHookResult = ReturnType<typeof useConsultantUserListSuspenseQuery>;
export type ConsultantUserListQueryResult = Apollo.QueryResult<ConsultantUserListQuery, ConsultantUserListQueryVariables>;
export const UserDocument = gql`
    query User($userId: ID!) {
  user(id: $userId) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery, UserQueryVariables> & ({ variables: UserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserCompanyRolesDocument = gql`
    query UserCompanyRoles($userId: ID!, $companyId: String!) {
  user(id: $userId) {
    companies(company: $companyId) {
      edges {
        node {
          _id
          id
          role
        }
      }
    }
  }
}
    `;

/**
 * __useUserCompanyRolesQuery__
 *
 * To run a query within a React component, call `useUserCompanyRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompanyRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompanyRolesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useUserCompanyRolesQuery(baseOptions: Apollo.QueryHookOptions<UserCompanyRolesQuery, UserCompanyRolesQueryVariables> & ({ variables: UserCompanyRolesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>(UserCompanyRolesDocument, options);
      }
export function useUserCompanyRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>(UserCompanyRolesDocument, options);
        }
export function useUserCompanyRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>(UserCompanyRolesDocument, options);
        }
export type UserCompanyRolesQueryHookResult = ReturnType<typeof useUserCompanyRolesQuery>;
export type UserCompanyRolesLazyQueryHookResult = ReturnType<typeof useUserCompanyRolesLazyQuery>;
export type UserCompanyRolesSuspenseQueryHookResult = ReturnType<typeof useUserCompanyRolesSuspenseQuery>;
export type UserCompanyRolesQueryResult = Apollo.QueryResult<UserCompanyRolesQuery, UserCompanyRolesQueryVariables>;
export const VulnerabilityListDocument = gql`
    query VulnerabilityList($first: Int, $after: String, $identifier: String, $title: String, $testingTypes: [String], $order: VulnerabilityFilter_order) {
  vulnerabilities(
    first: $first
    after: $after
    identifier: $identifier
    title: $title
    testingTypes_list: $testingTypes
    order: [$order]
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...vulnerabilityListFields
      }
    }
  }
}
    ${VulnerabilityListFieldsFragmentDoc}`;

/**
 * __useVulnerabilityListQuery__
 *
 * To run a query within a React component, call `useVulnerabilityListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVulnerabilityListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVulnerabilityListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      identifier: // value for 'identifier'
 *      title: // value for 'title'
 *      testingTypes: // value for 'testingTypes'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useVulnerabilityListQuery(baseOptions?: Apollo.QueryHookOptions<VulnerabilityListQuery, VulnerabilityListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VulnerabilityListQuery, VulnerabilityListQueryVariables>(VulnerabilityListDocument, options);
      }
export function useVulnerabilityListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VulnerabilityListQuery, VulnerabilityListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VulnerabilityListQuery, VulnerabilityListQueryVariables>(VulnerabilityListDocument, options);
        }
export function useVulnerabilityListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VulnerabilityListQuery, VulnerabilityListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VulnerabilityListQuery, VulnerabilityListQueryVariables>(VulnerabilityListDocument, options);
        }
export type VulnerabilityListQueryHookResult = ReturnType<typeof useVulnerabilityListQuery>;
export type VulnerabilityListLazyQueryHookResult = ReturnType<typeof useVulnerabilityListLazyQuery>;
export type VulnerabilityListSuspenseQueryHookResult = ReturnType<typeof useVulnerabilityListSuspenseQuery>;
export type VulnerabilityListQueryResult = Apollo.QueryResult<VulnerabilityListQuery, VulnerabilityListQueryVariables>;
export const SelectVulnerabilityDocument = gql`
    query SelectVulnerability($first: Int, $after: String, $identifier: String, $title: String, $order: VulnerabilityFilter_order) {
  vulnerabilities(
    first: $first
    after: $after
    identifier: $identifier
    title: $title
    order: [$order]
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...vulnerabilityFields
      }
    }
  }
}
    ${VulnerabilityFieldsFragmentDoc}`;

/**
 * __useSelectVulnerabilityQuery__
 *
 * To run a query within a React component, call `useSelectVulnerabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectVulnerabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectVulnerabilityQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      identifier: // value for 'identifier'
 *      title: // value for 'title'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSelectVulnerabilityQuery(baseOptions?: Apollo.QueryHookOptions<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>(SelectVulnerabilityDocument, options);
      }
export function useSelectVulnerabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>(SelectVulnerabilityDocument, options);
        }
export function useSelectVulnerabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>(SelectVulnerabilityDocument, options);
        }
export type SelectVulnerabilityQueryHookResult = ReturnType<typeof useSelectVulnerabilityQuery>;
export type SelectVulnerabilityLazyQueryHookResult = ReturnType<typeof useSelectVulnerabilityLazyQuery>;
export type SelectVulnerabilitySuspenseQueryHookResult = ReturnType<typeof useSelectVulnerabilitySuspenseQuery>;
export type SelectVulnerabilityQueryResult = Apollo.QueryResult<SelectVulnerabilityQuery, SelectVulnerabilityQueryVariables>;
export const VulnerabilityDocument = gql`
    query Vulnerability($vulnerabilityId: ID!) {
  vulnerability(id: $vulnerabilityId) {
    ...vulnerabilityFields
  }
}
    ${VulnerabilityFieldsFragmentDoc}`;

/**
 * __useVulnerabilityQuery__
 *
 * To run a query within a React component, call `useVulnerabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useVulnerabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVulnerabilityQuery({
 *   variables: {
 *      vulnerabilityId: // value for 'vulnerabilityId'
 *   },
 * });
 */
export function useVulnerabilityQuery(baseOptions: Apollo.QueryHookOptions<VulnerabilityQuery, VulnerabilityQueryVariables> & ({ variables: VulnerabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VulnerabilityQuery, VulnerabilityQueryVariables>(VulnerabilityDocument, options);
      }
export function useVulnerabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VulnerabilityQuery, VulnerabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VulnerabilityQuery, VulnerabilityQueryVariables>(VulnerabilityDocument, options);
        }
export function useVulnerabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VulnerabilityQuery, VulnerabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VulnerabilityQuery, VulnerabilityQueryVariables>(VulnerabilityDocument, options);
        }
export type VulnerabilityQueryHookResult = ReturnType<typeof useVulnerabilityQuery>;
export type VulnerabilityLazyQueryHookResult = ReturnType<typeof useVulnerabilityLazyQuery>;
export type VulnerabilitySuspenseQueryHookResult = ReturnType<typeof useVulnerabilitySuspenseQuery>;
export type VulnerabilityQueryResult = Apollo.QueryResult<VulnerabilityQuery, VulnerabilityQueryVariables>;